import * as i2$1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Component, PLATFORM_ID, Inject, EventEmitter, Optional, InjectionToken, Output, Input, NgModule, ViewChild, isDevMode } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i4 from '@angular/router';
import { Router, NavigationStart, NavigationError, NavigationEnd, RouterModule, GuardsCheckEnd } from '@angular/router';
import * as i2$2 from '@citi-gcg-173875/citi-analytics';
import { SiteCatalystService } from '@citi-gcg-173875/citi-analytics';
import * as i3 from '@citi-gcg-173875/citi-branding';
import { Layouts, CitiRouteDetector, CitiBrandingModule } from '@citi-gcg-173875/citi-branding';
import { CoreServicesModule, CoreCommonModule } from '@citi-gcg-173875/citi-common-modules';
import * as i7 from '@citi-gcg-173875/citi-common-ui-cds';
import { CdsCoreModule, CdsJampModule, CdsPageDotsModule, CdsCTAModule, CdsModalDialogModule, CdsButtonModule, CdsIconModule, CdsTourModule, CdsPopup2Module, CdsTextHeaderModule, CdsDropdownModule, CdsFormsModule, CdsGridModule } from '@citi-gcg-173875/citi-common-ui-cds';
import * as i4$1 from '@citi-gcg-173875/citi-security';
import { AuthorizationService, CitiSecurityModule, E2eService, DeepdropService, TMXService } from '@citi-gcg-173875/citi-security';
import * as i1 from '@citi-gcg-173875/citi-utils';
import { WINDOW, StorageService, IS_SSRENDERED_APP, Modal, CitiAppConfig, Dropdown2, SessionService, AppConfigService, PostSessionService, CookieService, EcmCookieService, ScriptLoadService, WINDOW_PROVIDER, NAVIGATOR_PROVIDER } from '@citi-gcg-173875/citi-utils';
import { provideNgxWebstorage, withNgxWebstorageConfig, withLocalStorage, withSessionStorage } from 'ngx-webstorage';
import * as i2 from '@citi-gcg-173875/citi-http';
import { throwError, BehaviorSubject, combineLatest, of, timer, interval, catchError as catchError$1, firstValueFrom, map as map$1 } from 'rxjs';
import { catchError, filter, map, finalize } from 'rxjs/operators';
import * as i4$2 from '@angular/platform-browser';
import { Cookie } from 'ng2-cookies';
import * as i1$1 from '@angular/common';
import { isPlatformBrowser, DOCUMENT, isPlatformServer, CommonModule } from '@angular/common';
import * as i6 from '@citi-gcg-173875/nga-login-service-shared';
import { NgaLoginServiceModule, NGALoginService } from '@citi-gcg-173875/nga-login-service-shared';
import * as i5 from '@citi-gcg-173875/citi-deepdrop-rei';
import { DeepDropAssistedChannelModule, AssistedChannelDataShareService } from '@citi-gcg-173875/citi-deepdrop-rei';
import { Cookie as Cookie$1 } from 'ng2-cookies/ng2-cookies';
import * as i4$3 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';

class NonFatalErrorService {
    constructor(appConfigService, _cs, _storageService) {
        this.appConfigService = appConfigService;
        this._cs = _cs;
        this._storageService = _storageService;
        this.errorCustomConfig = this.appConfigService.getConfig('nonFatalErrorConfig');
    }
    getErrorMessage(errorContentId) {
        let language = this._storageService.get('locale');
        if (language == null || language === '') {
            language = 'en_US';
        }
        this.appConfigService.setLocale(language);
        this._storageService.delete('isLegacyError');
        return this._cs.makeApiCall('USCBOL', 'copy', errorContentId);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NonFatalErrorService, deps: [{ token: i1.AppConfigService }, { token: i2.ContentService }, { token: i1.StorageService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NonFatalErrorService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NonFatalErrorService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.AppConfigService }, { type: i2.ContentService }, { type: i1.StorageService }] });

class NonFatalErrorComponent {
    constructor(angularErrorPageService, route, _cs) {
        this.angularErrorPageService = angularErrorPageService;
        this.route = route;
        this._cs = _cs;
    }
    getErrorMessageContent(errorContentId) {
        this.angularErrorPageService
            .getErrorMessage(errorContentId)
            .pipe(catchError((err) => {
            return throwError(err);
        }))
            .subscribe(response => {
            this.contentData = JSON.parse(response.TEXT);
            // this.errorCategory = this.errorContentConfig[errorType];
            // this.contentData=(this._cs.get('USCBOL', 'copy', this.errorCategory, 'TEXT'));
        });
    }
    ngOnInit() {
        this.subscription = this.route.queryParams.subscribe((queryParam) => {
            if (queryParam['errorCode'] != null) {
                this.errorType = queryParam['errorCode'];
            }
            else {
                this.errorType = 'default';
            }
        });
        this.getErrorMessageContent(this.errorType);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NonFatalErrorComponent, deps: [{ token: NonFatalErrorService }, { token: i4.ActivatedRoute }, { token: i2.ContentService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: NonFatalErrorComponent, isStandalone: false, selector: "ng-component", providers: [NonFatalErrorService], ngImport: i0, template: "<citi-simple-layout brandingType=\"servicing\">\n</citi-simple-layout>\n", styles: [":host ::ng-deep h2,:host ::ng-deep .nonFatalErrorMessage{margin-bottom:20px}:host ::ng-deep a.btn-primary{display:block;min-width:240px;padding-left:10px}:host-context(.citi-container.cbolui-ddl){margin:0!important;padding-left:0;min-height:100px}@media only screen and (max-width: 1024px){:host ::ng-deep h2,:host ::ng-deep .nonFatalErrorMessage{margin-bottom:10px}:host ::ng-deep a.btn-primary{margin-top:10px;margin-right:0}:host ::ng-deep h2,:host ::ng-deep .nonFatalErrorMessage,:host ::ng-deep a.btn-primary{margin-left:0}:host ::ng-deep h2{margin-top:-20px;word-wrap:break-word}}@media only screen and (min-width: 1370px){:host ::ng-deep h2,:host ::ng-deep .nonFatalErrorMessage,:host ::ng-deep a.btn-primary{margin-left:-40px}:host ::ng-deep a.btn-primary{display:block;min-width:280px;padding-left:10px}}\n"], dependencies: [{ kind: "component", type: i3.SimpleLayoutComponent, selector: "citi-simple-layout", inputs: ["theme", "endpoint", "responsive", "width", "singleBreakpoint", "cdsThemeEnabled", "pageId", "servicingType", "brandingType", "loading", "prelogin", "locale", "fullbleed", "waitMessage", "readyMessage"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NonFatalErrorComponent, decorators: [{
            type: Component,
            args: [{ standalone: false, providers: [NonFatalErrorService], template: "<citi-simple-layout brandingType=\"servicing\">\n</citi-simple-layout>\n", styles: [":host ::ng-deep h2,:host ::ng-deep .nonFatalErrorMessage{margin-bottom:20px}:host ::ng-deep a.btn-primary{display:block;min-width:240px;padding-left:10px}:host-context(.citi-container.cbolui-ddl){margin:0!important;padding-left:0;min-height:100px}@media only screen and (max-width: 1024px){:host ::ng-deep h2,:host ::ng-deep .nonFatalErrorMessage{margin-bottom:10px}:host ::ng-deep a.btn-primary{margin-top:10px;margin-right:0}:host ::ng-deep h2,:host ::ng-deep .nonFatalErrorMessage,:host ::ng-deep a.btn-primary{margin-left:0}:host ::ng-deep h2{margin-top:-20px;word-wrap:break-word}}@media only screen and (min-width: 1370px){:host ::ng-deep h2,:host ::ng-deep .nonFatalErrorMessage,:host ::ng-deep a.btn-primary{margin-left:-40px}:host ::ng-deep a.btn-primary{display:block;min-width:280px;padding-left:10px}}\n"] }]
        }], ctorParameters: () => [{ type: NonFatalErrorService }, { type: i4.ActivatedRoute }, { type: i2.ContentService }] });

class RoutingDetectorConfig {
    static { this.interceptorList = ['CbolRouteDummyInterceptorService']; }
}

class CbolCoreConfig {
    static { this.cbolFeatureConfig = {
        '': {
            isCoexistenceRequired: 'N',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'N'
        },
        'ng-test': {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        unauthorized: {
            isCoexistenceRequired: 'N',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        servicing: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        'citibank-location-finder': {
            isCoexistenceRequired: 'N',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        ContactInfo: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        paperless: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        statements: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        creditlineincrease: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        'forgot-userid-pwd': {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        debcaract: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        repcard: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        contactus: {
            isCoexistenceRequired: 'N',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        lending: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        CDAccount: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        mortgage: {
            isCoexistenceRequired: 'N',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'N'
        },
        hlofinder: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        alerts: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        sow: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        apptsched: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        mrc: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        pinreset: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        paypal: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        'open-a-bank-account': {
            isCoexistenceRequired: 'N',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        apptsetting: {
            isCoexistenceRequired: 'N',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        badaccounts: {
            isCoexistenceRequired: 'N',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        kyc: {
            isCoexistenceRequired: 'Y',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'Y'
        },
        'small-business-banking': {
            isCoexistenceRequired: 'N',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'N'
        },
        homepage: {
            isCoexistenceRequired: 'N',
            handleCoexistenceError: 'N',
            gemfirePushNeeded: 'N'
        }
    }; }
    static { this.cbolTypedFeatureConfig = [
        {
            route: '',
            isCoexistenceRequired: false,
            handleCoexistenceError: false,
            gemfirePushNeeded: false
        },
        {
            route: 'ng-test',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'homepage',
            isCoexistenceRequired: false,
            handleCoexistenceError: false,
            gemfirePushNeeded: false
        },
        {
            route: 'unauthorized',
            isCoexistenceRequired: false,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'servicing',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'citibank-location-finder',
            isCoexistenceRequired: false,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'ContactInfo',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'paperless',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'statements',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'creditlineincrease',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'forgot-userid-pwd',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'debcaract',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'repcard',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'contactus',
            isCoexistenceRequired: false,
            handleCoexistenceError: false,
            gemfirePushNeeded: true,
            preLogin: true
        },
        {
            route: 'lending',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'CDAccount',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'mortgage',
            isCoexistenceRequired: false,
            handleCoexistenceError: false,
            gemfirePushNeeded: false
        },
        {
            route: 'hlofinder',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'alerts',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'sow',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'apptsched',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'mrc',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'pinreset',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'paypal',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'open-a-bank-account',
            isCoexistenceRequired: false,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'apptsetting',
            isCoexistenceRequired: false,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'badaccounts',
            isCoexistenceRequired: false,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        },
        {
            route: 'kyc',
            isCoexistenceRequired: true,
            handleCoexistenceError: false,
            gemfirePushNeeded: true
        }
    ]; }
}

class CbolCoreRedirectService {
    constructor() {
        this.branding$ = new BehaviorSubject(null);
        this.keepalive$ = new BehaviorSubject(null);
        this.redirectUrl$ = new BehaviorSubject(null);
    }
    setBrandingResult(res) {
        this.branding$.next(res);
    }
    setKeepaliveResult(res) {
        this.keepalive$.next(res);
    }
    setEventValue(value) {
        this.redirectUrl$.next(value);
    }
    onAllReady() {
        return combineLatest([
            this.branding$,
            this.keepalive$,
            this.redirectUrl$
        ]).pipe(filter(([api1, api2, eventVal]) => api1 !== null && api2 !== null && eventVal !== null));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreRedirectService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreRedirectService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreRedirectService, decorators: [{
            type: Injectable
        }] });

const configUrl = '/config';
class CbolCoreConfigService {
    constructor(injector, postSessionService, http, appConfigService, cookieService, layoutService, _window, _document, _platformId, route, authService, modFedRouteGuard, ngaLoginService, cdsThemingService, cbolCoreRedirectService) {
        this.injector = injector;
        this.postSessionService = postSessionService;
        this.http = http;
        this.appConfigService = appConfigService;
        this.cookieService = cookieService;
        this.layoutService = layoutService;
        this._window = _window;
        this._document = _document;
        this._platformId = _platformId;
        this.route = route;
        this.authService = authService;
        this.modFedRouteGuard = modFedRouteGuard;
        this.ngaLoginService = ngaLoginService;
        this.cdsThemingService = cdsThemingService;
        this.cbolCoreRedirectService = cbolCoreRedirectService;
        this._cbolFeatureConfig = CbolCoreConfig.cbolTypedFeatureConfig;
        this.sessionPostBrandingStorageSubject = new BehaviorSubject(null);
        this.browserConfigServiceEndpoint = '/digital/customerEntitlement/browser/branding';
        this.httpCookiePackage = [
            'appVersion',
            'businessCode',
            'channelId',
            'client_id',
            'countryCode',
            'apimBaseUrl'
        ];
        this.activityFlag = false;
        this._router = this.injector.get(Router);
        this._router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe(event => {
            //console.log('Accessed Route', event['url']);
            this.accessedRoute = event['url'].split("/")[2] ?
                (event['url'].split("/")[1] + "-" + event['url'].split("/")[2]).toUpperCase() :
                new URLSearchParams((event['url'])?.split("?")[1])?.get('routeId')?.split('?')[0];
        });
        this._router.events.subscribe((event) => {
            if (event instanceof NavigationError) {
                this.redirectError(event);
            }
        });
        this.modFedRedirection();
        this.authService
            .getSessionObservable()
            .pipe(filter(sessionIdentifer => !!sessionIdentifer))
            .subscribe((sessionIdentifier) => {
            if (this.sessionIdentifier === sessionIdentifier) {
                console.log('sessionIdentifier already exist, no need to make multiple branding calls. -------> ', this.sessionIdentifier);
                return;
            }
            if (!this.activityFlag) {
                this.activityFlag = true;
                this.sessionIdentifier = sessionIdentifier;
                this.load();
            }
            else {
                this.load().then(val => {
                    this.emitSessionPost(this.sessionPost);
                });
            }
        });
        this.ngaLoginService.cbolConfigLoad.subscribe({
            next: (event) => {
                console.log('Cbol Profile Service API call');
                this.load();
            }
        });
        this.authService.getPartnerId.subscribe((partnerId) => {
            if (partnerId) {
                this.initCdsTheming(partnerId);
            }
        });
    }
    modFedRedirection() {
        this.modFedRouteGuard.modFedRedirect.subscribe(val => {
            this.redirect = val;
            this.cbolCoreRedirectService.setEventValue(this.redirect);
            (!Cookie.get('isLoggedIn') && this.redirect) ? this.sendToDestinationApp(this.redirect) : '';
        });
        this.cbolCoreRedirectService.onAllReady().subscribe(([res1, res2, eventVal]) => {
            eventVal ? this.sendToDestinationApp(eventVal) : '';
        });
    }
    sendToDestinationApp(destinationUrl) {
        this._window ? this._window.location.assign(destinationUrl) : '';
        return false;
    }
    redirectError(event) {
        if (this._window && this._window.location.href.includes("/US/nga/")) {
            let path = this._window.location.href.split("/US/nga/"); // ["http://online.citi.com", "your-route"]
            this._window ? this._window.location.assign(path[0] + "/US/ag" + event.url) : '';
        }
    }
    /*
    load() must continue to return a Promise to preserve backwards-compatiblity until further notice
    Can still control the implementation under the hood, swapping out the appropriate SPBS calls and working with Observables until we return
    */
    load(queryParam) {
        this.currentRoute = this._window ? this._window.location.pathname : '';
        console.log("currentRoute -->", this.currentRoute);
        let channelID = this.cookieService.getCookie('channelId');
        let sessionCID = (isPlatformBrowser(this._platformId)) ? sessionStorage.getItem('channelID') : null;
        console.log('Session CID', sessionCID);
        console.log('Cookie CID', channelID);
        // * Start Route Suppression Check (redirect customer to dashboard on blacklisted route access)
        if (isPlatformBrowser(this._platformId)) {
            // * Subscribe to the session observable to check for sbps data
            this.sbpsSubject = this.getSessionPostObservable().subscribe(data => {
                if (sessionStorage.getItem('sessionPostBrandingStorage')) {
                    // * FeatureFlags (spbs) are available. Proceed with Limited Access check
                    this.authService.shouldSuppressLoad(this.currentRoute).subscribe((shouldSuppressRoute) => {
                        if (shouldSuppressRoute) {
                            console.log('Blacklisted Route Access Detected. Redirecting to Dashboard...');
                            this._window.location.href = '/US/ag/parent-interstitial';
                            return;
                        }
                        // * Limited Access check complete. Sbps check is no longer needed
                        this.sbpsSubject ? this.sbpsSubject.unsubscribe() : '';
                    });
                }
            });
        }
        if (!(channelID == 'SFRTL' || channelID == 'ECLIPSE' || sessionCID == 'SFRTL' || sessionCID == 'ECLIPSE')) {
            if (!!this.sessionIdentifier && this.currentRoute.indexOf('/sign-off') == -1) {
                switch (this.sessionIdentifier) {
                    case AuthorizationService.NGA:
                        if ((this.appConfigService.getTenantId() == 'CBOL' || this.appConfigService.getTenantId() == 'amazon' || this.appConfigService.getTenantId() == 'DRAGONFLY' || this.appConfigService.getTenantId() == 'mortgage' || this.appConfigService.getTenantId() == 'INTERNET' || this.appConfigService.getPartnerId() != null) &&
                            (!this.browserConfigSubscription ||
                                !!this.browserConfigSubscription.closed)) {
                            if (queryParam)
                                this.makeNGAConfigCall(this.browserConfigServiceEndpoint + '?' + queryParam);
                            else
                                this.makeNGAConfigCall();
                            return Promise.resolve(true);
                        }
                        return Promise.resolve(false);
                    default:
                        return this.makeLegacyConfigCall().toPromise();
                }
            }
        }
        else {
            this.establishCookiePackage();
        }
    }
    refreshLoad() {
        return this.http
            .get(this.browserConfigServiceEndpoint, {
            params: {
                entitlementRefresh: true
            }
        })
            .pipe(map((res) => {
            this.extractSessionPostData(res);
            this.establishCookiePackage();
            return true;
        }), catchError((err) => {
            const paramMap = {
                tenantId: this.route.snapshot.url,
                errorPage: 'Y'
            };
            this._router.navigate(['/sign-off'], { queryParams: paramMap });
            return throwError(err);
        }));
    }
    makeNGAConfigCall(bcsEndpoint = this.browserConfigServiceEndpoint) {
        this.browserConfigSubscription = this.http
            .get(bcsEndpoint)
            .pipe(map((res) => {
            this.extractSessionPostData(res);
            this.establishCookiePackage();
            this.cbolCoreRedirectService.setBrandingResult('branding');
            return Promise.resolve(true);
        }), catchError((err) => {
            const paramMap = {
                tenantId: this.route.snapshot.url,
                routeId: this.accessedRoute,
                errorCase: 'branding'
            };
            this._router.navigate(['/sign-off'], { queryParams: paramMap });
            return Promise.resolve(false);
        }), finalize(() => this.browserConfigSubscription.unsubscribe()))
            .subscribe();
    }
    /**
     * Determines whether legacy configuration call is needed.
     * If call is needed, will make the network call that returns SessionPostBrandingStorage and, when call is successful, will set ECMCookie
     */
    makeLegacyConfigCall() {
        this.ngaCoexistenceEndpoint = !!this.appConfigService.getConfig('customConfig').ngaCoexistenceEndpoint
            ? this.appConfigService.getConfig('customConfig').ngaCoexistenceEndpoint
            : '';
        //TODO: should we make use of the storage service for grabbing cookies, or just grab them directly using JS Cookie.get() syntax?
        let isCookie = this.cookieService.getCookie('NGACoExistenceCookie') ||
            Cookie.get('NGACoExistenceCookie');
        let isMember = this.postSessionService.getItem('isMember');
        let currentUrl;
        let routeName;
        let keyInConfig;
        this.ngaCoexistenceEndpoint = this.appConfigService.getConfig('customConfig').ngaCoexistenceEndpoint;
        if (typeof this.ngaCoexistenceEndpoint != 'undefined') {
            this.ngaCoexistenceEndpoint = this.ngaCoexistenceEndpoint;
        }
        else {
            this.ngaCoexistenceEndpoint = '';
        }
        console.log('ngaCoexistenceEndpoint....' + this.ngaCoexistenceEndpoint);
        //TODO: can we change this damn url reference to utilize the angular router?
        currentUrl = this._window ? this._window.location.pathname : '';
        if (currentUrl.match('US/ag')) {
            routeName = currentUrl.split('/')[3];
        }
        else {
            routeName = currentUrl.split('/')[1];
        }
        keyInConfig = this.getConfigForKey(routeName);
        this.determineGemfireCall(keyInConfig);
        console.log(`currentUrl: '${currentUrl}'`);
        console.log(`routeName: '${routeName}'`);
        // TODO: Find out if below method needs to used instead
        // this.determineGemfireCall(keyInConfig);
        try {
            this.gemfirePushNeeded = !!(keyInConfig && keyInConfig.gemfirePushNeeded)
                ? keyInConfig.gemfirePushNeeded
                : true;
        }
        catch (e) {
            console.log(e);
            this.gemfirePushNeeded = true;
        }
        console.log(`keyInConfig--> + ${keyInConfig}
                gemfirePushNeeded--> ${this.gemfirePushNeeded}`);
        let isNgaCallRequired = this.checkForNgaCall(keyInConfig, isCookie);
        console.log(`ngaCallRequired? ${isNgaCallRequired}`);
        console.log(`coexistenceEndpoint: ${this.ngaCoexistenceEndpoint}`);
        if (isNgaCallRequired &&
            this.ngaCoexistenceEndpoint != '' &&
            this._window) {
            return this.makeNGACall(keyInConfig);
            // .then(data => {
            //   console.log('Set Session Storage ' + data);
            //   if (this._window)
            //     this._window.sessionStorage.setItem(
            //       'sessionPostBrandingStorage',
            //       JSON.stringify(data)
            //     );
            //   return Promise.resolve(true);
            // })
            // .catch(err => {
            //   console.log(' NGA call Error----->' + err);
            //   this.handlePostBrandingError(keyInConfig, currentUrl);
            //   return Promise.resolve(true);
            // });
        }
        else {
            console.log('NGA call is not done since cookie is not required or ngaCoexistenceEndpoint is not defined in environment file ');
            return of(true);
        }
    }
    determineGemfireCall(keyInConfig) {
        if (!!keyInConfig) {
            this.gemfirePushNeeded = keyInConfig.gemfirePushNeeded;
        }
        else {
            this.gemfirePushNeeded = false;
        }
    }
    /**
     * Returns the BehaviorSubject that will eventually next SessionPostBrandingStorage to anyone listening
     */
    getSessionPostObservable() {
        return this.sessionPostBrandingStorageSubject.asObservable();
    }
    getSessionPostSubject() {
        return this.sessionPostBrandingStorageSubject;
    }
    /**
     * Returns Observable of legacy .jws call that eventually completes to return SessionPostBrandingStorage object
     * @param keyInConfig - the key associated with the current route, if defined in cbol-core.config.ts
     */
    makeNGACall(keyInConfig) {
        let requestBody = {
            coexistenceNeeded: this.isCoexistenceRequired,
            gemfirePushNeeded: this.gemfirePushNeeded
        };
        console.log('make NGA call');
        if (this._window) {
            const coexistenceDomain = this.appConfigService.getEnvironment() == 'DEV'
                ? 'http://localhost:7878'
                : this._window.location.origin;
            return this.http
                .post(coexistenceDomain + this.ngaCoexistenceEndpoint, requestBody)
                .pipe(map((res) => {
                return this.extractSessionPostData(res);
            }), catchError(err => {
                if (!!this.authService.getSessionType()) {
                    console.log(' NGA call Error handling on valid session----->' + err);
                    return this.handlePostBrandingError(keyInConfig);
                }
                else {
                    return of(true);
                }
            }));
        }
    }
    establishCookiePackage() {
        const cookieObj = {};
        const cookieConfig = this.appConfigService.getHttpServiceConfig()
            .defaultHeaders;
        this.httpCookiePackage.forEach(val => {
            if (val == 'apimBaseUrl') {
                Object.assign(cookieObj, {
                    [val]: this.appConfigService.getApiServerUrl()
                });
                this._document.cookie = `apimBaseUrl=${this.appConfigService.getApiServerUrl()}; domain=citi.com; path=/`;
            }
            else {
                Object.assign(cookieObj, { [val]: cookieConfig[val] });
                Cookie.set(val, cookieObj[val], undefined, '/', this.areOnCitiDomain() ? 'citi.com' : undefined);
            }
        });
        return cookieObj;
    }
    areOnCitiDomain() {
        return this._window.location.hostname.indexOf('citi.com') > -1
            ? true
            : false;
    }
    /**
     * Wraps convenience methods for extracting/processing the SessionPostBrandingStorage object
     * @param response - the SessionPostBrandingStorage object
     */
    extractSessionPostData(response) {
        try {
            this.setSessionPost(response);
            this.setECMCookie();
            this.setQRsignonCookie();
            this.setSPPBCookie();
            this.setPartnerId();
            this.initCdsTheming();
            this.canActivateReload();
            //this.setccsidCookie();
            return true;
        }
        catch (e) {
            console.log('unable to set spbs|| ECM');
        }
    }
    /**
     * Takes in sessionPostBrandingStorage object and sets it in SessionStorage
     * @param response
     */
    setSessionPost(sessionPost) {
        try {
            window.sessionStorage.setItem('sessionPostBrandingStorage', JSON.stringify(sessionPost));
            this.sessionPost = sessionPost;
            this.emitSessionPost(this.sessionPost);
            this.layoutService.postBrandingStorage.next(true);
            return true;
        }
        catch (e) {
            throw new Error('unable to set session post branding storage');
        }
    }
    emitSessionPost(sessionPost) {
        this.sessionPostBrandingStorageSubject.next(sessionPost);
    }
    //set ccid_ccsid cookie
    //commenting for now because of prod issue.
    // private setccsidCookie() {
    //   let sessionPostBrandingStorage =
    //     sessionStorage['sessionPostBrandingStorage'] ||
    //     localStorage['sessionPostBrandingStorage'] ||
    //     null;
    //     if (sessionPostBrandingStorage) {
    //       if (sessionPostBrandingStorage.includes('ccid_ccsid')){
    //         let sessionData = JSON.parse(sessionStorage.getItem('sessionPostBrandingStorage'));
    //         const spbs = sessionData.ccid_ccsid;
    //         this.setCookie("ccid_ccsid",spbs, 180);
    //     }
    //       } else {
    //       throw new Error('unable to set ccid_ccsid');
    //     }
    // }
    //   setCookie(cname, cvalue, exdays) {
    //     var Db = [];
    //     var d = new Date();
    //     var domain = '.citi.com'; // setting domain as a var
    //     d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    //     Db.push(cname, "\x3d", cvalue);
    //     Db.push("; expires\x3d", d.toUTCString());
    //     Db.push("; path\x3d/");
    //     Db.push("; domain\x3d", domain); // updating domain var in cookie value
    //     //document.cookie = cookieName +"=" + cookieValue + ";expires=" + myDate + ";domain=.example.com;path=/"
    //     this._document.cookie = Db.join("");
    //     console.log('ccsid cookie created...');
    // }
    /**
     * Retrieves the ecmvalue property of SessionPostBrandingStorage from SessionStorage, and sets the CBOLECM cookie
     */
    setECMCookie() {
        let sessionPostBrandingStorage = sessionStorage['sessionPostBrandingStorage'] ||
            localStorage['sessionPostBrandingStorage'] ||
            null;
        if (sessionPostBrandingStorage) {
            const maxAge = 60 * 60 * 24 * 365; // set one year in seconds
            const path = '/';
            const domain = '.citi.com';
            sessionPostBrandingStorage = JSON.parse(sessionPostBrandingStorage);
            this._document.cookie = `CBOLECM=${sessionPostBrandingStorage.ecmvalue}; Domain=${domain}; Max-Age=${maxAge}; Path=${path}`;
            // Cookie.set("CBOLECM", sessionPostBrandingStorage.ecmvalue);
        }
        else {
            throw new Error('unable to set ECM; no spbs found');
        }
    }
    /**
     * Retrieves the ecmvalue property of SessionPostBrandingStorage from SessionStorage, and sets the SPPB cookie
     */
    setSPPBCookie() {
        let sessionPostBrandingStorage = sessionStorage['sessionPostBrandingStorage'] ||
            localStorage['sessionPostBrandingStorage'] ||
            null;
        if (sessionPostBrandingStorage) {
            const maxAge = 60 * 60 * 24 * 365; // set one year in seconds
            const path = '/';
            const domain = '.citi.com';
            sessionPostBrandingStorage = JSON.parse(sessionPostBrandingStorage);
            this._document.cookie = `SPPBECM=${sessionPostBrandingStorage.sppbValue}; Domain=${domain}; Max-Age=${maxAge}; Path=${path}`;
        }
        else {
            throw new Error('unable to set SPPB; no sessionPostBrandingStorage found');
        }
    }
    setPartnerId() {
        if (this._document.cookie.indexOf('partnerId') == -1) {
            this._router.events
                .pipe(filter(event => {
                return event instanceof NavigationEnd;
            }))
                .subscribe((event) => {
                console.log('detect from cbol-core!', event.urlAfterRedirects);
                let url = event.urlAfterRedirects;
                let cookieVal = '';
                if (this._window) {
                    if (url.includes('partnerId')) {
                        cookieVal = url.substring(1).replace(/\//g, '_').split('?')[1].split('=')[1];
                        const maxAge = 60 * 60 * 24 * 365; // set one year in seconds
                        const path = '/';
                        const domain = '.citigroup.net';
                        this._document.cookie = `partnerId=${cookieVal}; Domain=${domain}; Max-Age=${maxAge}; Path=${path}`;
                        this.appConfigService.setPartnerId(cookieVal);
                    }
                }
                console.log('cookie value', cookieVal);
            });
        }
        else {
            console.log('unable to set parentId');
            // throw new Error('unable to set parentId');
        }
    }
    // Sets 'qrsign' cookie if 'ff_enableQRCode' feature flag is True
    setQRsignonCookie() {
        try {
            this.spbs = JSON.parse(sessionStorage['sessionPostBrandingStorage']);
            let featureFlags = this.spbs?.featureFlags;
            let deleteQrSinonCookie = true;
            let deleteQrLiteLoginCookie = true;
            if (featureFlags?.ff_enableQRCode === "Y") {
                console.log("set qrsignon cookie");
                deleteQrSinonCookie = false;
                Cookie.set('qrsignon', 'true', 365, '/', '.citi.com');
            }
            if (featureFlags?.ff_enableQrLite === "Y") {
                console.log("set qrlitelogin cookie");
                deleteQrLiteLoginCookie = false;
                Cookie.set('qrlitelogin', 'true', 365, '/', '.citi.com');
            }
            if (deleteQrSinonCookie) {
                console.log('delete qrsignon cookie...');
                Cookie.delete('qrsignon');
            }
            if (deleteQrLiteLoginCookie) {
                console.log('delete qrlitelogin cookie...');
                Cookie.delete('qrlitelogin');
            }
        }
        catch (err) {
            console.error('Error retrieving Feature Flags: ', err);
        }
    }
    /*
      initiateEUMAppConfig() {
          const eumAppKey: string = this.appConfigService.getEUMAppConfig().appKey;
          const adrumScriptUrl =  this.appConfigService.getEUMAppConfig().cdnUrl;
          const adrumExtUrlHttp = this.appConfigService.getEUMAppConfig().adrumExtUrlHttp;
          const adrumExtUrlHttps =  this.appConfigService.getEUMAppConfig().adrumExtUrlHttps;
          /*
           const adrumScriptUrl = 'cbol-core-assets/' + this.appConfigService.getEUMAppConfig().cdnUrl;
          const adrumExtUrlHttp = 'cbol-core-assets/' + this.appConfigService.getEUMAppConfig().adrumExtUrlHttp;
          const adrumExtUrlHttps = 'cbol-core-assets/' + this.appConfigService.getEUMAppConfig().adrumExtUrlHttps;
          */
    /*    window['adrum-start-time'] = new Date().getTime();
        window['adrum-config'] = {
                  'appKey': eumAppKey,
                     'isZonePromise': this.appConfigService.getEUMAppConfig().isZonePromise,
                      'adrumExtUrlHttp': adrumExtUrlHttp,
                      'adrumExtUrlHttps': adrumExtUrlHttps,
                      'beaconUrlHttp': this.appConfigService.getEUMAppConfig().beaconUrlHttp,
                      'beaconUrlHttps': this.appConfigService.getEUMAppConfig().beaconUrlHttps,
                      'xd': this.appConfigService.getEUMAppConfig().xd
                       };
             //         const var1 =  this.loadEUMConfigScript(adrumScriptUrl);
                       this.loadEUMConfigScript(adrumScriptUrl).onload = () => {
                                   console.log('EUM Script loaded', window['adrum-config']);
                       };
           }
  
    loadEUMConfigScript(src: string): HTMLScriptElement {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      script.setAttribute('src', src);
      script.setAttribute('id', 'adrum');
      //script.setAttribute('async', 'true');
      this._document.getElementsByTagName('head')[0].appendChild(script);
      return script;
    }
  */
    handlePostBrandingError(keyInConfig, currentUrl) {
        this.errorUrl = this.appConfigService.getConfig('customConfig').errorUrl;
        if (typeof keyInConfig != 'undefined') {
            if (keyInConfig.handleCoexistenceError == 'Y' &&
                typeof this.errorUrl != 'undefined' &&
                this.errorUrl != '') {
                if (this._window)
                    this._window.location.href = this.errorUrl;
            }
            else {
                console.log('No error Redirection done---->Handle Error:' +
                    keyInConfig.handleCoexistenceError +
                    ',Error URL:' +
                    this.errorUrl);
                return Promise.resolve(true);
            }
        }
        else {
            console.log('No error Redirection done as config is not available');
            return Promise.resolve(true);
        }
    }
    getConfigForKey(key) {
        for (let i = 0; i < this._cbolFeatureConfig.length; i++) {
            let config = this._cbolFeatureConfig[i];
            if (config.route == key) {
                return config;
            }
        }
        return null;
    }
    checkForNgaCall(keyInConfig, isCookie) {
        if (!keyInConfig) {
            // check if the route has been defined in cbol-core-config
            console.log('key is not defined in the config');
            if (isCookie) {
                // is NGACoexistenceCookie already present?
                this.isCoexistenceRequired = false; // if yes, no need for a coexistence call
                return true;
            }
            else {
                this.isCoexistenceRequired = true; // if no, need a coexistence call
                return true;
            }
        }
        // if (typeof (keyInConfig) != 'undefined') {
        if (keyInConfig.isCoexistenceRequired && !isCookie) {
            this.isCoexistenceRequired = false;
            console.log("NGA Cookie is not available and it's not required as per config");
            return false;
        }
        else if (!!keyInConfig.isCoexistenceRequired && !isCookie) {
            console.log("NGA Cookie is not available and  it's required as per config ");
            this.isCoexistenceRequired = true;
            return true;
        }
        else if (!!keyInConfig.isCoexistenceRequired && isCookie) {
            //TODO: investigate whether it is fine to remove this OR condition from original logic
            // || keyInConfig.isCoexistenceRequired == 'N' && isCookie)
            console.log('NGA Cookie is  available and  not required .  ');
            this.isCoexistenceRequired = false;
            return true;
        }
        return false;
    }
    // Initializes CDS Theme
    initCdsTheming(partnerId) {
        let featureFlags = this.spbs?.featureFlags;
        if ((featureFlags?.ff_cdsTheming && featureFlags?.ff_cdsTheming === "Y") || partnerId != undefined) {
            console.log("User eligble for CDS Theming...");
            this.cdsThemingService.initCdsTheme(partnerId);
        }
    }
    canActivateReload() {
        let routeToReload = sessionStorage.getItem("routeReloadState");
        let urlObj = new URL(routeToReload, window.location.origin);
        urlObj.searchParams.set('reload', 'true');
        let updatedUrl = urlObj.pathname + urlObj.search;
        if (routeToReload) {
            sessionStorage.removeItem("routeReloadState");
            this._router.navigateByUrl(updatedUrl);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreConfigService, deps: [{ token: i0.Injector }, { token: i1.PostSessionService }, { token: i2.HttpService }, { token: i1.AppConfigService }, { token: i1.CookieService }, { token: i3.LayoutsService }, { token: WINDOW }, { token: DOCUMENT }, { token: PLATFORM_ID }, { token: i4.ActivatedRoute }, { token: i4$1.AuthorizationService }, { token: i4$1.ModFedRouteGuard }, { token: i6.NGALoginService }, { token: i3.CdsThemingService }, { token: CbolCoreRedirectService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreConfigService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreConfigService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i0.Injector }, { type: i1.PostSessionService }, { type: i2.HttpService }, { type: i1.AppConfigService }, { type: i1.CookieService }, { type: i3.LayoutsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i4.ActivatedRoute }, { type: i4$1.AuthorizationService }, { type: i4$1.ModFedRouteGuard }, { type: i6.NGALoginService }, { type: i3.CdsThemingService }, { type: CbolCoreRedirectService }] });

// /**
// * @class CbolSessionService
// * @constructor
// **/
class CbolSessionService {
    sessionPostSuccessHandler(sessionPost) {
        if (!!sessionPost) {
            let dataString = JSON.stringify(sessionPost);
            let gettingSessionData = JSON.parse(dataString);
            if (gettingSessionData.isMarketingTriggered !== 'Y') {
                this.marketingaction();
            }
            gettingSessionData.isMarketingTriggered = 'Y';
            let dataForSessionStorage = JSON.stringify(gettingSessionData);
            if (this._window)
                sessionStorage.setItem('sessionPostBrandingStorage', dataForSessionStorage);
        }
    }
    constructor(_appConfigService, _httpService, _storageService, _platformId, _window, _coreConfig, _authService, _assistedService, _assistedDataService, modFedRouteGuard, cbolCoreRedirectService, _router, _http, _cookieService, _isSSRApp, _deepdropService) {
        this._appConfigService = _appConfigService;
        this._httpService = _httpService;
        this._storageService = _storageService;
        this._platformId = _platformId;
        this._window = _window;
        this._coreConfig = _coreConfig;
        this._authService = _authService;
        this._assistedService = _assistedService;
        this._assistedDataService = _assistedDataService;
        this.modFedRouteGuard = modFedRouteGuard;
        this.cbolCoreRedirectService = cbolCoreRedirectService;
        this._router = _router;
        this._http = _http;
        this._cookieService = _cookieService;
        this._deepdropService = _deepdropService;
        this.activityFlag = false;
        this.disableActivityCheck = false;
        this.isTimerInit = false;
        this.redirect = false;
        this.killLegacySecondayLoginEndpoint = '/US/REST/digital/customers/profiles/privacy/secondary/submission.jws';
        //Session time out new implementation
        this.sessionEmitter = new EventEmitter();
        this.modal_open = false;
        this.legacySessionTimeoutHandler = () => {
            if (this._window)
                sessionStorage.setItem('isMarketingTriggered', null);
            this._window.location.href = this._appConfigService.getConfig('sessionService').sessionTimeoutUrl;
        };
        this.legacyRenewSessionHandler = () => {
            if (Cookie.get('NGACoExistenceCookie')) {
                if (Cookie.get('NGAKeepAOAlive')) {
                    this._http.get(Cookie.get('NGAKeepAOAlive')).subscribe();
                }
            }
        };
        this.ngaSessionTimeoutHandler = (param) => {
            //TODO:  what does the unauthorized.do logic do?  that should be packaged here
            //TODO:  should this actually navigate to the NGA signoff point AND/OR tie directly in to the NGA Angular signoff module?
            if (this._window)
                sessionStorage.setItem('isMarketingTriggered', null);
            //START: Getting the current path and triggering the sessionTimeout through angular signOff Module
            let tenantId;
            let currentUrl = this._router.url;
            let signOffUrl;
            this.routeName = currentUrl.split('/')[1];
            if (this.routeName.toLowerCase() == 'paypal' ||
                this.routeName.toLowerCase() == 'loanfx') {
                tenantId = this.routeName + 'SessionTimeOut';
                signOffUrl = '/sign-off?tenantId=' + tenantId;
                //END: Getting the current path and triggering the sessionTimeout through angular signOff Module
            }
            else {
                signOffUrl = '/sign-off?sessionTimeout=true';
            }
            if (this._appConfigService.getBusinessId() == 'USMKT') {
                // Redirect session time out to citi.com in Marketing pages UAT and PROD
                this._window.location.href = `${this._appConfigService.getcsrHostName()}/US/ag/${signOffUrl}`;
            }
            if (this._window && this._window.location.pathname.startsWith('/US/nga')) {
                // Redirect signoff to US/ag if base href is US/nga
                this._window.location.href = `${this._appConfigService.getcsrHostName()}/US/ag${signOffUrl}`;
            }
            else {
                const paramMap = {
                    routeId: this.accessedRoute,
                    errorCase: param
                };
                const queryString = new URLSearchParams(paramMap).toString();
                this._window.location.href.includes("sign-off") ? '' : this._window.location.href = `${this._appConfigService.getcsrHostName()}/US/ag/sign-off?${queryString}`;
            }
        };
        this.ngaSessionRenewHandler = () => {
            if (Cookie.get('NGACoExistenceCookie')) {
                if (Cookie.get('NGAKeepAOAlive')) {
                    this._http.get(Cookie.get('NGAKeepAOAlive')).subscribe();
                }
            }
        };
        this._keepAliveIntervalHandler = () => {
            if (!!this.activityFlag) {
                this.activityFlag = false;
                this.renew();
            }
        };
        this._keepAliveIntervalObserver = {
            next: x => {
                this._keepAliveIntervalHandler();
            },
            error: err => {
                console.log('KeepAliveIntervalObserver Err: %s', err);
            },
            complete: () => { }
        };
        this._router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe(event => {
            console.log('Accessed Route', event['url']);
            this.accessedRoute = event['url'].split("/")[2] ?
                (event['url'].split("/")[1] + "-" + event['url'].split("/")[2]).toUpperCase() :
                new URLSearchParams((event['url'])?.split("?")[1])?.get('routeId')?.split('?')[0];
        });
        //To kill the legacy Secondary Login session created when the user login through NGA login
        if (!_isSSRApp) {
            this.killLegacySecondaryLogin();
        }
        /*
        trigger initial marketing action upon successful return of SessionPostBrandingStorage; destroy subscription
        */
        this.sessionPostSubscription = this._coreConfig
            .getSessionPostObservable()
            .pipe(finalize(() => {
            this.sessionPostSubscription.unsubscribe();
        }))
            .subscribe((sessionPost) => {
            this.sessionPostSuccessHandler(sessionPost);
        }, err => {
            console.error(err);
        });
        let channelID = this._cookieService.getCookie('channelId');
        let sessionCID = (isPlatformBrowser(this._platformId)) ? sessionStorage.getItem('channelID') : null;
        if (!(channelID == 'SFRTL' || channelID == 'ECLIPSE' || sessionCID == 'SFRTL' || sessionCID == 'ECLIPSE')) {
            this.sessionSubscription = this._authService
                .getSessionObservable()
                .subscribe(sessionType => {
                if (!!sessionType) {
                    // if we receive notice of an active session...
                    if (!this.isTimerInit) {
                        // and the timer is not active... then let's start session timers
                        switch (sessionType) {
                            case AuthorizationService.NGA:
                                this.sessionType = AuthorizationService.NGA;
                                this._customTimeoutHandler = this.ngaSessionTimeoutHandler;
                                this._customRenewSessionHandler = this.ngaSessionRenewHandler;
                                break;
                            default:
                                this.sessionType = AuthorizationService.legacy;
                                this._customTimeoutHandler = this.legacySessionTimeoutHandler;
                                this._customRenewSessionHandler = this.legacyRenewSessionHandler;
                        }
                        this.start();
                    }
                }
                else {
                    // else we receive word there is no active session
                    if (!!this.isTimerInit) {
                        // if there is somehow a timer that is active, we assume the user has just logged off from the Angular app
                        console.log('reset timer');
                        this.resetSession();
                    }
                }
            });
        }
        else {
            // This method is created for calling authorize method for reimagine token generation
            let channelID = this._cookieService.getCookie('channelId');
            if (channelID == 'SFRTL' || channelID == 'ECLIPSE') {
                this.assistedAuth();
            }
        }
    }
    // /**
    // 	 * The assistedAuth method is used to call the authorize method.
    assistedAuth() {
        let citiAuth = this._cookieService.getCookie('isLoggedIn');
        if (citiAuth) {
            const assistedKeepAliveInterval = this._appConfigService.getSessionServiceConfig().keepAliveInterval * 1000;
            console.log("## assistedKeepAliveInterval", assistedKeepAliveInterval);
            this.timerSubscription = timer(assistedKeepAliveInterval, assistedKeepAliveInterval).pipe(map(() => {
                this.authCall(); // load data contains the http request
            })).subscribe();
        }
    }
    authCall() {
        console.log("## authorize call trigerring ");
        this._assistedDataService.showOauthRedirect(false);
        this._assistedService.authorizationService();
    }
    // /**
    // 	 * The start method is used to start the session timer. It recevies a SessionTimeoutHandler.
    // 	 * When the session timeout occurs, it will execute the handleSessionTimeout method of SessionTimeoutHandler object.
    // 	 *
    // 	 * @method start
    // 	 * @public
    // 	 * @param customTimeoutHandler {SessionTimeoutHandler} When the session timeout occurs,
    // 	 * the handleSessionTimouet method of this object is called.
    // 	 * @returns {void}
    // */
    start(customTimeoutHandler, customRenewSessionHandler) {
        const self = this;
        this.activityFlag = false;
        this.disableActivityCheck = false;
        this.isTimerInit = true;
        this.calculateTimeOut();
        const keepAliveInterval = this._appConfigService.getSessionServiceConfig().keepAliveInterval * 1000;
        this._keepAliveIntervalObservable = timer(keepAliveInterval, keepAliveInterval);
        // One-time KeepAlive Call as soon as AG Page loaded.
        this.renew();
    }
    calculateTimeOut() {
        if (this.inactiveSubscription) {
            this.inactiveSubscription.unsubscribe();
        }
        this.sessionTimeOut = (this._appConfigService.getSessionServiceConfig().sessionTimeout - 120) * 1000;
        this.resetTimer();
        this.checkTimeDiff();
    }
    checkTimeDiff() {
        this.inactiveSubscription = interval(1000)
            .pipe(map(x => { }))
            .subscribe(x => {
            this.resetCookieTime = Cookie.get('cbol_timeout') ? Cookie.get('cbol_timeout') : this.resetTime.getTime();
            this.modal_open = ((Cookie.get('timeout_modal_state') === 'modal_closed') && this.modal_open) ? true : false;
            this.currentTime = new Date();
            let diffTime = this.currentTime.getTime() - this.resetCookieTime;
            if (diffTime < this.sessionTimeOut && this.modal_open) {
                this.sessionEmitter.emit('onContinueSession');
                this.modal_open = false;
            }
            if (diffTime >= this.sessionTimeOut) {
                Cookie.set('timeout_modal_state', 'modal_open', null, '/', '.citi.com', true);
                this.sessionEmitter.emit('showOverLay');
                this.modal_open = true;
            }
        });
    }
    resetTimer() {
        this.resetTime = new Date();
        Cookie.set('cbol_timeout', this.resetTime.getTime(), null, '/', '.citi.com', true);
    }
    executeTimeout(param) {
        if (this.inactiveSubscription) {
            this.inactiveSubscription.unsubscribe();
        }
        this._customTimeoutHandler(param);
        if (this._window)
            sessionStorage.setItem('isMarketingTriggered', null);
    }
    toggleActivityCheck(disabled) {
        this.disableActivityCheck = disabled;
    }
    isTimerInitialized() {
        return this.isTimerInit;
    }
    activityHandler(active) {
        if (this.disableActivityCheck === false) {
            this.activityFlag = true;
            // For bug with Tour Component, not always resetting timer
            // if (document.getElementsByClassName('tourSessionTimer').length > 0) {
            //   console.log('Renewing Session...');
            //   this.renew();
            // }
        }
    }
    resetSession() {
        this.isTimerInit = false;
        this.activityFlag = false;
        this.disableActivityCheck = false;
        this.inactiveSubscription.unsubscribe();
        this._keepAliveIntervalSubscription.unsubscribe();
    }
    getHttpRequestFunction() {
        let httpRequestFunction = this._httpService.post.bind(this._httpService);
        if (this._appConfigService.getSessionServiceConfig().sessionKeepAliveMethod) {
            if (this._appConfigService.getSessionServiceConfig()
                .sessionKeepAliveMethod === 'GET') {
                //TODO:  bound functions are necessary here; just use the injected HTTP Service reference
                httpRequestFunction = this._httpService.get.bind(this._httpService);
            }
            else if (this._appConfigService.getSessionServiceConfig()
                .sessionKeepAliveMethod === 'PUT') {
                //TODO:  bound functions are necessary here; just use the injected HTTP Service reference
                httpRequestFunction = this._httpService.put.bind(this._httpService);
            }
        }
        return httpRequestFunction;
    }
    // /**
    //  * The renew method sends a keep alive request to the url specified
    //  * in the sessionKeepAliveUrl property of the SessionServiceConfig object in the Application Config.
    //  * After the keep alive request is sent, it will also restart the session timeout timer.
    //  * @method start
    //  * @public
    //  * @param customTimeoutHandler {SessionTimeoutHandler} When the session timeout occurs,
    //  *  the handleSessionTimouet method of this object is called.
    //  * @returns {void}
    //  */
    renew() {
        let httpRequestFunction = this.getHttpRequestFunction();
        let httpRequestFuncSubscription = httpRequestFunction(this._appConfigService.getSessionServiceConfig().sessionKeepAliveUrl)
            .pipe(finalize(() => {
            httpRequestFuncSubscription.unsubscribe();
        }))
            .subscribe(response => {
            try {
                this._keepAliveIntervalSubscription.unsubscribe();
            }
            catch (e) {
                /*
                If we have active subscriptions to session timeout and keepalive, the catch statement isn't needed.
                Otherwise, catch the error and create the initial subscriptions below.
                */
            }
            this.cbolCoreRedirectService.setKeepaliveResult('keepalive');
            this._keepAliveIntervalSubscription = this._keepAliveIntervalObservable.subscribe(this._keepAliveIntervalObserver);
        }, err => {
            console.log('session timeout error handler', err);
            this.executeTimeout("keepalive");
        });
        //TODO: It Keeps AO session hit keepalive
        if (this._customRenewSessionHandler) {
            this._customRenewSessionHandler();
        }
    }
    isPresentSessionTokens() {
        const cookieName = this._appConfigService.getSessionCookieInformation()
            .cookieName;
        const valueSeparator = this._appConfigService.getSessionCookieInformation()
            .valueSeparator;
        const arrValues = this._storageService.getArray(cookieName, valueSeparator, StorageService.COOKIE);
        return arrValues && arrValues.length > 2;
    }
    isPresentFriendKey() {
        const isFriendKey = this._appConfigService.getSessionCookieInformation()
            .isFriendKey;
        const isFriend = this._storageService.get(isFriendKey);
        return isFriend !== null && isFriend !== 'false';
    }
    // /**
    // 		 * The isVisitor method returns true if the cookie for the session
    // 		 *  does not exist or it exists but it does not contain the session tokens.
    // 		 * @method isVisitor
    // 		 * @public
    // 		 * @returns {boolean}
    // 	*/
    isVisitor() {
        return !this.isPresentSessionTokens();
    }
    // 	/**
    // 		* The isCustomer method returns true if all the OUath token is present for the customer.
    // 		* If OuathToken is not present then it would return false.
    // 		* @method isCustomer
    // 		* @public
    // 		* @returns {boolean}
    //  */
    isCustomer() {
        return this.isPresentSessionTokens() && !this.isPresentFriendKey();
    }
    // 	/**
    // 		* The isFriend method returns true if all the OUath token is present and also if the key for isFriend is available in storage
    // 		* @method isFriend
    // 		* @public
    // 		* @returns {boolean}
    //  */
    isFriend() {
        return this.isPresentSessionTokens() && this.isPresentFriendKey();
    }
    // /**
    // 		* The setFriendKey method inserts the friend key in the storage.
    // 		* @method setFriendKey
    // 		* @param isFriend {boolean} If true it inserts the friend key, if false it deletes the friend key.
    // 		* @public
    // 		* @returns {boolean}
    //  */
    setFriendKey(isFriend) {
        const isFriendKey = this._appConfigService.getSessionCookieInformation()
            .isFriendKey;
        if (isFriend) {
            this._storageService.set(isFriendKey, 'true');
        }
        else {
            this._storageService.delete(isFriendKey);
        }
    }
    getSessionEmitter() {
        return this.sessionEmitter;
    }
    canActivate(route, state) {
        if (this.isLoggedIn()) {
            return true;
        }
        else {
            let nextScreen = state.url.split('/')[1];
            if (!this._window)
                return;
            if (this._deepdropService.isSSRDeepdropFallback()) {
                let destUrl = this._window.location.protocol + '//' + this._window.location.host;
                this._window.location.href =
                    destUrl +
                        '/US/JSO/loginpage/retarget.action?next_ag_screen=' +
                        nextScreen +
                        '&deepdrop=true';
            }
            else {
                nextScreen = nextScreen.replace(/\?/g, '&');
                let destUrl = this._appConfigService.getnewCitiHostName() + '/login?nextRoute=';
                this._window.location.href = destUrl + nextScreen + '&deepdrop=true';
            }
            return false;
        }
    }
    isLoggedIn() {
        let sessionPostBrandingStorage = this._window
            ? this._window.sessionStorage.getItem('sessionPostBrandingStorage')
            : null;
        if (!sessionPostBrandingStorage) {
            console.log('sessionPostBrandingStorage is null');
            return false;
        }
        let isVisitor;
        if (sessionPostBrandingStorage.includes('isVisitor')) {
            const firstIndex = sessionPostBrandingStorage.indexOf('isVisitor');
            const lastIndex = sessionPostBrandingStorage.indexOf(',', firstIndex);
            isVisitor = sessionPostBrandingStorage.substring(firstIndex, lastIndex);
        }
        if (isVisitor == null || isVisitor.includes('N')) {
            return true;
        }
        else {
            return false;
        }
    }
    getSessionData() {
        if (!isPlatformBrowser(this._platformId)) {
            return;
        }
        let gettingSession = this._window.sessionStorage.getItem('sessionPostBrandingStorage');
        let gettingSessionData = JSON.parse(gettingSession);
        try {
            this.ecmvalue = gettingSessionData.ecmvalue;
            this.mktDomain = gettingSessionData.mktDomain;
            this.pbqs = gettingSessionData.pbqs;
            this.fsUUID = gettingSessionData.fsUUID;
        }
        catch (err) {
            console.error(err);
        }
    }
    marketingaction() {
        /** This method is not in use after Nov Release 2022 [GBC-7736] **/
        if (sessionStorage['sessionPostBrandingStorage']) {
            const sbps = JSON.parse(sessionStorage['sessionPostBrandingStorage']);
            if (sbps?.['featureFlags']?.['ff_marketingLegacyServerShutdownFallback'] !== 'Y') {
                this.getSessionData();
                let mkturl;
                if (this.ecmvalue != null) {
                    mkturl =
                        `https://${this.mktDomain}/credit-cards/cookiescript/citi.action?token=${this.ecmvalue}&` +
                            `pbqs=${this.pbqs}&uuid=${this.fsUUID}&t=${new Date().getTime()}`;
                }
                if (this.ecmvalue == null) {
                    mkturl =
                        `https://${this.mktDomain}/credit-cards/cookiescript/citi.action?pbqs=` +
                            `${this.pbqs}&uuid=${this.fsUUID}&t=${new Date().getTime()}`;
                }
                const script = document.createElement('script');
                script.setAttribute('src', mkturl);
                script.async = true;
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        }
    }
    killLegacySecondaryLogin() {
        let isSecondaryLoginCookie = Cookie.get('isSecondaryLogin');
        if (isSecondaryLoginCookie) {
            let secondarySessionTerminationCall = this._httpService
                .post(this._appConfigService.getcsrHostName() +
                this.killLegacySecondayLoginEndpoint, {})
                .pipe(catchError(err => {
                console.log('killLegacySecondayLoginEndpoint failure');
                //set session item if submission call fails
                this._window
                    ? this._window.sessionStorage.setItem('submissionJWSfailed', false)
                    : null;
                return throwError(err);
            }), finalize(() => {
                Cookie.delete('isSecondaryLogin', '/', '.citi.com');
                secondarySessionTerminationCall.unsubscribe();
            }))
                .subscribe(data => {
                console.log(data);
                console.log(data['ssoFlagsList']);
                try {
                    let ssoFlags = data['ssoFlagsList'];
                    if (!ssoFlags) {
                        throw new Error('ssoFlags not defined');
                    }
                    else {
                        let newSSOFlags = {};
                        // get ssoFlagCookie from cookie if exist;
                        let ssoFlagCookie = this._cookieService.getCookie('ssoFlagsList');
                        // if ssoFlags already exist in cookie, put only true value in newSSOFlags;
                        if (ssoFlagCookie && ssoFlagCookie.length > 1) {
                            ssoFlagCookie = JSON.parse(ssoFlagCookie);
                            for (let flag in ssoFlagCookie) {
                                if (ssoFlagCookie[flag])
                                    newSSOFlags[flag] = true;
                            }
                        }
                        // put only true values from ssoFlags (from data), in to newSSOFlags also;
                        for (let flag in ssoFlags) {
                            if (ssoFlags[flag])
                                newSSOFlags[flag] = true;
                        }
                        // set newSSOFlags into cookie;
                        this._cookieService.setCookie({
                            name: 'ssoFlagsList',
                            value: JSON.stringify(newSSOFlags),
                            path: '/',
                            domain: '.citi.com'
                        });
                        // sessionStorage.setItem('ssoFlagsList', JSON.stringify(ssoFlags));
                        console.log('sessionStorage: ', sessionStorage);
                        console.log('killLegacySecondayLoginEndpoint success');
                    }
                }
                catch (e) {
                    console.error('Exception in killing secondary session');
                }
            });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolSessionService, deps: [{ token: i1.AppConfigService }, { token: i2.HttpService }, { token: i1.StorageService }, { token: PLATFORM_ID }, { token: WINDOW }, { token: CbolCoreConfigService }, { token: i4$1.AuthorizationService }, { token: i5.AssistedChannelService }, { token: i5.AssistedChannelDataShareService }, { token: i4$1.ModFedRouteGuard }, { token: CbolCoreRedirectService }, { token: i4.Router }, { token: i2$1.HttpClient }, { token: i1.CookieService }, { token: IS_SSRENDERED_APP, optional: true }, { token: i4$1.DeepdropService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolSessionService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolSessionService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.AppConfigService }, { type: i2.HttpService }, { type: i1.StorageService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: CbolCoreConfigService }, { type: i4$1.AuthorizationService }, { type: i5.AssistedChannelService }, { type: i5.AssistedChannelDataShareService }, { type: i4$1.ModFedRouteGuard }, { type: CbolCoreRedirectService }, { type: i4.Router }, { type: i2$1.HttpClient }, { type: i1.CookieService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IS_SSRENDERED_APP]
                }] }, { type: i4$1.DeepdropService }] });

const SESSION_STORAGE = new InjectionToken('SessionStorageToken');
function sessionStorageFactory(platformId) {
    return isPlatformBrowser(platformId) ? sessionStorage : null;
}
const SESSION_STORAGE_PROVIDER = {
    provide: SESSION_STORAGE,
    useFactory: sessionStorageFactory,
    deps: [PLATFORM_ID]
};

class PreloginInactivityService {
    constructor(_appConfigService, _httpService, contentService, injector, _platform, _window) {
        this._appConfigService = _appConfigService;
        this._httpService = _httpService;
        this.contentService = contentService;
        this.injector = injector;
        this._platform = _platform;
        this._window = _window;
        //BAU timeout time as a backup, if app config is missing pre login timeout
        this.defaultPreLoginTimeout = 180;
        // Interval Times for 10 and 15 minutes and Event Emitters defined for Doc capture team
        this.firstInterval = 60;
        this.secondInterval = 90;
        this.preFirstEvent = new EventEmitter();
        this.preSecondEvent = new EventEmitter();
        this.preFirstCounter = false;
        this.preSecondCounter = false;
        // this._router = this.injector.get(Router);
        // this._router.events
        //   .pipe(filter(event => event instanceof NavigationStart))
        //   .subscribe(event => {
        //     //console.log('Accessed Route', event['url']);
        //     this.accessedRoute = event['url'].split("/")[2] ?
        //       (event['url'].split("/")[1] + "-" + event['url'].split("/")[2]).toUpperCase() :
        //       new URLSearchParams((event['url'])?.split("?")[1])?.get('routeId')?.split('?')[0];
        //   });
        if (isPlatformBrowser(this._platform)) {
            const url = new URL(this._window?.location?.href).pathname;
            this.accessedRoute = url.split("/")[2] ?
                (url.split("/")[1] + "-" + url.split("/")[2]).toUpperCase() :
                new URLSearchParams((url)?.split("?")[1])?.get('routeId')?.split('?')[0];
        }
    }
    /**
      * The calculatePreTimeOut method gets called on cbol session componet for all pre login pages and also when pre login route changes.
      * method: calculatePreTimeOut
    */
    calculatePreTimeOut() {
        if (this.preLoginInactiveSubscription) {
            this.preLoginInactiveSubscription.unsubscribe();
        }
        let configTimeout = this._appConfigService.getSessionServiceConfig().preLoginTimeout * 10000;
        this.preTimeout = configTimeout ? configTimeout : (this.defaultPreLoginTimeout * 10000);
        this.resetPreLoginTimer();
        this.checkPreLoginTimeDiff();
    }
    /**
      * The checkPreLoginTimeDiff method is used for emitting events for Doc Capture and BAU 30 mins inactivity timeout.
      * method: checkPreLoginTimeDiff
    */
    checkPreLoginTimeDiff() {
        this.preLoginInactiveSubscription = interval(1000)
            .pipe(map(x => { }))
            .subscribe(async (x) => {
            this.currentTime = new Date();
            let diffTime = this.currentTime.getTime() - this.resetTime.getTime();
            // console.log("####", diffTime, this.firstInterval)
            // First two if statements are for DOC capture event emitters at 10 and 15 minutes
            if ((diffTime >= (this.firstInterval * 10000)) && !this.preFirstCounter) {
                this.preFirstEvent.emit(true);
                this.preFirstCounter = true;
            }
            if ((diffTime >= (this.secondInterval * 10000)) && !this.preSecondCounter) {
                this.preSecondEvent.emit(true);
                this.preSecondCounter = true;
            }
            //BAU Pre login inactivity after 30 minutes for calling demoted signoff api
            if ((diffTime >= this.preTimeout) && !Cookie.get('cbol_timeout')) {
                // console.log("## Pre login failure case for token expiry - demotedCustomerSignoff");
                this.preLoginInactiveSubscription.unsubscribe();
                await this._httpService.deleteSessions();
                //taking user back to homepage
                if (this._window) {
                    const appId = 'citishop_prelogin_inactivity';
                    const contentObs = this.contentService.getStaticBundle(appId);
                    contentObs.subscribe(data => {
                        if (data) {
                            this.journeyUrlMapping = JSON.parse(this.contentService.get(appId, 'copy', 'journey_page_prelogin_inactivity_url_map', undefined)['TEXT']);
                            const journeyUrl = this.journeyUrlMapping[this.accessedRoute] ? this.getEnvironmentUrl(this.journeyUrlMapping[this.accessedRoute]) : false;
                            this.redirectToHomePage(journeyUrl);
                        }
                        else {
                            this.redirectToHomePage();
                        }
                    }, error => {
                        console.log('Failure in citishop_prelogin_inactivity', error);
                        this.redirectToHomePage();
                    });
                }
            }
        });
    }
    // Get environment URL based off predefined map structure in content, if no environment matches return UAT environment
    getEnvironmentUrl(urlMappingObject) {
        let environmentUrl = urlMappingObject[this._appConfigService.getEnvironment()];
        console.log(this._appConfigService.getEnvironment());
        if (!environmentUrl) {
            console.log(this._appConfigService.getEnvironment());
            environmentUrl = urlMappingObject['UAT'];
        }
        console.log(environmentUrl + 'TEST');
        return environmentUrl;
    }
    /**
      * The resetPreLoginTimer will set with new time whenever there is activity.
      * method: resetPreLoginTimer
    */
    resetPreLoginTimer() {
        this.resetTime = new Date();
        this.preFirstCounter = false;
        this.preFirstCounter = false;
    }
    redirectToHomePage(journeyUrl) {
        this._window.location.href = journeyUrl
            ? this._appConfigService.getnewCitiHostName() + journeyUrl + '/?loginScreenId=preLoginInactivity'
            : this._appConfigService.getnewCitiHostName() + '/?loginScreenId=preLoginInactivity';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: PreloginInactivityService, deps: [{ token: i1.AppConfigService }, { token: i2.HttpService }, { token: i2.ContentService }, { token: i0.Injector }, { token: PLATFORM_ID }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: PreloginInactivityService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: PreloginInactivityService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.AppConfigService }, { type: i2.HttpService }, { type: i2.ContentService }, { type: i0.Injector }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }] });

class CbolCoreContent {
    static { this.en_US = {
        copy$$SessionTimeOut: {
            GROUP_TYPE: 'Container',
            SET_NOTIFICATION: 'N',
            SiteCatPageName: 'Sign On Help - Bank Reset Password',
            TimeOut: 'Due to inactivity, your session will expire in:',
            Minutes: 'minute(s)',
            Seconds: 'second(s)',
            Action: 'If additional time is required, please click "Continue Session". To allow the session to end, click "End"',
            PrimaryButtonText: 'Continue',
            CancelButtonText: 'End',
            Headline: 'Session Time-Out'
        },
        copy$$Cobrowse: {
            SUBGROUP_TYPE: 'Container',
            PrimaryButtonText: 'Ok',
            CancelButtonText: 'Cancel',
            GROUP_TYPE: 'Container',
            SET_NOTIFICATION: 'N',
            Content: "During your call, you may be asked to share our screen for a faster, more efficient experience. If you agree, the phone representative you're speaking with will give you a Service Code to enter below.",
            Refernece: 'If you need assistance from a Citi representative, <a href="/US/CBOL/hc/contactus/flow.action">contact us</a> via chat or phone.',
            Title: 'Share Your Screen With A Phone Representative',
            placeholder: 'Service Code',
            ErrorMessage: 'Please enter a valid service code',
            CONTENT_ID: 'Cobrowse',
            NAME: 'Cobrowse'
        }
    }; }
    static { this.es_US = {
        copy$$SessionTimeOut: {
            GROUP_TYPE: 'Container',
            SET_NOTIFICATION: 'N',
            SiteCatPageName: 'Sign On Help - Bank Reset Password',
            TimeOut: 'Tu sesión expirará por falta de actividad en:',
            Minutes: 'minuto(s)',
            Seconds: 'segundo(s)',
            Action: 'Si necesitas tiempo adicional, por favor haz clic en "Continuar Sesión". Para permitir que la sesión finalice, haz clic en "Finalizar".',
            PrimaryButtonText: 'Continuar',
            CancelButtonText: 'Finalizar',
            Headline: 'Expiración de Sesión'
        },
        copy$$Cobrowse: {
            SUBGROUP_TYPE: 'Container',
            PrimaryButtonText: 'Aceptar',
            CancelButtonText: 'Cancelar',
            GROUP_TYPE: 'Container',
            SET_NOTIFICATION: 'N',
            Content: 'Durante tu llamada, se te podría pedir que compartas tu pantalla para tener una experiencia más rápida y eficiente. Si estás de acuerdo, el representante telefónico con el que estás hablando te proporcionará un Código de Servicio para ingresar a continuación.',
            Refernece: 'Si necesitas ayuda de un Representante de Citi, <a href="/US/CBOL/hc/contactus/flow.action">Contáctanos</a> a través del chat o por teléfono.',
            Title: 'Comparte Tu Pantalla Con un Representante Telefónico',
            placeholder: 'Código de Servicio',
            ErrorMessage: 'Please enter a valid service code',
            CONTENT_ID: 'Cobrowse',
            NAME: 'Cobrowse'
        }
    }; }
}

class CbolCoreContentService {
    constructor(contentService) {
        this.contentService = contentService;
        this.appId = 'cbol_ag_container';
    }
    getData() {
        return this.contentService.getStaticBundle(this.appId).pipe(catchError$1(err => {
            const locale = Cookie$1.get('locale') ? Cookie$1.get('locale') : 'en_US';
            this.content = CbolCoreContent[locale];
            return of(this.content);
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreContentService, deps: [{ token: i2.ContentService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreContentService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreContentService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i2.ContentService }] });

class SessionTimeoutModal {
    constructor(coreContent, siteCat, _taggingService, _window, _appConfigService) {
        this.coreContent = coreContent;
        this.siteCat = siteCat;
        this._taggingService = _taggingService;
        this._window = _window;
        this._appConfigService = _appConfigService;
        this.defaultPopUpTime = 120;
        /**
         * @property endSession
         * @description emits when end session button is clicked
         */
        this.endSession = new EventEmitter();
        /**
         * @property continueSession
         * @description emits when continue session button is clicked
         */
        this.continueSession = new EventEmitter();
        /**
         * @property changeShown
         * @description emits when modal change is detected
         */
        this.changeShown = new EventEmitter();
        /**
         * @property noActivity
         * @description emits when timer runs out and equals to zero
         */
        this.noActivity = new EventEmitter();
    }
    async ngOnInit() {
        try {
            const data = await firstValueFrom(this.coreContent.getData());
            this.content = this.getContentForKey(data, 'copy$$SessionTimeOut');
        }
        catch (err) {
            console.error("Failed to fetch content", err);
        }
        // app-envConfig value for popup time
        this.configPopUpTime = this._appConfigService.getSessionServiceConfig().sessionTimeOutPopUpTime;
        // if custom timer value from consuming component is passed, if not from app-envConfig, if not default from component
        this.sessionTimeOutPopUpTime = this.customTimer
            ? this.customTimer
            : this.configPopUpTime
                ? this.configPopUpTime
                : this.defaultPopUpTime;
        this.startTimer(this.sessionTimeOutPopUpTime);
        if (this.showTimeOutOverlay === true) {
            this.startCountDown();
        }
        this._taggingService.triggerPageTagging("nonicms_content", this.isUserLoggedIn(), "654SessionTimeoutPage", {
            dynamicContent: { cust_error: this.content.Headline }
        });
    }
    isUserLoggedIn() {
        let sessionPostBrandingStorage = this._window
            ? this._window.sessionStorage.getItem('sessionPostBrandingStorage')
            : null;
        return !sessionPostBrandingStorage ? false : true;
    }
    getContentForKey(data, key) {
        if (key != null && key !== undefined) {
            return data[key];
        }
    }
    startCountDown() {
        this.interval = setInterval(() => {
            if (this.sessionTimeOutPopUpTime > 0) {
                this.startTimer(this.sessionTimeOutPopUpTime--);
            }
            else {
                clearInterval(this.interval);
                this.noActivity.emit();
            }
        }, 1000);
    }
    startTimer(time) {
        this.timer = time * 1000;
        this.timerArr = this.formatTimer(this.timer);
        this.fullTimer = this.timerArr[0];
        var timeSplit = this.fullTimer.split(':');
        this.minsLeft = timeSplit[0];
        this.secsLeft = timeSplit[1];
    }
    /**
     * @Method:formatTimer
     * @Description: return session time out popup timer in format mm:ss
     */
    formatTimer(t) {
        t = t / 1000;
        this.minutes = Math.floor(t / 60) % 60;
        t -= this.minutes * 60;
        this.seconds = t % 60;
        if (this.seconds < 10) {
            this.seconds = '0' + this.seconds;
        }
        if (this.minutes < 10) {
            this.minutes = '0' + this.minutes;
        }
        return [this.minutes + ':' + this.seconds];
    }
    onEndUserSession() {
        this._taggingService.triggerPageTagging("nonicms_content", this.isUserLoggedIn(), "654_bSessionTimeoutCTAClick", {
            dynamicContent: { link_name: this.content.CancelButtonText }
        });
        this.endSession.emit();
    }
    onContinueUserSession() {
        this._taggingService.triggerPageTagging("nonicms_content", this.isUserLoggedIn(), "654_bSessionTimeoutCTAClick", {
            dynamicContent: { link_name: this.content.PrimaryButtonText }
        });
        this.continueSession.emit();
    }
    isModalShown($event) {
        this.changeShown.emit($event);
    }
    onCloseOverlay() {
        this._taggingService.triggerPageTagging("nonicms_content", this.isUserLoggedIn(), "654_bSessionTimeoutCTAClick", {
            dynamicContent: { link_name: 'Close' }
        });
        this.continueSession.emit();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SessionTimeoutModal, deps: [{ token: CbolCoreContentService }, { token: i2$2.SiteCatalystService }, { token: i1.TaggingService }, { token: WINDOW }, { token: i1.AppConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: SessionTimeoutModal, isStandalone: false, selector: "session-timeout-modal", inputs: { showTimeOutOverlay: "showTimeOutOverlay", customTimer: "customTimer" }, outputs: { endSession: "endSession", continueSession: "continueSession", changeShown: "changeShown", noActivity: "noActivity" }, ngImport: i0, template: "<div class=\"cbol-session\" *ngIf=\"showTimeOutOverlay\">\n  <citi-modal\n    showCancelButton=\"true\"\n    cancelButtonText=\"{{ content?.CancelButtonText }}\"\n    primaryButtonText=\"{{ content?.PrimaryButtonText }}\"\n    title=\"{{ content?.Headline }}\"\n    [(show)]=\"showTimeOutOverlay\"\n    (secondaryButtonClick)=\"onEndUserSession()\"\n    (primaryButtonClick)=\"onContinueUserSession()\"\n    (closeButtonClick)=\"onCloseOverlay()\"\n    (showChange)=\"isModalShown($event)\"\n    openerSelector=\"#sessionFocus\"\n    class=\"cbolui-ddl-post\"\n  >\n    <p></p>\n    <p>\n      {{ content?.TimeOut }}\n      <b\n        >{{ minsLeft }} {{ content?.Minutes }} {{ secsLeft }} {{ content?.Seconds\n        }}</b\n      >\n    </p>\n\n    <p [innerHTML]=\"content?.Action\"></p>\n  </citi-modal>\n</div>\n", styles: [".cbol-session::ng-deep .modal.in{z-index:9999999999!important}.cbol-session::ng-deep .citi-modal-backdrop{z-index:999999999!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1.ModalComponent, selector: "citi-modal", inputs: ["scrollable", "htmlContent", "ariaRole", "footerContent", "idStr", "title", "primaryButtonUrl", "primaryButtonTarget", "primaryButtonText", "showCancelButton", "footerProjection", "disablePrimaryButton", "disableCloseButton", "closeOnBgClick", "cancelButtonText", "openerSelector", "show", "closeButtonIdStr"], outputs: ["primaryButtonClick", "secondaryButtonClick", "closeButtonClick", "showChange", "onHide"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SessionTimeoutModal, decorators: [{
            type: Component,
            args: [{ selector: 'session-timeout-modal', standalone: false, template: "<div class=\"cbol-session\" *ngIf=\"showTimeOutOverlay\">\n  <citi-modal\n    showCancelButton=\"true\"\n    cancelButtonText=\"{{ content?.CancelButtonText }}\"\n    primaryButtonText=\"{{ content?.PrimaryButtonText }}\"\n    title=\"{{ content?.Headline }}\"\n    [(show)]=\"showTimeOutOverlay\"\n    (secondaryButtonClick)=\"onEndUserSession()\"\n    (primaryButtonClick)=\"onContinueUserSession()\"\n    (closeButtonClick)=\"onCloseOverlay()\"\n    (showChange)=\"isModalShown($event)\"\n    openerSelector=\"#sessionFocus\"\n    class=\"cbolui-ddl-post\"\n  >\n    <p></p>\n    <p>\n      {{ content?.TimeOut }}\n      <b\n        >{{ minsLeft }} {{ content?.Minutes }} {{ secsLeft }} {{ content?.Seconds\n        }}</b\n      >\n    </p>\n\n    <p [innerHTML]=\"content?.Action\"></p>\n  </citi-modal>\n</div>\n", styles: [".cbol-session::ng-deep .modal.in{z-index:9999999999!important}.cbol-session::ng-deep .citi-modal-backdrop{z-index:999999999!important}\n"] }]
        }], ctorParameters: () => [{ type: CbolCoreContentService }, { type: i2$2.SiteCatalystService }, { type: i1.TaggingService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1.AppConfigService }], propDecorators: { showTimeOutOverlay: [{
                type: Input
            }], customTimer: [{
                type: Input
            }], endSession: [{
                type: Output
            }], continueSession: [{
                type: Output
            }], changeShown: [{
                type: Output
            }], noActivity: [{
                type: Output
            }] } });

class CbolSessionComponent {
    constructor(_sessionService, _httpClient, _appConfigService, _preloginInactivityService, _router, renderer, _window, _sessionStorage, _cookieService, _platformId, _zone) {
        this._sessionService = _sessionService;
        this._httpClient = _httpClient;
        this._appConfigService = _appConfigService;
        this._preloginInactivityService = _preloginInactivityService;
        this._router = _router;
        this.renderer = renderer;
        this._window = _window;
        this._sessionStorage = _sessionStorage;
        this._cookieService = _cookieService;
        this._platformId = _platformId;
        this._zone = _zone;
        this.showTimeOutOverlay = false;
    }
    ngOnInit() {
        // calling prelogin timer on app load for inactivity handler
        if (!Cookie.get('isLoggedIn')) {
            isPlatformBrowser(this._platformId)
                ? this._preloginInactivityService.calculatePreTimeOut()
                : null;
        }
        const sessionTimeoutHandler = () => {
            this._routerChangeSubscription.unsubscribe();
            if (this._window)
                this._window.location.href = this._appConfigService.getConfig('sessionService').sessionTimeoutUrl;
        };
        const renewSessionHandler = () => {
            if (isPlatformServer(this._platformId)) {
                if (this._cookieService.getCookie('NGACoExistenceCookie') &&
                    this._cookieService.getCookie('NGAKeepAOAlive')) {
                    this._httpClient
                        .get(this._cookieService.getCookie('NGAKeepAOAlive'))
                        .subscribe();
                }
            }
            else {
                if (Cookie.get('NGACoExistenceCookie')) {
                    if (Cookie.get('NGAKeepAOAlive')) {
                        this._httpClient.get(Cookie.get('NGAKeepAOAlive')).subscribe();
                    }
                }
            }
        };
        /* Listen to router change to identify and initialize post login session timeout.*/
        this._routerChangeSubscription = this._router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(event => {
            console.log('router event detected!', this._sessionService.isTimerInitialized());
            if (!Cookie.get('isLoggedIn')) {
                isPlatformBrowser(this._platformId)
                    ? this._preloginInactivityService.calculatePreTimeOut()
                    : null;
            }
            if (this._sessionService.isTimerInitialized() === false &&
                Cookie.get('NGACoExistenceCookie')) {
                console.log('init timer');
                this._sessionService.start(sessionTimeoutHandler, renewSessionHandler);
                // Triggering Marketting action
                let gettingSession = this._sessionStorage
                    ? this._sessionStorage.getItem('sessionPostBrandingStorage')
                    : null;
                let gettingSessionData = JSON.parse(gettingSession);
                if (gettingSessionData.isMarketingTriggered !== 'Y') {
                    this._sessionService.marketingaction();
                    gettingSessionData.isMarketingTriggered = 'Y';
                    let dataForSessionStorage = JSON.stringify(gettingSessionData);
                    if (this._sessionStorage)
                        this._sessionStorage.setItem('sessionPostBrandingStorage', dataForSessionStorage);
                }
                // Listen to click events
                this.clickHandler = this.renderer.listen('document', 'click', event => {
                    this._sessionService.activityHandler(true);
                });
                // Listen to key press events
                this.keyPressListener = this.renderer.listen('document', 'keypress', event => {
                    this._sessionService.activityHandler(true);
                });
            }
            else if (this._sessionService.isTimerInitialized() === true &&
                !Cookie.get('NGACoExistenceCookie') &&
                !Cookie.get('isLoggedIn') // CAP-Changes Story# GBC-7605
            ) {
                console.log('reset timer');
                this._sessionService.resetSession();
                this.clickHandler(); // unbind click event on document
                this.keyPressListener(); // unbind keypress event on document
                this.doubleClickHandler(); // unbind double click event on document
                this.mouseMoveHandler(); // unbind mouse move event on document
                this.mouseDownHandler(); // unbind mouse down event on document
                this.mouseOverHandler(); // unbind mouse over event on document
                this.touchStartHandler(); // unbind touch start event on document
                this.scrollHandler(); // unbind scroll start event on document
            }
        });
        //Listen to click events
        this.clickHandler = this.renderer.listen('document', 'click', event => {
            this.resetTimer();
        });
        //Listen to key press events
        this.keyPressListener = this.renderer.listen('document', 'keypress', event => {
            this.resetTimer();
        });
        //Listen to double click events
        this.doubleClickHandler = this.renderer.listen('document', 'dblclick', event => {
            this.resetTimer();
        });
        //Listen to key mouse move events
        this.mouseMoveHandler = this.renderer.listen('document', 'mousemove', event => {
            this.resetTimer();
        });
        //Listen to mouse down events
        this.mouseDownHandler = this.renderer.listen('document', 'mousedown', event => {
            this.resetTimer();
        });
        //Listen to mouse over press events
        this.mouseOverHandler = this.renderer.listen('document', 'mouseover', event => {
            this.resetTimer();
        });
        //Listen to touch events in mobile responsive
        this.touchStartHandler = this.renderer.listen('document', 'touchstart', event => {
            this.resetTimer();
        });
        //Listen to scroll events in mobile responsive
        this.scrollHandler = this.renderer.listen('document', 'scroll', event => {
            this.resetTimer();
        });
        this._sessionService.getSessionEmitter().subscribe(event => {
            if (event === 'showOverLay') {
                this.showTimeOutOverlay = true;
            }
            if (event === 'onContinueSession') {
                this.executeOnContinueUserSession();
            }
        });
    }
    noActivity() {
        this.showTimeOutOverlay = false;
        this.clickHandler(); // unbind click event on document
        this.keyPressListener(); // unbind keypress event on document
        this.doubleClickHandler(); // unbind double click event on document
        this.mouseMoveHandler(); // unbind mouse move event on document
        this.mouseDownHandler(); // unbind mouse down event on document
        this.mouseOverHandler(); // unbind mouse over event on document
        this.touchStartHandler(); // unbind touch start event on document
        this.scrollHandler(); // unbind scroll start event on document
        this._sessionService.executeTimeout("sessiontimeout");
    }
    resetTimer() {
        this._sessionService.activityHandler(true);
        //demoted handler checks
        if (!Cookie.get('isLoggedIn')) {
            isPlatformBrowser(this._platformId)
                ? this._preloginInactivityService.resetPreLoginTimer()
                : null;
        }
        else {
            if (!this.showTimeOutOverlay) {
                this._sessionService.resetTimer();
            }
        }
    }
    onEndUserSession() {
        this._sessionService.executeTimeout("sessiontimeout");
    }
    executeOnContinueUserSession() {
        this.showTimeOutOverlay = false;
        this._sessionService.renew();
        this._sessionService.toggleActivityCheck(false);
        this._sessionService.resetTimer();
    }
    onContinueUserSession() {
        Cookie.set('timeout_modal_state', 'modal_closed', null, '/', '.citi.com', true);
        this._sessionService.sessionEmitter.emit('onContinueSession');
    }
    /* Disables tracking user clicks when the timeout modal is active.*/
    isModalShown(event) {
        this._sessionService.toggleActivityCheck(event);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolSessionComponent, deps: [{ token: CbolSessionService }, { token: i2$1.HttpClient }, { token: i1.AppConfigService }, { token: PreloginInactivityService }, { token: i4.Router }, { token: i0.Renderer2 }, { token: WINDOW }, { token: SESSION_STORAGE }, { token: i1.CookieService }, { token: PLATFORM_ID }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: CbolSessionComponent, isStandalone: false, selector: "cbol-session", ngImport: i0, template: "<session-timeout-modal *ngIf=\"showTimeOutOverlay\"\n  [showTimeOutOverlay]=\"showTimeOutOverlay\"\n  (endSession)=\"onEndUserSession()\"\n  (continueSession)=\"onContinueUserSession()\"\n  (noActivity)=\"noActivity()\"\n  (changeShown)=\"isModalShown($event)\"\n></session-timeout-modal>\n", styles: [".cbol-session::ng-deep .modal.in{z-index:9999999999!important}.cbol-session::ng-deep .citi-modal-backdrop{z-index:999999999!important}\n"], dependencies: [{ kind: "component", type: SessionTimeoutModal, selector: "session-timeout-modal", inputs: ["showTimeOutOverlay", "customTimer"], outputs: ["endSession", "continueSession", "changeShown", "noActivity"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolSessionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cbol-session', standalone: false, template: "<session-timeout-modal *ngIf=\"showTimeOutOverlay\"\n  [showTimeOutOverlay]=\"showTimeOutOverlay\"\n  (endSession)=\"onEndUserSession()\"\n  (continueSession)=\"onContinueUserSession()\"\n  (noActivity)=\"noActivity()\"\n  (changeShown)=\"isModalShown($event)\"\n></session-timeout-modal>\n", styles: [".cbol-session::ng-deep .modal.in{z-index:9999999999!important}.cbol-session::ng-deep .citi-modal-backdrop{z-index:999999999!important}\n"] }]
        }], ctorParameters: () => [{ type: CbolSessionService }, { type: i2$1.HttpClient }, { type: i1.AppConfigService }, { type: PreloginInactivityService }, { type: i4.Router }, { type: i0.Renderer2 }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }, { type: i1.CookieService }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i0.NgZone }] });

class CitiSessionHandlerComponent {
    constructor(_router, _ng, _window) {
        this._router = _router;
        this._ng = _ng;
        this._window = _window;
        this.checkInterval = 10000;
        this._url = 'login.do';
        this._cookieName = 'NGACoExistenceCookie';
        this._isAngularRouting = false;
    }
    ngOnInit() {
        this._ng.runOutsideAngular(() => {
            this._interval = setInterval(() => {
                let _cookieVal = Cookie$1.get(this._cookieName);
                if (this._NGACoExistenceCookie != null && _cookieVal === null) {
                    if (this._isAngularRouting) {
                        this._router.navigateByUrl(this._url);
                    }
                    else if (this._window) {
                        this._window.location.href = this._url;
                    }
                }
                this._NGACoExistenceCookie = _cookieVal;
            }, this.checkInterval);
        });
    }
    ngOnDestroy() {
        clearInterval(this._interval);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiSessionHandlerComponent, deps: [{ token: i4.Router }, { token: i0.NgZone }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: CitiSessionHandlerComponent, isStandalone: false, selector: "citi-session-handler", inputs: { checkInterval: ["interval", "checkInterval"], _url: ["url", "_url"], _cookieName: ["cookie-name", "_cookieName"], _isAngularRouting: ["angular-routing", "_isAngularRouting"] }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiSessionHandlerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-session-handler',
                    standalone: false,
                    template: ''
                }]
        }], ctorParameters: () => [{ type: i4.Router }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }], propDecorators: { checkInterval: [{
                type: Input,
                args: ['interval']
            }], _url: [{
                type: Input,
                args: ['url']
            }], _cookieName: [{
                type: Input,
                args: ['cookie-name']
            }], _isAngularRouting: [{
                type: Input,
                args: ['angular-routing']
            }] } });

class CbolCoreComponent {
    constructor(_sessionService, _appConfigService, _http, _storageService, _window, layoutsService, _sanitizer) {
        this._sessionService = _sessionService;
        this._appConfigService = _appConfigService;
        this._http = _http;
        this._storageService = _storageService;
        this._window = _window;
        this.layoutsService = layoutsService;
        this._sanitizer = _sanitizer;
        this.width = '';
        this.containerClasses = [];
        this.interceptorList = RoutingDetectorConfig.interceptorList;
        if (this._storageService.get('sessionPostBrandingStorage', StorageService.SESSIONSTORAGE) &&
            this._storageService.get('sessionPostBrandingStorage', StorageService.SESSIONSTORAGE)['isFallBackLegacySignoff'] === 'Y') {
            this.isAngularRouting = false;
            this.url = this._appConfigService.getConfig('customConfig').sessionRedirectionURL;
        }
        else {
            this.isAngularRouting = true;
            this.url = this._appConfigService.getConfig('customConfig').ngaSessionRedirectionURL;
        }
        if (this._window)
            this._window.lpAccountNumber = this._appConfigService.getConfig('customConfig').lpAccountNumber;
        this.fullpageLoading = this.layoutsService.fullpageLoading;
        this.appbodyLoading = this.layoutsService.appbodyLoading;
        this.layoutsService.appbodyLoadingChanged.subscribe(appbodyLoading => {
            this.appbodyLoading = appbodyLoading;
        });
        this.layoutsService.fullpageLoadingChanged.subscribe(fullpageLoading => {
            this.fullpageLoading = fullpageLoading;
        });
        this.layoutsService.widthChanged.subscribe(width => {
            /* Set the width in the layout container classes */
            this.width = width;
        });
    }
    containerClassChange(val) {
        this.containerClasses = val;
    }
    getContentWidth() {
        if (this.layoutsService.responsive == 'false') {
            const newWidth = 'width:' + this.width + 'px !important';
            return this._sanitizer.bypassSecurityTrustStyle(newWidth);
        }
    }
    ngOnInit() {
        const defaultHeaders = this._appConfigService.getHttpServiceConfig()
            .defaultHeaders;
        if (this._storageService.get('RSA', StorageService.COOKIE))
            defaultHeaders['deviceTokenCookie'] = this._storageService.get('RSA', StorageService.COOKIE);
        if (!this._window)
            return;
        this.checkDeepdrop();
    }
    checkDeepdrop() {
        if (this._deepdropTimeoutSubscription) {
            this._deepdropTimeoutSubscription.unsubscribe();
        }
        this._deepdropTimeoutObservable = timer(0, 1000);
        this._deepdropTimeoutObserver = {
            next: x => {
                if (x === 30) {
                    if (this._window.sessionStorage.getItem('isDeepdrop')) {
                        // if (this.0.get('isDeepdrop',StorageService.SESSIONSTORAGE)) {
                        console.log('Checking session storage before delete');
                        // this._storageService.delete('isDeepdrop',StorageService.SESSIONSTORAGE);
                        this._window.sessionStorage.removeItem('isDeepdrop');
                    }
                    console.log('*************Subscribing with Timer***************');
                    this._deepdropTimeoutSubscription.unsubscribe();
                }
            },
            error: err => {
                console.log('DeepdropTimeoutObserver Err: %s', err);
            },
            complete: () => {
                console.log('DeepdropTimeoutObserver complete');
            }
        };
        var check = this._storageService.get('sessionPostBrandingStorage', StorageService.SESSIONSTORAGE);
        var check2 = this._sessionService.isCustomer();
        console.log(check);
        console.log(check2);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreComponent, deps: [{ token: i1.SessionService }, { token: i1.AppConfigService }, { token: i2$1.HttpClient }, { token: i1.StorageService }, { token: WINDOW }, { token: i3.LayoutsService }, { token: i4$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: CbolCoreComponent, isStandalone: false, selector: "cbol-core", ngImport: i0, template: "<citi-parent-layout>\n  <router-outlet></router-outlet>\n  <ng-content select=\"mfa-modal\"></ng-content>\n  <cbol-session></cbol-session>\n  <citi-route-detector\n    [route-detection-config]=\"interceptorList\"\n  ></citi-route-detector>\n  <citi-session-handler\n    [url]=\"url\"\n    interval=\"10000\"\n    [angular-routing]=\"isAngularRouting\"\n  ></citi-session-handler>\n</citi-parent-layout>\n", styles: [""], dependencies: [{ kind: "directive", type: i4.RouterOutlet, selector: "router-outlet", inputs: ["name", "routerOutletData"], outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }, { kind: "component", type: i3.ParentLayoutComponent, selector: "citi-parent-layout" }, { kind: "component", type: i3.CitiRouteDetectorComponent, selector: "citi-route-detector", inputs: ["route-detection-config"] }, { kind: "component", type: CbolSessionComponent, selector: "cbol-session" }, { kind: "component", type: CitiSessionHandlerComponent, selector: "citi-session-handler", inputs: ["interval", "url", "cookie-name", "angular-routing"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cbol-core', standalone: false, template: "<citi-parent-layout>\n  <router-outlet></router-outlet>\n  <ng-content select=\"mfa-modal\"></ng-content>\n  <cbol-session></cbol-session>\n  <citi-route-detector\n    [route-detection-config]=\"interceptorList\"\n  ></citi-route-detector>\n  <citi-session-handler\n    [url]=\"url\"\n    interval=\"10000\"\n    [angular-routing]=\"isAngularRouting\"\n  ></citi-session-handler>\n</citi-parent-layout>\n" }]
        }], ctorParameters: () => [{ type: i1.SessionService }, { type: i1.AppConfigService }, { type: i2$1.HttpClient }, { type: i1.StorageService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i3.LayoutsService }, { type: i4$2.DomSanitizer }] });

class ContentComponent {
    constructor(_contentService) {
        this._contentService = _contentService;
    }
    getContent() {
        if (this.appId) {
            return this._contentService.get(this.appId, this.contentType, this.contentId, this.prop, this.placeholders);
        }
        else {
            return this._contentService.get(this.bundleName, this.contentType, this.contentId, this.prop, this.placeholders);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentComponent, deps: [{ token: i2.ContentService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: ContentComponent, isStandalone: false, selector: "content", inputs: { appId: "appId", bundleName: "bundleName", contentType: "contentType", contentId: "contentId", prop: "prop", placeholders: "placeholders" }, ngImport: i0, template: "{{ getContent() }}\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'content', standalone: false, template: "{{ getContent() }}\n" }]
        }], ctorParameters: () => [{ type: i2.ContentService }], propDecorators: { appId: [{
                type: Input
            }], bundleName: [{
                type: Input
            }], contentType: [{
                type: Input
            }], contentId: [{
                type: Input
            }], prop: [{
                type: Input
            }], placeholders: [{
                type: Input
            }] } });

const COMPONENTS$3 = [ContentComponent];
const MODULES$2 = [CommonModule, RouterModule];
class ContentModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: ContentModule, declarations: [ContentComponent], imports: [CommonModule, RouterModule], exports: [ContentComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentModule, imports: [MODULES$2] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ContentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$2],
                    declarations: [...COMPONENTS$3],
                    exports: [ContentComponent]
                }]
        }] });

/**
 * @module CorePlatformRoutingModule
 * @main CorePlatformRoutingModule
 */
class PageNotFoundComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: PageNotFoundComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: PageNotFoundComponent, isStandalone: false, selector: "ng-component", ngImport: i0, template: "<div>\n  <h1>Page Not Found</h1>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: PageNotFoundComponent, decorators: [{
            type: Component,
            args: [{ standalone: false, template: "<div>\n  <h1>Page Not Found</h1>\n</div>\n" }]
        }] });

class TourService {
    constructor(_httpService, _cbolCoreConfigService, _sessionStorage) {
        this._httpService = _httpService;
        this._cbolCoreConfigService = _cbolCoreConfigService;
        this._sessionStorage = _sessionStorage;
        // parentHasLoaded: BehaviorSubject<boolean> = new BehaviorSubject(false);
        this.reEntryValue = false;
        this.sortedArrofEls = [];
        this.elementsArr = [];
        this.arrForButtons = [];
        this.arrLoaded = false;
        this.showIDWarnings = true; // Set this to false if you don't want these errors showing in your app.
        this.previousArrs = '';
        this.bs = new BehaviorSubject([]);
        this.activeTutorial = new BehaviorSubject('');
        this.activeOneStep = new BehaviorSubject('');
        this.employeeFlag = new BehaviorSubject('');
        this.el = new BehaviorSubject([]);
        this.reEntryTile = new BehaviorSubject('');
    }
    initTour() {
        this.arrForButtons = this.sortTourItems(JSON.parse(this.tourJSON));
        this.makeElementArr(this.arrForButtons);
    }
    /**
     * @remarks
     * This iterates through the objects in Tour JSON.
     *
     * @param arrOfEls - This is the array you get after parsing and sorting your Tour JSON
     */
    makeElementArr(arrOfEls) {
        this.elementsArr = [];
        this.arrForEls = arrOfEls;
        arrOfEls.forEach(comp => {
            if (document.getElementById(comp.id)) {
                this.elementsArr.push(document.getElementById(comp.id));
            }
            else {
                this.arrForButtons = this.arrForButtons.filter(el => {
                    return el.id !== comp.id;
                });
                // if (this.showIDWarnings) console.error(`Could not find element: "${comp.id}"`);
            }
        });
        this.el.next(this.arrForEls);
        this.bs.next(this.arrForButtons);
    }
    /**
     * @param unfilteredTourArr - Your initial, unfiltered Tour JSON
     * @param refreshedElement - What is the id of the element triggering the refresh?
     * @param timeoutWait - in milliseconds, how long should this function wait until it searches the DOM for your new element? Default is 800.
     *
     * @remarks
     * Initially, if an element cannot be found on the DOM, it is filtered out of the list of navigatable elements.
     * Use this if an element is to appear only after triggered to do so from a previous element.
     */
    refreshElArr(unfilteredTourArr, refreshedElement, timeoutWait = 800) {
        if (this.previousArrs !== refreshedElement) {
            this.arrForButtons = [];
            this.elementsArr = [];
            this.arrForButtons = this.sortTourItems(JSON.parse(unfilteredTourArr));
            setTimeout(() => {
                this.makeElementArr(this.arrForButtons);
            }, timeoutWait);
            this.previousArrs = refreshedElement;
        }
    }
    sortTourItems(tArr) {
        const sortedArr = tArr['elements'].sort((a, b) => {
            return a.order - b.order;
        });
        return sortedArr;
    }
    reEntryFlag() {
        this.tourFeatureFlag();
        return this.reEntryValue;
    }
    ;
    // Determines whether the feature flag coming from entitlement services is valid or not
    // emitting feature flag string name to tour.component.ts, if flag set true.
    tourFeatureFlag() {
        let returnValue;
        let ff_singleCardTest = false;
        const bauTutorials = ["ff_NonPGLUser",
            "ff_newCardLite",
            "ff_AttNewCardLite",
            "ff_ATTCardFull",
            "ff_AttPointsPlusLite",
            "ff_PGLMultiCardFull",
            "ff_PGLMultiCardLite",
            "ff_PGLCardLite",
            "ff_LeapFrog",
            "ff_reImagine",
            "ff_citiWealthBuilder",
            "ff_singleCardEvolutionTutorial",
            "ff_reEntryTile",
            "ff_employeeFeedback",
            "ff_singleCardTest"];
        this._cbolCoreConfigService.getSessionPostObservable().subscribe(spbs => {
            returnValue = false;
            let val = spbs.featureFlags;
            let activeFlag;
            let trueFlagArray = [];
            bauTutorials.forEach((feature) => {
                if (val[feature] === "Y") { // The tutorial is being shown
                    /**
                     ** Enable condition below if "ff_reEntryTile" is inside "FS24Tutorial"
                     **/
                    if (feature == 'ff_employeeFeedback') {
                        this.employeeFlag.next('ff_employeeFeedback');
                        return;
                    }
                    ;
                    if (feature == 'ff_singleCardTest') {
                        // saves value of ff_singleCardTest, true or false. If not found, default set to false above
                        ff_singleCardTest = val[feature];
                        return;
                    }
                    ;
                    trueFlagArray.push(feature);
                }
            });
            if (trueFlagArray.includes('ff_reEntryTile') &&
                trueFlagArray.length == 2 &&
                !trueFlagArray.includes('ff_PGLCardFull') &&
                !trueFlagArray.includes('ff_PGLMultiCardFull')) {
                this.reEntryValue = true;
                this.reEntryTile.next('ff_reEntryTile');
            }
            trueFlagArray = trueFlagArray.filter(id => id !== 'ff_reEntryTile');
            activeFlag = trueFlagArray[0];
            if (trueFlagArray.length == 1) {
                returnValue = true;
            }
            // Check if the tutorial flag is non PGL, gold/CPC/single card flavors and emit tutorial after
            const customFlag = this.getCustomerBrandingFlag(spbs, activeFlag);
            if (activeFlag === 'ff_NonPGLUser') {
                const hasSBOB = spbs.hasOwnProperty('hasSBOB') ? spbs.hasSBOB === 'Y' : false;
                if (ff_singleCardTest && (spbs.serviceLinksBean.isSingleCardSPF === 'Y') && !hasSBOB) {
                    this.activeTutorial.next('ff_NonPGLUser_singleAccountDetail');
                }
                else if (!ff_singleCardTest && (spbs.serviceLinksBean.isSingleCardSPF === 'Y') && !hasSBOB) {
                    this.activeTutorial.next('ff_NonPGLUser_singleSummary');
                }
                else {
                    //standard welcome to dashboard 2.0 tutorial, CPC and gold flavors
                    this.activeTutorial.next(customFlag);
                }
            }
            else if (activeFlag === 'ff_reImagine' || activeFlag === 'ff_newCardLite') {
                //console.log(customFlag)
                this.activeTutorial.next(customFlag);
            }
            else {
                this.activeTutorial.next(activeFlag);
            }
        });
        return returnValue;
    }
    ;
    /**
     * Checks if the customer is a cpc/citigold customer with or without investment accounts
     */
    getCustomerBrandingFlag(sessionStorageResponse, activeTutorial) {
        const isCPC = sessionStorageResponse.userBranding === 'CPC';
        const isGold = sessionStorageResponse.userBranding?.toUpperCase() === 'GOLD';
        const isPriority = sessionStorageResponse.userBranding?.toUpperCase() === 'PRIORITY';
        const hasInvestmentAccounts = sessionStorageResponse.hasBrokerage === 'Y' && sessionStorageResponse.isInvestor === 'Y';
        switch (activeTutorial) {
            case 'ff_NonPGLUser':
                if (isCPC && hasInvestmentAccounts)
                    return 'ff_NonPGLUser_cpcWithInvest';
                else if (isCPC && !hasInvestmentAccounts)
                    return 'ff_NonPGLUser_cpc';
                else if (isGold && hasInvestmentAccounts)
                    return 'ff_NonPGLUser_goldWithInvest';
                else if (isGold && !hasInvestmentAccounts)
                    return 'ff_NonPGLUser_gold';
                else if (isPriority)
                    return 'ff_NonPGLUser_priority';
                else
                    return 'ff_NonPGLUser';
            case 'ff_reImagine':
                if (isGold)
                    return 'ff_reImagine_gold';
                else
                    return 'ff_reImagine_cpc';
            case 'ff_newCardLite':
                const newCardObj = { 89: 'premier', 142: 'double_cash', 202: 'simplicity', 257: 'diamond_preferred', 408: 'rewards_plus' };
                for (let account of sessionStorageResponse.accounts) {
                    if (newCardObj[account.pcodId]) {
                        return `${activeTutorial}_${newCardObj[account.pcodId]}`;
                    }
                }
        }
    }
    /**
     * Fix for PROD INC. Duplicate logic below, will fix when we migrate from tour -> tour2
     * @param flag
     */
    oneStepFeatureFlag(flag = "ff_reImagineBluePriority") {
        let returnVal;
        let featureFlags;
        if (sessionStorage && sessionStorage['sessionPostBrandingStorage']) {
            featureFlags = JSON.parse(sessionStorage['sessionPostBrandingStorage']).featureFlags;
            returnVal = false;
            if (featureFlags[flag] == 'Y') {
                returnVal = true;
                this.activeOneStep.next(flag);
            }
        }
        else {
            this._cbolCoreConfigService.getSessionPostObservable().subscribe(spbs => {
                featureFlags = spbs.featureFlags;
                returnVal = false;
                if (featureFlags[flag] == 'Y') {
                    returnVal = true;
                    this.activeOneStep.next(flag);
                }
            });
        }
        return returnVal;
    }
    updateOneStepBackend(label, tutorial_title) {
        let actionEnum;
        actionEnum = 'FINISHED';
        let putUserActionRequest = {
            applicationId: 'CBOL',
            requestType: 'TUTORIALS',
            tutorial: {
                action: actionEnum,
                id: tutorial_title
            }
        };
        this._httpService
            .put('/digital/userActions/update', putUserActionRequest)
            .subscribe(val => {
            //set cookie to supress a subsequent modal during the same session.
            const now = new Date();
            const expDate = new Date(now.getTime() + 60 * 60 * 1000); //cookie will expire after 60 minutes, * 60 seconds per minute, * 1000 ms per second
            Cookie.set('ts', 'y', expDate, '/', '.citi.com', true);
        });
    }
    updateBackend(label, tutorial_title) {
        let actionEnum;
        // other parts of this service create 'flavors' of ff_NonPGLUser tutorials (gold, cpc, single account, etc).
        // This conditional updates the tutorial title so the backend only receives one of the existing flags
        // ff_NonPGLUser_gold becomes ff_NonPGLUser, etc.
        tutorial_title.includes("ff_NonPGLUser") ? tutorial_title = "ff_NonPGLUser" : null;
        tutorial_title.includes("ff_reImagine") ? tutorial_title = "ff_reImagine" : null;
        tutorial_title.includes("ff_newCardLite") ? tutorial_title = "ff_newCardLite" : null;
        // if a user closes the opening modal or one of the mini-modal steps before the final modal, send put request to enable re-entry tile
        if (label == "closeStartingModals") {
            // make sure we are not in a single modal tutorial case
            // ff_PGLMultiCardFull and ff_PGLCardFull will only show as a asingle modal with no steps
            if (tutorial_title != "ff_PGLMultiCardFull" && tutorial_title != "ff_PGLCardFull" && tutorial_title != "ff_ATTCardFull" && tutorial_title != "ff_productsOffersWildfireTutorial") {
                actionEnum = 'ENABLE';
                tutorial_title = 'ff_reEntryTile';
            }
            else {
                actionEnum = 'FINISHED';
            }
        }
        else if (label == "remindLater") {
            actionEnum = 'REMINDLATER';
            tutorial_title != "ff_reEntryTile" ? this.updateBackend("remindLater", "ff_reEntryTile") : null;
        }
        else {
            // we are on the final modal and need to send 2 put requests. One for tutorial flag (initial call), one for re-entry tile (recursive call)
            actionEnum = 'FINISHED';
            label == "clearTutorialFlag" ? this.updateBackend("finishReEntryTile", "ff_reEntryTile") : null;
        }
        let putUserActionRequest = {
            applicationId: 'CBOL',
            requestType: 'TUTORIALS',
            tutorial: {
                action: actionEnum,
                id: tutorial_title
            }
        };
        this._httpService
            .put('/digital/userActions/update', putUserActionRequest)
            .subscribe(val => {
            //set cookie to supress a subsequent modal during the same session.
            const now = new Date();
            const expDate = new Date(now.getTime() + 60 * 60 * 1000); //cookie will expire after 60 minutes, * 60 seconds per minute, * 1000 ms per second
            Cookie.set('ts', 'y', expDate, '/', '.citi.com', true);
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TourService, deps: [{ token: i2.HttpService }, { token: CbolCoreConfigService }, { token: SESSION_STORAGE }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TourService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TourService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i2.HttpService }, { type: CbolCoreConfigService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }] });

class TourComponent {
    // @Input() showModal: boolean;
    set showModal(show) {
        this._showModal = show;
    }
    constructor(window, _document, _renderer, _tour, _httpService, _cookieService, _contentService, _liveAnnouncer, _cbolCoreConfigService, focusMonitor) {
        this.window = window;
        this._document = _document;
        this._renderer = _renderer;
        this._tour = _tour;
        this._httpService = _httpService;
        this._cookieService = _cookieService;
        this._contentService = _contentService;
        this._liveAnnouncer = _liveAnnouncer;
        this._cbolCoreConfigService = _cbolCoreConfigService;
        this.focusMonitor = focusMonitor;
        this.reEntryTileShow = false;
        this.tutorial_title = '';
        this.tourHeader = '';
        this.tourBody = '';
        this.hasImage = false;
        this.selectedNumber = 0;
        this.stepArr = [];
        this.currentIter = 0;
        this.elementArr = [];
        this.enableButton = false;
        this._showModal = false;
        this._showWelcomeModal = false;
        this.positioning = '';
        this.isStartModalContentLoaded = false;
        this.isModalPositionLoaded = false;
        this.navHighlighted = false;
        this.tourComps = [];
        this.buttonArr = [];
        this.doneEvent = new EventEmitter();
        this.exitEvent = new EventEmitter();
        this.clickOutEvent = new EventEmitter();
        this.hellLastModal = false;
        this.isTop = '';
        if (!!window) {
            this.hostname = window.location.origin;
        }
    }
    ngOnInit() {
        this._tour.bs.subscribe(barr => (this.buttonArr = barr));
        this._tour.el.subscribe(earr => {
            this.elsArr = earr;
        });
        this._tour.activeTutorial.subscribe(activeFlag => {
            this.tutorial_title = activeFlag;
        });
        this._tour.reEntryTile.subscribe(val => {
            this.reEntryVal = val;
            if (this.reEntryVal == 'ff_reEntryTile') {
                this.reEntryTileShow = true;
            }
        });
        this._tour.employeeFlag.subscribe(employeeFlag => {
            this.employeeFeedbackFlag = employeeFlag;
        });
    }
    ngAfterViewInit() {
        this.elExists()
            .then(() => {
            if (this._showModal) {
                this._tour.initTour(); // Sort the Tour JSON and then make element array
                this._tour.bs.subscribe(barr => (this.buttonArr = barr));
                this.journeyBox = this._document.getElementById('journeyApp');
                this.goToElement();
            }
        })
            .catch(err => console.error(err));
    }
    ngOnDestroy() {
        this.removeNavClass();
        this._tour.bs.unsubscribe();
        this._tour.el.unsubscribe();
        this._tour.activeTutorial.unsubscribe();
        this._tour.employeeFlag.unsubscribe();
        this._tour.reEntryTile.unsubscribe();
    }
    logChange(e) {
        //
    }
    startTour(show = true) {
        this._showModal = show;
        this.elExists()
            .then(() => {
            this._tour.initTour(); // Sort the Tour JSON and then make element array
            // this._tour.bs.subscribe(barr => (this.buttonArr = barr));
            this.journeyBox = this._document.getElementById('journeyApp');
            this.goToElement();
            // call the sitcat after we make sure the promise is resolved unless
            // the elemnets array is undefined
            this.siteCatOnStartTourStepOverlay();
        })
            .catch(err => console.error(err));
        setTimeout(() => {
            let domActEl = this.nextStep.nativeElement.ownerDocument.activeElement;
            this.nextStep.nativeElement.focus();
            if (document.activeElement !== domActEl) {
                // this.focusMonitor.focusVia(this.nextStep, 'program');
                this.nextStep.nativeElement.focus();
            }
        }, 500);
    }
    //welcome modal methods.
    closeWelcome(eve) {
        this._showWelcomeModal = false;
        //use button text as label to send to site cat tracking
        let label = eve.currentTarget.outerText;
        //cds modal close button returns blank for outertext, so manually set as "x"
        eve.currentTarget.className.includes("cds-modal2-close") ? label = "×" : null;
        this.siteCatOnStartAndEndTour(label); //close tour
        this.updateBackend("closeStartingModals");
    }
    startWelcomeTour() {
        this._showWelcomeModal = false;
        this.startTour();
        this.siteCatOnStartAndEndTour("Start Tutorial");
    }
    reEntryTileTour() {
        this.getContents();
        setTimeout(() => {
            this.startTour();
        }, 1000);
    }
    welcomeTour() {
        this.getContents();
        this._showWelcomeModal = true;
        setTimeout(() => {
            this.siteCatOnOverlay();
        }, 750);
    }
    elExists() {
        const startTime = new Date().getTime();
        return new Promise((resolve, reject) => {
            const timer = setInterval(() => {
                const now = new Date().getTime();
                if (document.getElementsByClassName('loaded').length > 0) {
                    clearInterval(timer);
                    resolve();
                }
                else if (now - startTime >= 30000) {
                    clearInterval(timer);
                    reject();
                }
            }, 50);
        });
    }
    // toggleModal() {
    //   this._showModal = !this._showModal;
    // }
    closeModal() {
        if (this.currentElement) {
            this.removeBFClass();
            this.closeFocusElement = this.currentElement;
            this.currentElement = this.elementArr[0];
            this.currentIter = 0;
            this.journeyBox.classList.remove('thicc-bottom');
            this._showModal = false;
            this.closeFocusElement.focus();
            if (!this.hellLastModal) {
                this.exitEvent.emit(true);
                this.updateBackend("closeStartingModals");
                this.siteCatOnTourSteps("Close");
            }
        }
        else {
            this._showModal = false;
        }
    }
    doneModal(eve) {
        if (this.currentElement) {
            this.removeBFClass();
            this.closeFocusElement = this.currentElement;
            this.currentElement = this.elementArr[0];
            this.currentIter = 0;
            this.journeyBox.classList.remove('thicc-bottom');
            this._showModal = false;
            this.closeFocusElement.focus();
        }
        else {
            this.hellLastModal = false;
            this.doneEvent.emit(true);
        }
        //use button text as label to send to site cat tracking
        let label = eve.currentTarget.outerText;
        //cds button doesn't contain "text", so manually set as "x"
        eve.currentTarget.className.includes("cds-modal2-close") ? label = "×" : null;
        this.updateBackend("clearTutorialFlag");
        this.siteCatOnTourDoneAndBack(label);
    }
    restartTour(event) {
        this.doneModal(event);
        this._showWelcomeModal = true;
    }
    updateBackend(label) {
        this._showWelcomeModal = false;
        this._tour.updateBackend(label, this.tutorial_title);
    }
    backModal() {
        this.hellLastModal = false;
        this._showModal = true;
        this.elExists()
            .then(() => {
            this.currentIter = this._tour.arrForEls.length - 1;
            if (this.currentIter == 0)
                this.enableButton = false;
            this.journeyBox = this._document.getElementById('journeyApp');
            this.goToElement();
        })
            .catch(err => console.error(err));
        this.siteCatOnTourDoneAndBack('Back');
        setTimeout(() => {
            let domActEl = this.previousStep.nativeElement.ownerDocument.activeElement;
            this.previousStep.nativeElement.focus();
            if (document.activeElement !== domActEl) {
                // this.focusMonitor.focusVia(this.previousStep, 'program');
                this.previousStep.nativeElement.focus();
            }
        }, 100);
    }
    bgClose(e) {
        if (e.target === this.modalBG.nativeElement) {
            this.closeModal();
            this.clickOutEvent.emit(true);
        }
    }
    goToElement() {
        if (this._tour.arrForEls.length > 0) {
            this.currentElement = this._document.getElementById(this._tour.arrForEls[this.currentIter].id);
            this.tourHeader = this._tour.arrForEls[this.currentIter].header;
            this.tourBody = this._tour.arrForEls[this.currentIter].content;
            if (this.navHighlighted) {
                this.removeNavClass();
            }
            if (this._tour.arrForEls[this.currentIter].navigation) {
                this.addNavClass();
            }
            if (this._tour.arrForEls[this.currentIter].hasOwnProperty('image')) {
                this.hasImage = true;
                this.tourImg = this._tour.arrForEls[this.currentIter].image;
            }
            else {
                this.hasImage = false;
            }
            this.currentElement.classList.add('bring-forth');
            // Add click event click the element if needed
            if (this._tour.arrForEls[this.currentIter].parentOutput) {
                this._document.getElementById(this._tour.arrForEls[this.currentIter].id).click();
            }
            // If a secondary element is to be highlighted as well, add bring forth to that id
            if (this._tour.arrForEls[this.currentIter].hasOwnProperty('secondaryID')) {
                // let secondEl = this._document.getElementById(
                //   this._tour.arrForButtons[this.currentIter].secondaryID
                // );
                // secondEl.classList.add('bring-forth');
                let mulId = this._tour.arrForEls[this.currentIter].secondaryID;
                mulId.forEach(x => {
                    this._document.getElementById(x)
                        ? this._document.getElementById(x).classList.add('bring-forth')
                        : null;
                });
            }
            setTimeout(() => {
                this.getElLocation();
                this.isModalPositionLoaded = true;
            }, 100);
        }
        else {
            console.log(`this._tour.tourArr is empty: length = ${this._tour.arrForEls.length} see?`);
        }
    }
    advanceElement() {
        this.siteCatOnTourSteps("Next");
        if (this.currentIter == 0) {
            this._liveAnnouncer.announce('Back Button');
        }
        this.enableButton = true;
        this.clickedButton = true;
        if (this.currentIter < this._tour.elementsArr.length - 1) {
            this.currentIter++;
            this.removeBFClass();
            this.goToElement();
            this.siteCatOnStartTourStepOverlay();
        }
        else {
            this.hellLastModal = true;
            this.closeModal();
            // wait untill the done div is displayed
            setTimeout(() => {
                this._tour.arrForEls[this.currentIter].order = this._tour.elementsArr.length + 1;
                this.siteCatOnStartTourStepOverlay();
            }, 0);
        }
        this._tour.refreshElArr(this._tour.tourJSON, JSON.parse(this._tour.tourJSON).elements[this.currentIter].id);
    }
    previousElement() {
        this.siteCatOnTourSteps("Back");
        if (this.currentIter == 1) {
            this.nextStep.nativeElement.focus();
            this.enableButton = false;
        }
        this.clickedButton = false;
        if (this.currentIter > 0) {
            this.currentIter--;
            this.removeBFClass();
            this.goToElement();
        }
        else {
            // it will never go to else case as we blocked disabling going back for first focussed element.
            this.currentIter = this._tour.elementsArr.length - 1;
            this.removeBFClass();
            this.goToElement();
        }
        this._tour.refreshElArr(this._tour.tourJSON, JSON.parse(this._tour.tourJSON).elements[this.currentIter].id);
        setTimeout(() => {
            if (this.currentIter === 0) {
                this.tourPopup.nativeElement.focus();
                let domActEl = this.nextStep.nativeElement.ownerDocument.activeElement;
                if (document.activeElement !== domActEl) {
                    // this.focusMonitor.focusVia(this.nextStep, 'program');
                    this.tourPopup.nativeElement.focus();
                }
            }
        }, 50);
    }
    changeEl(idx) {
        this.currentIter = idx;
        this.removeBFClass();
        this.goToElement();
    }
    // Get El Location determines where the modal should appear
    getElLocation() {
        this.clearPosition(this.modalBody.nativeElement);
        let jBox = this.journeyBox.getBoundingClientRect();
        let box = this.currentElement.getBoundingClientRect();
        let pos = this._tour.arrForEls[this.currentIter].positionBox;
        let halfBoxHeight = Math.floor(Math.abs(Math.floor(box?.top - box?.bottom)) / 2);
        pos ? this.modalPosition(box, pos) : this.modalPosition(box, 'default');
        setTimeout(() => {
            this._liveAnnouncer.announce(`
        Step ${this.currentIter + 1} of ${this.elsArr?.length + 1}.
        heading level 2 ${this.tourHeader}
        ${this.tourBody}
      `);
            switch (this.positioning) {
                case 'bottom': {
                    this.tourPopup.nativeElement.scrollIntoView({ behavior: "auto", block: "end", inline: "nearest" });
                    break;
                }
                case 'top': {
                    this.tourPopup.nativeElement.scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" });
                    break;
                }
                default: {
                    this.tourPopup.nativeElement.scrollIntoView({ behavior: "auto", block: "center", inline: "nearest" });
                    break;
                }
            }
            this._showModal = true;
        }, 50);
    }
    // Are we placing the modal on the left, right, or bottom of the highlighted element?
    modalPosition(highlightedElRect, position) {
        switch (position) {
            case 'bottom': {
                this.modalBody.nativeElement.style.left = `${Math.floor(highlightedElRect.left)}px`;
                this.modalBody.nativeElement.style.top = `${highlightedElRect.top +
                    highlightedElRect.height +
                    25}px`;
                this.positioning = 'bottom';
                break;
            }
            case 'right': {
                this.modalBody.nativeElement.style.left = `${Math.floor(highlightedElRect.right + 25)}px`;
                this.modalBody.nativeElement.style.top = `${highlightedElRect.top}px`;
                this.positioning = 'right';
                break;
            }
            case 'left': {
                this.modalBody.nativeElement.style.right = `${Math.floor(this.currentElement.offsetParent?.offsetWidth - highlightedElRect.left + 25)}px`;
                this.modalBody.nativeElement.style.top = `${highlightedElRect.top}px`;
                this.positioning = 'left';
                break;
            }
            case 'top': {
                let topHeight;
                setTimeout(() => {
                    topHeight = this.modalBody.nativeElement.offsetHeight;
                    this.modalBody.nativeElement.style.left = `${Math.floor(highlightedElRect.left)}px`;
                    this.modalBody.nativeElement.style.top = `${highlightedElRect.top -
                        topHeight -
                        23}px`;
                    this.positioning = 'top';
                    this.isTop = `${topHeight - 18}px`;
                });
                break;
            }
            default: {
                this.modalBody.nativeElement.style.left = `${Math.floor(highlightedElRect.right + 31)}px`;
                this.modalBody.nativeElement.style.top = `${highlightedElRect.top -
                    25}px`;
                this.positioning = 'right';
                break;
            }
        }
    }
    clearPosition(el) {
        this.window.scrollTo(0, 0);
        el.style.top = '';
        el.style.right = '';
        el.style.bottom = '';
        el.style.left = '';
    }
    removeBFClass() {
        // Multiple elements may contain the .bring-forth class
        let bfArr = this._document.querySelectorAll('.bring-forth');
        bfArr.forEach(bfEl => bfEl.classList.remove('bring-forth'));
    }
    removeNavClass() {
        const nav = this._document.querySelector('.primary-header');
        nav.classList.remove('tutorial-nav');
        this.navHighlighted = false;
    }
    addNavClass() {
        const nav = this._document.querySelector('.primary-header');
        nav.classList.add('tutorial-nav');
        this.navHighlighted = true;
    }
    siteCatOnOverlay() {
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `secure|accounts|activity|dashboard:${this.startModalContent?.Header.replace(/<sup>&reg<\/sup>/g, '')}:tutorial:intro`
            };
            window.taggingDataLayer.applicationData('38_3a1TutorialForDashboardIntro', taggingDetails);
        }
    }
    siteCatOnStartAndEndTour(action) {
        let link_name = action;
        if (action == "×") {
            link_name = "Close";
        }
        else if (action == "Start Tutorial") {
            link_name = this.startModalContent?.buttonCTA;
        }
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `secure|accounts|activity|dashboard:${this.startModalContent?.Header.replace(/<sup>&reg<\/sup>/g, '')}:tutorial:intro:link clicked`,
                link_name: link_name
            };
            window.taggingDataLayer.updateEventData('38_3a2TutorialForDashboardIntroLinkClicked', taggingDetails);
        }
    }
    siteCatOnStartTourStepOverlay() {
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `secure|accounts|activity|dashboard:${this.startModalContent?.Header.replace(/<sup>&reg<\/sup>/g, '')}:tutorial:${this.tourHeader}:${this.currentIter + 1}`
            };
            window.taggingDataLayer.applicationData('38_3b1TutorialForDashboardTourStep', taggingDetails);
        }
    }
    siteCatOnTourSteps(steps) {
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `secure|accounts|activity|dashboard:${this.startModalContent?.Header.replace(/<sup>&reg<\/sup>/g, '')}:tutorial:${this.tourHeader}:${this.currentIter + 1}:link clicked`,
                link_name: steps
            };
            window.taggingDataLayer.updateEventData('38_3b2TutorialForDashboardTourStepLinkClicked', taggingDetails);
        }
    }
    siteCatOnTourDoneAndBack(action) {
        let link_name = action;
        if (action == "×") {
            link_name = "Close";
        }
        else if (action == "Back") {
            link_name = "Back";
        }
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `secure|accounts|activity|dashboard:${this.startModalContent?.Header.replace(/<sup>&reg<\/sup>/g, '')}:tutorial:${this.endModalContent?.Header}:${this._tour.arrForButtons.length + 1}:link clicked`,
                link_name: link_name
            };
            window.taggingDataLayer.updateEventData('38_3b2TutorialForDashboardTourStepLinkClicked', taggingDetails);
        }
    }
    getContents() {
        this._contentService.getStaticBundle('cbol_ag_container').subscribe(val => {
            let contentName;
            if (this.tutorial_title.includes('ff_NonPGLUser_single')) {
                contentName = 'copy$$' + 'ff_NonPGLUser_single';
            }
            else if (this.tutorial_title.includes('ff_NonPGLUser_cpc')) {
                contentName = 'copy$$' + 'ff_NonPGLUser_cpc';
            }
            else if (this.tutorial_title.includes('ff_NonPGLUser_gold')) {
                contentName = 'copy$$' + 'ff_NonPGLUser_gold';
            }
            else if (this.tutorial_title.includes('ff_NonPGLUser_priority')) {
                contentName = 'copy$$' + 'ff_NonPGLUser_priority';
            }
            else if (this.tutorial_title.includes('ff_newCardLite')) {
                contentName = 'copy$$' + 'ff_newCardLite';
            }
            else {
                contentName = 'copy$$' + this.tutorial_title;
            }
            let tutorialSeen = !!this._cookieService.getCookie('ts');
            let interstitialSeen = this._cookieService.getCookie('interstitialSeen') == "true";
            // check for reentry tile, previous tutorial, or interstitial to show welcome modal
            if (Object.keys(val).includes(contentName) && !tutorialSeen && !interstitialSeen || this.reEntryTileShow) {
                this.startModalContent = contentName !== 'copy$$ff_newCardLite' ? val[contentName].startModalContent : val[contentName][this.tutorial_title].startModalContent;
                this.isStartModalContentLoaded = true;
                if (!!this.employeeFeedbackFlag && !!val[contentName].endModalContentEmployee) {
                    this.endModalContentEmployee = val[contentName].endModalContentEmployee;
                    this.tellUs = true;
                }
                else {
                    this.endModalContent = val[contentName].endModalContent;
                }
            }
            else {
                this._showWelcomeModal = false;
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TourComponent, deps: [{ token: WINDOW }, { token: DOCUMENT }, { token: i0.Renderer2 }, { token: TourService }, { token: i2.HttpService }, { token: i1.CookieService }, { token: i2.ContentService }, { token: i4$3.LiveAnnouncer }, { token: CbolCoreConfigService }, { token: i4$3.FocusMonitor }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: TourComponent, isStandalone: false, selector: "tour-modal-cbol-core", inputs: { showModal: "showModal", tourComps: "tourComps", tourJSON: "tourJSON" }, outputs: { doneEvent: "doneEvent", exitEvent: "exitEvent", clickOutEvent: "clickOutEvent" }, viewQueries: [{ propertyName: "modalBG", first: true, predicate: ["modalBG"], descendants: true }, { propertyName: "tourPopup", first: true, predicate: ["tourPopup"], descendants: true }, { propertyName: "modalBody", first: true, predicate: ["modalBody"], descendants: true }, { propertyName: "modalPouch", first: true, predicate: ["modalPouch"], descendants: true }, { propertyName: "doneTutorialValue", first: true, predicate: ["doneTut"], descendants: true }, { propertyName: "nextStep", first: true, predicate: ["nextStep"], descendants: true }, { propertyName: "previousStep", first: true, predicate: ["previousStep"], descendants: true }], ngImport: i0, template: "<cds-modal-dialog\n  *ngIf=\"isStartModalContentLoaded\"\n  [(isOpen)]=\"_showWelcomeModal\"\n  [isClosedOnBackdropClick]=\"false\"\n  [isClosedOnEscape]=\"false\"\n  [isRestoreFocusDisabled]=\"true\"\n  [hasFade]=\"true\"\n  [ariaLabel]=\"'Tour Modal'\"\n  (isOpenChange)=\"logChange($event)\"\n  (openStart)=\"logChange('openStart')\"\n  (openEnd)=\"logChange('openEnd')\"\n  (closeStart)=\"logChange('closeStart')\"\n  (closeEnd)=\"logChange('closeEnd')\"\n>\n  <div class=\"cds-modal-dialog-centered\">\n    <div\n      cdsModalInitialFocus\n      role=\"dialog\"\n      class=\"cds-modal2-content\"\n      [ngStyle]=\"{ 'max-width': '820px' }\"\n    >\n      <div\n        class=\"cds-modal2-body\"\n        [ngStyle]=\"{ display: 'flex', padding: 0 }\"\n      >\n        <div\n          class=\"tour-modal-final final-welcome-modal\"\n          [ngStyle]=\"{\n            backgroundImage: startModalContent?.backgroundImg\n              ? 'url(' + hostname + startModalContent?.backgroundImg + ')'\n              : '',\n            height: tutorial_title === 'ff_NonPGLUser_cpc' ? '381px' : ''\n          }\"\n        >\n          <div class=\"lastModalTable\">\n            <div style=\"display: flex;\">\n              <div class=\"welcomeModalBoxOne\">\n                <h1\n                  class=\"cds-modal2-header welcome-header\"\n                  [innerHTML]=\"startModalContent?.Header\"\n                  [ngStyle]=\"{\n                    marginTop: (tutorial_title === 'ff_PGLMultiCardLite' ? '24px' : '') || (tutorial_title === 'ff_AttPointsPlusLite' ? '30px' : '')\n                  }\"\n                ></h1>\n                <p\n                  class=\"subHead cds-modal2-body\"\n                  [innerHTML]=\"startModalContent?.Subhead\"\n                  [ngStyle]=\"{\n                    marginTop: (tutorial_title === 'ff_AttPointsPlusLite' ? '-15px' : '') || (tutorial_title === 'ff_PGLMultiCardLite' ? '-10px' : ''),\n                    marginBottom: tutorial_title === 'ff_PGLMultiCardLite' ? '10px' : ''\n                  }\"\n                ></p>\n                <p\n                  class=\"welcomeModalTextOne cds-modal2-body\"\n                  [innerHTML]=\"startModalContent?.Copy\"\n                ></p>\n                <div\n                  class=\"cds-modal2-footer\"\n                  *ngIf=\"\n                    !(\n                      tutorial_title === 'ff_PGLCardFull' ||\n                      tutorial_title === 'ff_PGLMultiCardFull' ||\n                      tutorial_title === 'ff_ATTCardFull'\n                    );\n                    else pglFull\n                  \"\n                >\n                  <button\n                    cdsCta=\"primary\"\n                    class=\"start-button\"\n                    (click)=\"startWelcomeTour()\"\n                    [innerHTML]=\"startModalContent?.buttonCTA\"\n                  ></button>\n                </div>\n                <ng-template #pglFull>\n                  <div class=\"cds-modal2-footer\">\n                    <button\n                      cdsCta=\"primary\"\n                      [ngStyle]=\"{ minWidth: '160px', fontSize: '14px' }\"\n                      (click)=\"closeWelcome($event)\"\n                    >\n                      Let's Go\n                    </button>\n                  </div>\n                </ng-template>\n              </div>\n              <div\n                [ngClass]=\"{\n                  welcomeImg: true,\n                  pglBlueCard:\n                    tutorial_title === 'ff_PGLCardFull' ||\n                    tutorial_title === 'ff_PGLMultiCardFull' ||\n                    tutorial_title === 'ff_PGLMultiCardLite' ||\n                    tutorial_title === 'ff_ATTCardFull' ||\n                    tutorial_title === 'ff_AttPointsPlusLite'\n                }\"\n                [ngStyle]=\"{\n                  backgroundImage:\n                    'url(' + hostname + startModalContent?.img + ')'\n                }\"\n              >\n                <button\n                  aria-label=\"Close Modal Box\"\n                  class=\"cds-modal2-close close-btn\"\n                  [ngStyle]=\"{marginTop: '16px', marginRight:'16px'}\"\n                  cdsButton=\"secondary\"\n                  buttonIcon=\"icon\"\n                  [JFPToken]=\"false\"\n                  size=\"small\"\n                  (click)=\"closeWelcome($event)\"\n                >\n                  <cds-icon\n                    class=\"close-icon\"\n                    type=\"2021\"\n                    name=\"044-close\"\n                    [svgStyle]=\"{ 'width.px': 20, 'height.px': 20 }\"\n                    aria-hidden=\"true\"\n                  ></cds-icon>\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</cds-modal-dialog>\n\n<section class=\"tour-component\">\n  <div\n    class=\"welcome-banner\"\n    *ngIf=\"!_showModal\"\n  >\n    <ng-content></ng-content>\n  </div>\n\n  <div\n    class=\"tour-bg\"\n    style=\"overflow: visible;\"\n    *ngIf=\"_showModal\"\n    (click)=\"bgClose($event)\"\n    #modalBG\n  >\n    <div class=\"tourLayer boxLayer\"></div>\n    <div\n      class=\"the-modal-itself\"\n      role=\"dialog\"\n      cdkTrapFocus\n      [ngClass]=\"{ 'modal-loaded': isModalPositionLoaded }\"\n    >\n      <div\n        class=\"tour-modal\"\n        #modalBody\n      >\n        <span\n          [id]=\"positioning + 'Triangle'\"\n          [ngStyle]=\"{\n            top: positioning == 'top' ? isTop : null\n          }\"\n        ></span>\n        <div class=\"tour-flex\">\n          <div\n            class=\"tour\"\n            #tourPopup\n          >\n            <div class=\"header-bar\">\n              <h2\n                class=\"tour-header\"\n                [innerHTML]=\"tourHeader\"\n              ></h2>\n              <button\n                aria-label=\"Close Modal Box\"\n                class=\"cds-modal-close cds-close cds-close-light\"\n                (click)=\"closeModal()\"\n              ></button>\n            </div>\n            <div\n              class=\"tour-body\"\n              [innerHTML]=\"tourBody\"\n            ></div>\n            <div class=\"tour-footer\">\n              <div class=\"button-flex\">\n                <div class=\"choice-dots\">\n                  <cds-page-dots\n                    [totalPages]=\"elsArr?.length + 1\"\n                    [currentPage]=\"currentIter + 1\"\n                    announceStr=\"Step\"\n                  ></cds-page-dots>\n                </div>\n                <div class=\"back-next\">\n                  <button\n                    class=\"previous\"\n                    *ngIf=\"enableButton\"\n                    (click)=\"previousElement()\"\n                    #previousStep\n                    [innerHTML]=\"\n                      startModalContent.backText\n                        ? startModalContent.backText\n                        : 'Back'\n                    \"\n                  ></button>\n                  <button\n                    cdsCta=\"primary\"\n                    size=\"small\"\n                    (click)=\"advanceElement()\"\n                    #nextStep\n                    [innerHTML]=\"\n                      startModalContent.nextText\n                        ? startModalContent.nextText\n                        : 'Next'\n                    \"\n                  ></button>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div\n            class=\"tour-img\"\n            *ngIf=\"hasImage\"\n          >\n            <img\n              [src]=\"tourImg.url\"\n              [alt]=\"tourImg.alt\"\n            />\n          </div>\n        </div>\n      </div>\n\n      <div\n        class=\"modal-pouch\"\n        #modalPouch\n      ></div>\n    </div>\n  </div>\n</section>\n<cds-modal-dialog\n  [(isOpen)]=\"hellLastModal\"\n  [isClosedOnBackdropClick]=\"false\"\n  [isClosedOnEscape]=\"false\"\n  [hasFade]=\"true\"\n  [ariaLabel]=\"'Thank You Tour Modal'\"\n>\n  <div class=\"cds-modal-dialog-centered\">\n    <div\n      cdsModalInitialFocus\n      role=\"dialog\"\n      class=\"cds-modal2-content\"\n      [ngStyle]=\"{ 'max-width': '820px' }\"\n    >\n      <div class=\"tourLayer\"></div>\n      <div\n        class=\"tour-modal-final final-modal\"\n        #lastModalBody\n      >\n        <div class=\"lastModalTable\">\n          <div style=\"display: flex\">\n            <div\n              class=\"lastModalBoxOne\"\n              #doneTut\n            >\n              <h1\n                class=\"summary-header cds-modal2-header\"\n                [innerHTML]=\"\n                  !!tellUs\n                    ? endModalContentEmployee?.Header\n                    : endModalContent?.Header\n                \"\n              ></h1>\n              <p\n                class=\"lastModalText cds-modal2-body\"\n                [innerHTML]=\"\n                  !!tellUs\n                    ? endModalContentEmployee?.paragraph1\n                    : endModalContent?.paragraph1\n                \"\n              ></p>\n              <p\n                class=\"lastModalText cds-modal2-body\"\n                [innerHTML]=\"\n                  !!tellUs\n                    ? endModalContentEmployee?.paragraph2\n                    : endModalContent?.paragraph2\n                \"\n              ></p>\n              <div\n                class=\"cds-modal2-footer\"\n                [ngStyle]=\"{paddingLeft:'49px'}\"\n              >\n                <button\n                  class=\"done-button tourSessionTimer\"\n                  cdsButton=\"primary\"\n                  (click)=\"doneModal($event)\"\n                  [innerHTML]=\"\n                    startModalContent?.doneText\n                      ? endModalContent?.doneText\n                      : 'Done'\n                  \"\n                ></button>\n                <button\n                  cdsButton=\"tertiary\"\n                  [ngStyle]=\"{\n                    display: endModalContent?.backText ? 'inline' : 'none',\n                    marginLeft: '0px',\n                    marginRight: '16px'\n                  }\"\n                  (click)=\"backModal()\"\n                  [innerHTML]=\"endModalContent?.backText\"\n                ></button>\n                <button\n                  class=\"restart-Tour-button\"\n                  [ngStyle]=\"{\n                    display: endModalContent?.restartTour ? 'inline' : 'none'\n                  }\"\n                  (click)=\"restartTour($event)\"\n                  [innerHTML]=\"endModalContent?.restartTour\"\n                ></button>\n              </div>\n            </div>\n            <div\n              class=\"bgImg\"\n              [ngStyle]=\"\n                !!tellUs\n                  ? {\n                      backgroundImage:\n                        'url(' +\n                        hostname +\n                        endModalContentEmployee?.doneImg +\n                        ')'\n                    }\n                  : {\n                      backgroundImage:\n                        'url(' + hostname + endModalContent?.doneImg + ')'\n                    }\n              \"\n            >\n              <button\n                aria-label=\"Close Modal Box\"\n                class=\"cds-modal2-close close-btn\"\n                [ngStyle]=\"{marginTop: '16px', marginRight:'16px'}\"\n                cdsButton=\"secondary\"\n                buttonIcon=\"icon\"\n                [JFPToken]=\"false\"\n                size=\"small\"\n                (click)=\"doneModal($event)\"\n              >\n                <cds-icon\n                  class=\"close-icon\"\n                  type=\"2021\"\n                  name=\"044-close\"\n                  [svgStyle]=\"{ 'width.px': 20, 'height.px': 20 }\"\n                  aria-hidden=\"true\"\n                ></cds-icon>\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</cds-modal-dialog>\n<div\n  class=\"loaded\"\n  aria-hidden=\"true\"\n></div>", styles: [".tour-bg{position:absolute;top:0;left:0;width:100%;min-height:100vh;padding-top:75vw;height:100%;overflow:hidden}.tour-modal{box-sizing:border-box;position:absolute;min-width:400px;max-width:600px;background:#f1f1f1;border-radius:10px;box-shadow:0 2px 7px 2px #0003;z-index:11000}.tour-flex{display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center}.tour{box-sizing:border-box;width:100%;padding:30px 30px 14px}.header-bar{display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;margin-bottom:15px}.tour-header{max-width:250px;font-family:Interstate_Bold,sans-serif;font-size:21px;line-height:27px;margin:0;letter-spacing:0;color:#333}.tour-body{font-size:16px;font-weight:200;max-width:360px;margin-bottom:26px;color:#333;font-family:Interstate_Light;letter-spacing:0;line-height:24px}.tour-img{flex-basis:60%;display:flex}.tour-img img{max-width:100%;max-height:100%;overflow:hidden}.button-flex{display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center}.choice-dots{display:flex;flex-flow:row wrap;align-items:center;justify-content:flex-start}.previous,.next{box-sizing:border-box;background:#056dae;color:#fff;font-size:12px;font-weight:700;border:2px solid #056dae;border-radius:10px;padding:4px 30px;font-family:Interstate_Bold;letter-spacing:0;text-align:center;line-height:18px}.next:focus{outline:none!important}.previous:focus{box-shadow:0 2px 2px #00000024,0 1px 5px #0000001f,0 3px 1px -2px #0003}.previous{background:none;color:#056dae;border:0}.tour-footer .ball{box-sizing:border-box;width:8px;height:8px;border:0;border-radius:50%;background:#cecece;padding:0;margin-right:15px;transition:all .6s ease-in-out}.tour-footer .ball.selected{width:20px;border-radius:100px;background:#056dae}.modal-pouch *,.modal-pouch .bring-forth{background:#fff}.mobile-modal{display:none}.bgImg{background-image:url(/citi-branding-assets/tour-images/tour.svg);background-position:right;background-repeat:no-repeat;background-position-x:center;flex-grow:1;background-color:#f0f8ff}.tourLayer{-webkit-box-sizing:content-box;box-sizing:content-box;position:fixed;z-index:10000;border-radius:4px;-webkit-transition:all .3s ease-out;-o-transition:all .3s ease-out;transition:all .3s ease-out}.boxLayer{background:#00000080;top:0;left:0;min-width:100%;min-height:100%}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.lastModalBoxOne{width:380px!important}.welcomeModalBoxOne{width:440px!important}}.closeButton{border:none;background:transparent;font-size:24px;color:#056dae;margin-left:88%;margin-top:1%}.close-button{right:-16px}#rightTriangle{display:block;height:30px;width:30px;background-color:#f1f1f1;border:inherit;position:absolute;top:24px;left:-13px;-webkit-clip-path:polygon(0% 0%,100% 100%,0% 100%);clip-path:polygon(0% 0%,100% 100%,0% 100%);transform:rotate(45deg);border-radius:0 0 0 .4em}#bottomTriangle{display:block;height:30px;width:30px;background-color:#f1f1f1;border:inherit;position:absolute;top:-13px;left:27px;-webkit-clip-path:polygon(0% 0%,100% 100%,0% 100%);clip-path:polygon(0% 0%,100% 100%,0% 100%);transform:rotate(135deg);border-radius:0 0 0 .4em}#topTriangle{display:block;height:30px;width:30px;background-color:#f1f1f1;border:inherit;position:absolute;left:35px;-webkit-clip-path:polygon(0% 0%,100% 100%,0% 100%);clip-path:polygon(0% 0%,100% 100%,0% 100%);transform:rotate(315deg);border-radius:0 0 0 .4em}#leftTriangle{display:block;height:30px;width:30px;background-color:#f1f1f1;border:inherit;position:absolute;top:24px;right:-15px;-webkit-clip-path:polygon(0% 0%,100% 100%,0% 100%);clip-path:polygon(0% 0%,100% 100%,0% 100%);transform:rotate(225deg);border-radius:0 0 0 .4em}.tour-modal-final{box-sizing:border-box;min-width:400px;background:#fff;border-radius:10px;box-shadow:0 2px 7px 2px #0003;z-index:100000000;overflow:hidden;background-size:600px;background-position:577px -97px;background-repeat:no-repeat}.summary-header{margin-top:44px;padding-left:49px;padding-right:51px;font-size:26px;line-height:32px;flex:auto}.done-button{font-size:16px;width:87px;height:56px;padding:16px 24px;border-radius:16px}.restart-Tour-button{box-sizing:border-box;background:#fff;color:#056dae;font-size:15px;font-weight:bolder;border:none;border-radius:10px;font-family:Interstate_Bold;margin-left:20px}.noThanksButton{box-sizing:border-box;background:#fff;color:#056dae;font-size:12px;font-weight:bolder;border:none;border-radius:10px;padding:12px 15px;letter-spacing:0;line-height:18px;font-family:Interstate_Bold}.lastModalText{padding-left:49px;margin-right:13px;font-size:16px;flex:auto;font-family:Interstate_Light}.lastModalBoxOne{width:41%;display:inline-flex;flex-direction:column;background:#fff}.lastModalTable{width:100%}.final-welcome-modal{width:820px}.welcome-header{font-size:42px;display:block;margin-top:40px;margin-bottom:0}.start-button{height:56px;padding:16px 24px;border-radius:16px;font-size:16px}.welcomeImg{background-repeat:no-repeat;background-position-x:center;background-position:center;flex-grow:1}.pglBlueCard{background-position-y:81px}.subHead{color:#333;font-family:Interstate_Light;font-size:16px;letter-spacing:0;line-height:24px;flex:auto}.welcomeModalTextOne{font-size:16px;font-family:Interstate_Bold;line-height:24px;letter-spacing:0;flex:auto}.welcomeModalBoxOne{width:52%;display:inline-flex;flex-direction:column;background:#fff}:host ::ng-deep sup{font-size:18px!important;top:-1.2em;color:#333;height:13px;width:17px;line-height:14px;font-family:Interstate_Light;letter-spacing:0}:host ::ng-deep .bring-forth{box-sizing:border-box!important;position:relative!important;z-index:10500;background:#fff}:host ::ng-deep .tutorial-nav{position:static!important}.the-modal-itself{visibility:hidden;opacity:0;transition:visibility 0s,opacity .5s linear}.modal-loaded{visibility:visible;opacity:1}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i4$3.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "component", type: i7.CdsPageDotsComponent, selector: "cds-page-dots", inputs: ["announceStr", "isclickable", "inverse", "currentPage", "totalPages"], outputs: ["currentPageChange", "totalPagesChange"] }, { kind: "directive", type: i7.CdsCTA, selector: "button[cdsCta],button[cds-cta],a[cdsCta],a[cds-cta]", inputs: ["arrowRight", "arrowLeft", "size", "cdsCta", "customerType", "JFPToken", "ctaHref"], exportAs: ["cdsCta"] }, { kind: "component", type: i7.CdsModalDialogComponent, selector: "cds-modal-dialog", inputs: ["isOpen", "isClosedOnBackdropClick", "isClosedOnEscape", "hasFade", "ariaRole", "isRestoreFocusDisabled", "ariaLabel", "ariaLabelledby", "fadeTime"], outputs: ["isOpenChange", "openStart", "openEnd", "closeStart", "closeEnd"] }, { kind: "directive", type: i7.CdsButton, selector: "button[cdsButton],button[cds-button],a[cdsButton],a[cds-button]", inputs: ["cdsButton", "size", "buttonIcon", "arrowRight", "arrowLeft", "JFPToken"], exportAs: ["cdsButton"] }, { kind: "component", type: i7.CdsIcon, selector: "cds-icon", inputs: ["role", "idStr", "ariaLabel", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "altText", "shade", "name", "pathColor", "circleColor"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TourComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tour-modal-cbol-core', standalone: false, template: "<cds-modal-dialog\n  *ngIf=\"isStartModalContentLoaded\"\n  [(isOpen)]=\"_showWelcomeModal\"\n  [isClosedOnBackdropClick]=\"false\"\n  [isClosedOnEscape]=\"false\"\n  [isRestoreFocusDisabled]=\"true\"\n  [hasFade]=\"true\"\n  [ariaLabel]=\"'Tour Modal'\"\n  (isOpenChange)=\"logChange($event)\"\n  (openStart)=\"logChange('openStart')\"\n  (openEnd)=\"logChange('openEnd')\"\n  (closeStart)=\"logChange('closeStart')\"\n  (closeEnd)=\"logChange('closeEnd')\"\n>\n  <div class=\"cds-modal-dialog-centered\">\n    <div\n      cdsModalInitialFocus\n      role=\"dialog\"\n      class=\"cds-modal2-content\"\n      [ngStyle]=\"{ 'max-width': '820px' }\"\n    >\n      <div\n        class=\"cds-modal2-body\"\n        [ngStyle]=\"{ display: 'flex', padding: 0 }\"\n      >\n        <div\n          class=\"tour-modal-final final-welcome-modal\"\n          [ngStyle]=\"{\n            backgroundImage: startModalContent?.backgroundImg\n              ? 'url(' + hostname + startModalContent?.backgroundImg + ')'\n              : '',\n            height: tutorial_title === 'ff_NonPGLUser_cpc' ? '381px' : ''\n          }\"\n        >\n          <div class=\"lastModalTable\">\n            <div style=\"display: flex;\">\n              <div class=\"welcomeModalBoxOne\">\n                <h1\n                  class=\"cds-modal2-header welcome-header\"\n                  [innerHTML]=\"startModalContent?.Header\"\n                  [ngStyle]=\"{\n                    marginTop: (tutorial_title === 'ff_PGLMultiCardLite' ? '24px' : '') || (tutorial_title === 'ff_AttPointsPlusLite' ? '30px' : '')\n                  }\"\n                ></h1>\n                <p\n                  class=\"subHead cds-modal2-body\"\n                  [innerHTML]=\"startModalContent?.Subhead\"\n                  [ngStyle]=\"{\n                    marginTop: (tutorial_title === 'ff_AttPointsPlusLite' ? '-15px' : '') || (tutorial_title === 'ff_PGLMultiCardLite' ? '-10px' : ''),\n                    marginBottom: tutorial_title === 'ff_PGLMultiCardLite' ? '10px' : ''\n                  }\"\n                ></p>\n                <p\n                  class=\"welcomeModalTextOne cds-modal2-body\"\n                  [innerHTML]=\"startModalContent?.Copy\"\n                ></p>\n                <div\n                  class=\"cds-modal2-footer\"\n                  *ngIf=\"\n                    !(\n                      tutorial_title === 'ff_PGLCardFull' ||\n                      tutorial_title === 'ff_PGLMultiCardFull' ||\n                      tutorial_title === 'ff_ATTCardFull'\n                    );\n                    else pglFull\n                  \"\n                >\n                  <button\n                    cdsCta=\"primary\"\n                    class=\"start-button\"\n                    (click)=\"startWelcomeTour()\"\n                    [innerHTML]=\"startModalContent?.buttonCTA\"\n                  ></button>\n                </div>\n                <ng-template #pglFull>\n                  <div class=\"cds-modal2-footer\">\n                    <button\n                      cdsCta=\"primary\"\n                      [ngStyle]=\"{ minWidth: '160px', fontSize: '14px' }\"\n                      (click)=\"closeWelcome($event)\"\n                    >\n                      Let's Go\n                    </button>\n                  </div>\n                </ng-template>\n              </div>\n              <div\n                [ngClass]=\"{\n                  welcomeImg: true,\n                  pglBlueCard:\n                    tutorial_title === 'ff_PGLCardFull' ||\n                    tutorial_title === 'ff_PGLMultiCardFull' ||\n                    tutorial_title === 'ff_PGLMultiCardLite' ||\n                    tutorial_title === 'ff_ATTCardFull' ||\n                    tutorial_title === 'ff_AttPointsPlusLite'\n                }\"\n                [ngStyle]=\"{\n                  backgroundImage:\n                    'url(' + hostname + startModalContent?.img + ')'\n                }\"\n              >\n                <button\n                  aria-label=\"Close Modal Box\"\n                  class=\"cds-modal2-close close-btn\"\n                  [ngStyle]=\"{marginTop: '16px', marginRight:'16px'}\"\n                  cdsButton=\"secondary\"\n                  buttonIcon=\"icon\"\n                  [JFPToken]=\"false\"\n                  size=\"small\"\n                  (click)=\"closeWelcome($event)\"\n                >\n                  <cds-icon\n                    class=\"close-icon\"\n                    type=\"2021\"\n                    name=\"044-close\"\n                    [svgStyle]=\"{ 'width.px': 20, 'height.px': 20 }\"\n                    aria-hidden=\"true\"\n                  ></cds-icon>\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</cds-modal-dialog>\n\n<section class=\"tour-component\">\n  <div\n    class=\"welcome-banner\"\n    *ngIf=\"!_showModal\"\n  >\n    <ng-content></ng-content>\n  </div>\n\n  <div\n    class=\"tour-bg\"\n    style=\"overflow: visible;\"\n    *ngIf=\"_showModal\"\n    (click)=\"bgClose($event)\"\n    #modalBG\n  >\n    <div class=\"tourLayer boxLayer\"></div>\n    <div\n      class=\"the-modal-itself\"\n      role=\"dialog\"\n      cdkTrapFocus\n      [ngClass]=\"{ 'modal-loaded': isModalPositionLoaded }\"\n    >\n      <div\n        class=\"tour-modal\"\n        #modalBody\n      >\n        <span\n          [id]=\"positioning + 'Triangle'\"\n          [ngStyle]=\"{\n            top: positioning == 'top' ? isTop : null\n          }\"\n        ></span>\n        <div class=\"tour-flex\">\n          <div\n            class=\"tour\"\n            #tourPopup\n          >\n            <div class=\"header-bar\">\n              <h2\n                class=\"tour-header\"\n                [innerHTML]=\"tourHeader\"\n              ></h2>\n              <button\n                aria-label=\"Close Modal Box\"\n                class=\"cds-modal-close cds-close cds-close-light\"\n                (click)=\"closeModal()\"\n              ></button>\n            </div>\n            <div\n              class=\"tour-body\"\n              [innerHTML]=\"tourBody\"\n            ></div>\n            <div class=\"tour-footer\">\n              <div class=\"button-flex\">\n                <div class=\"choice-dots\">\n                  <cds-page-dots\n                    [totalPages]=\"elsArr?.length + 1\"\n                    [currentPage]=\"currentIter + 1\"\n                    announceStr=\"Step\"\n                  ></cds-page-dots>\n                </div>\n                <div class=\"back-next\">\n                  <button\n                    class=\"previous\"\n                    *ngIf=\"enableButton\"\n                    (click)=\"previousElement()\"\n                    #previousStep\n                    [innerHTML]=\"\n                      startModalContent.backText\n                        ? startModalContent.backText\n                        : 'Back'\n                    \"\n                  ></button>\n                  <button\n                    cdsCta=\"primary\"\n                    size=\"small\"\n                    (click)=\"advanceElement()\"\n                    #nextStep\n                    [innerHTML]=\"\n                      startModalContent.nextText\n                        ? startModalContent.nextText\n                        : 'Next'\n                    \"\n                  ></button>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div\n            class=\"tour-img\"\n            *ngIf=\"hasImage\"\n          >\n            <img\n              [src]=\"tourImg.url\"\n              [alt]=\"tourImg.alt\"\n            />\n          </div>\n        </div>\n      </div>\n\n      <div\n        class=\"modal-pouch\"\n        #modalPouch\n      ></div>\n    </div>\n  </div>\n</section>\n<cds-modal-dialog\n  [(isOpen)]=\"hellLastModal\"\n  [isClosedOnBackdropClick]=\"false\"\n  [isClosedOnEscape]=\"false\"\n  [hasFade]=\"true\"\n  [ariaLabel]=\"'Thank You Tour Modal'\"\n>\n  <div class=\"cds-modal-dialog-centered\">\n    <div\n      cdsModalInitialFocus\n      role=\"dialog\"\n      class=\"cds-modal2-content\"\n      [ngStyle]=\"{ 'max-width': '820px' }\"\n    >\n      <div class=\"tourLayer\"></div>\n      <div\n        class=\"tour-modal-final final-modal\"\n        #lastModalBody\n      >\n        <div class=\"lastModalTable\">\n          <div style=\"display: flex\">\n            <div\n              class=\"lastModalBoxOne\"\n              #doneTut\n            >\n              <h1\n                class=\"summary-header cds-modal2-header\"\n                [innerHTML]=\"\n                  !!tellUs\n                    ? endModalContentEmployee?.Header\n                    : endModalContent?.Header\n                \"\n              ></h1>\n              <p\n                class=\"lastModalText cds-modal2-body\"\n                [innerHTML]=\"\n                  !!tellUs\n                    ? endModalContentEmployee?.paragraph1\n                    : endModalContent?.paragraph1\n                \"\n              ></p>\n              <p\n                class=\"lastModalText cds-modal2-body\"\n                [innerHTML]=\"\n                  !!tellUs\n                    ? endModalContentEmployee?.paragraph2\n                    : endModalContent?.paragraph2\n                \"\n              ></p>\n              <div\n                class=\"cds-modal2-footer\"\n                [ngStyle]=\"{paddingLeft:'49px'}\"\n              >\n                <button\n                  class=\"done-button tourSessionTimer\"\n                  cdsButton=\"primary\"\n                  (click)=\"doneModal($event)\"\n                  [innerHTML]=\"\n                    startModalContent?.doneText\n                      ? endModalContent?.doneText\n                      : 'Done'\n                  \"\n                ></button>\n                <button\n                  cdsButton=\"tertiary\"\n                  [ngStyle]=\"{\n                    display: endModalContent?.backText ? 'inline' : 'none',\n                    marginLeft: '0px',\n                    marginRight: '16px'\n                  }\"\n                  (click)=\"backModal()\"\n                  [innerHTML]=\"endModalContent?.backText\"\n                ></button>\n                <button\n                  class=\"restart-Tour-button\"\n                  [ngStyle]=\"{\n                    display: endModalContent?.restartTour ? 'inline' : 'none'\n                  }\"\n                  (click)=\"restartTour($event)\"\n                  [innerHTML]=\"endModalContent?.restartTour\"\n                ></button>\n              </div>\n            </div>\n            <div\n              class=\"bgImg\"\n              [ngStyle]=\"\n                !!tellUs\n                  ? {\n                      backgroundImage:\n                        'url(' +\n                        hostname +\n                        endModalContentEmployee?.doneImg +\n                        ')'\n                    }\n                  : {\n                      backgroundImage:\n                        'url(' + hostname + endModalContent?.doneImg + ')'\n                    }\n              \"\n            >\n              <button\n                aria-label=\"Close Modal Box\"\n                class=\"cds-modal2-close close-btn\"\n                [ngStyle]=\"{marginTop: '16px', marginRight:'16px'}\"\n                cdsButton=\"secondary\"\n                buttonIcon=\"icon\"\n                [JFPToken]=\"false\"\n                size=\"small\"\n                (click)=\"doneModal($event)\"\n              >\n                <cds-icon\n                  class=\"close-icon\"\n                  type=\"2021\"\n                  name=\"044-close\"\n                  [svgStyle]=\"{ 'width.px': 20, 'height.px': 20 }\"\n                  aria-hidden=\"true\"\n                ></cds-icon>\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</cds-modal-dialog>\n<div\n  class=\"loaded\"\n  aria-hidden=\"true\"\n></div>", styles: [".tour-bg{position:absolute;top:0;left:0;width:100%;min-height:100vh;padding-top:75vw;height:100%;overflow:hidden}.tour-modal{box-sizing:border-box;position:absolute;min-width:400px;max-width:600px;background:#f1f1f1;border-radius:10px;box-shadow:0 2px 7px 2px #0003;z-index:11000}.tour-flex{display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center}.tour{box-sizing:border-box;width:100%;padding:30px 30px 14px}.header-bar{display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;margin-bottom:15px}.tour-header{max-width:250px;font-family:Interstate_Bold,sans-serif;font-size:21px;line-height:27px;margin:0;letter-spacing:0;color:#333}.tour-body{font-size:16px;font-weight:200;max-width:360px;margin-bottom:26px;color:#333;font-family:Interstate_Light;letter-spacing:0;line-height:24px}.tour-img{flex-basis:60%;display:flex}.tour-img img{max-width:100%;max-height:100%;overflow:hidden}.button-flex{display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center}.choice-dots{display:flex;flex-flow:row wrap;align-items:center;justify-content:flex-start}.previous,.next{box-sizing:border-box;background:#056dae;color:#fff;font-size:12px;font-weight:700;border:2px solid #056dae;border-radius:10px;padding:4px 30px;font-family:Interstate_Bold;letter-spacing:0;text-align:center;line-height:18px}.next:focus{outline:none!important}.previous:focus{box-shadow:0 2px 2px #00000024,0 1px 5px #0000001f,0 3px 1px -2px #0003}.previous{background:none;color:#056dae;border:0}.tour-footer .ball{box-sizing:border-box;width:8px;height:8px;border:0;border-radius:50%;background:#cecece;padding:0;margin-right:15px;transition:all .6s ease-in-out}.tour-footer .ball.selected{width:20px;border-radius:100px;background:#056dae}.modal-pouch *,.modal-pouch .bring-forth{background:#fff}.mobile-modal{display:none}.bgImg{background-image:url(/citi-branding-assets/tour-images/tour.svg);background-position:right;background-repeat:no-repeat;background-position-x:center;flex-grow:1;background-color:#f0f8ff}.tourLayer{-webkit-box-sizing:content-box;box-sizing:content-box;position:fixed;z-index:10000;border-radius:4px;-webkit-transition:all .3s ease-out;-o-transition:all .3s ease-out;transition:all .3s ease-out}.boxLayer{background:#00000080;top:0;left:0;min-width:100%;min-height:100%}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.lastModalBoxOne{width:380px!important}.welcomeModalBoxOne{width:440px!important}}.closeButton{border:none;background:transparent;font-size:24px;color:#056dae;margin-left:88%;margin-top:1%}.close-button{right:-16px}#rightTriangle{display:block;height:30px;width:30px;background-color:#f1f1f1;border:inherit;position:absolute;top:24px;left:-13px;-webkit-clip-path:polygon(0% 0%,100% 100%,0% 100%);clip-path:polygon(0% 0%,100% 100%,0% 100%);transform:rotate(45deg);border-radius:0 0 0 .4em}#bottomTriangle{display:block;height:30px;width:30px;background-color:#f1f1f1;border:inherit;position:absolute;top:-13px;left:27px;-webkit-clip-path:polygon(0% 0%,100% 100%,0% 100%);clip-path:polygon(0% 0%,100% 100%,0% 100%);transform:rotate(135deg);border-radius:0 0 0 .4em}#topTriangle{display:block;height:30px;width:30px;background-color:#f1f1f1;border:inherit;position:absolute;left:35px;-webkit-clip-path:polygon(0% 0%,100% 100%,0% 100%);clip-path:polygon(0% 0%,100% 100%,0% 100%);transform:rotate(315deg);border-radius:0 0 0 .4em}#leftTriangle{display:block;height:30px;width:30px;background-color:#f1f1f1;border:inherit;position:absolute;top:24px;right:-15px;-webkit-clip-path:polygon(0% 0%,100% 100%,0% 100%);clip-path:polygon(0% 0%,100% 100%,0% 100%);transform:rotate(225deg);border-radius:0 0 0 .4em}.tour-modal-final{box-sizing:border-box;min-width:400px;background:#fff;border-radius:10px;box-shadow:0 2px 7px 2px #0003;z-index:100000000;overflow:hidden;background-size:600px;background-position:577px -97px;background-repeat:no-repeat}.summary-header{margin-top:44px;padding-left:49px;padding-right:51px;font-size:26px;line-height:32px;flex:auto}.done-button{font-size:16px;width:87px;height:56px;padding:16px 24px;border-radius:16px}.restart-Tour-button{box-sizing:border-box;background:#fff;color:#056dae;font-size:15px;font-weight:bolder;border:none;border-radius:10px;font-family:Interstate_Bold;margin-left:20px}.noThanksButton{box-sizing:border-box;background:#fff;color:#056dae;font-size:12px;font-weight:bolder;border:none;border-radius:10px;padding:12px 15px;letter-spacing:0;line-height:18px;font-family:Interstate_Bold}.lastModalText{padding-left:49px;margin-right:13px;font-size:16px;flex:auto;font-family:Interstate_Light}.lastModalBoxOne{width:41%;display:inline-flex;flex-direction:column;background:#fff}.lastModalTable{width:100%}.final-welcome-modal{width:820px}.welcome-header{font-size:42px;display:block;margin-top:40px;margin-bottom:0}.start-button{height:56px;padding:16px 24px;border-radius:16px;font-size:16px}.welcomeImg{background-repeat:no-repeat;background-position-x:center;background-position:center;flex-grow:1}.pglBlueCard{background-position-y:81px}.subHead{color:#333;font-family:Interstate_Light;font-size:16px;letter-spacing:0;line-height:24px;flex:auto}.welcomeModalTextOne{font-size:16px;font-family:Interstate_Bold;line-height:24px;letter-spacing:0;flex:auto}.welcomeModalBoxOne{width:52%;display:inline-flex;flex-direction:column;background:#fff}:host ::ng-deep sup{font-size:18px!important;top:-1.2em;color:#333;height:13px;width:17px;line-height:14px;font-family:Interstate_Light;letter-spacing:0}:host ::ng-deep .bring-forth{box-sizing:border-box!important;position:relative!important;z-index:10500;background:#fff}:host ::ng-deep .tutorial-nav{position:static!important}.the-modal-itself{visibility:hidden;opacity:0;transition:visibility 0s,opacity .5s linear}.modal-loaded{visibility:visible;opacity:1}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.Renderer2 }, { type: TourService }, { type: i2.HttpService }, { type: i1.CookieService }, { type: i2.ContentService }, { type: i4$3.LiveAnnouncer }, { type: CbolCoreConfigService }, { type: i4$3.FocusMonitor }], propDecorators: { showModal: [{
                type: Input
            }], tourComps: [{
                type: Input
            }], tourJSON: [{
                type: Input
            }], doneEvent: [{
                type: Output
            }], exitEvent: [{
                type: Output
            }], clickOutEvent: [{
                type: Output
            }], modalBG: [{
                type: ViewChild,
                args: ['modalBG', { static: false }]
            }], tourPopup: [{
                type: ViewChild,
                args: ['tourPopup', { static: false }]
            }], modalBody: [{
                type: ViewChild,
                args: ['modalBody', { static: false }]
            }], modalPouch: [{
                type: ViewChild,
                args: ['modalPouch', { static: false }]
            }], doneTutorialValue: [{
                type: ViewChild,
                args: ['doneTut', { static: false }]
            }], nextStep: [{
                type: ViewChild,
                args: ['nextStep', { static: false }]
            }], previousStep: [{
                type: ViewChild,
                args: ['previousStep', { static: false }]
            }] } });

const COMPONENTS$2 = [
    CdsCoreModule,
    CdsJampModule,
    CdsPageDotsModule,
    CdsCTAModule,
    CdsModalDialogModule,
    CdsButtonModule,
    CdsIconModule,
    CdsTourModule
];
class TourModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TourModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: TourModule, declarations: [TourComponent], imports: [CommonModule,
            A11yModule, CdsCoreModule,
            CdsJampModule,
            CdsPageDotsModule,
            CdsCTAModule,
            CdsModalDialogModule,
            CdsButtonModule,
            CdsIconModule,
            CdsTourModule], exports: [TourComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TourModule, providers: [TourService], imports: [CommonModule,
            A11yModule, COMPONENTS$2] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TourModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TourComponent],
                    imports: [
                        CommonModule,
                        A11yModule,
                        ...COMPONENTS$2
                    ],
                    exports: [TourComponent],
                    providers: [TourService]
                }]
        }] });

class ChatConfig {
    getConfig() {
        return {
            chatRoutesArray: [
                {
                    parentRoute: 'pinreset', //parent route name as defined in routing file
                    childRoutes: [
                        //child routes
                        {
                            appRoute: 'pinreset/index',
                            journeyName: 'Pinreset',
                            pageDef: 'PinresetHome'
                        },
                        {
                            appRoute: 'pinreset/change',
                            journeyName: 'Pinreset',
                            pageDef: 'PR_ChangePIN'
                        },
                        {
                            appRoute: 'pinreset/reset',
                            journeyName: 'Pinreset',
                            pageDef: 'PR_ResetPIN'
                        },
                        {
                            appRoute: 'pinreset/confirm',
                            journeyName: 'Pinreset',
                            pageDef: 'PR_Confirm'
                        },
                        {
                            appRoute: 'pinreset/error',
                            journeyName: 'Pinreset',
                            pageDef: 'PR_Error'
                        }
                    ]
                },
                {
                    parentRoute: 'contactus',
                    childRoutes: [
                        {
                            appRoute: 'contactus',
                            journeyName: 'contactus',
                            pageDef: 'contact us'
                        }
                    ]
                },
                {
                    parentRoute: 'paperless',
                    childRoutes: [
                        {
                            appRoute: 'paperless/paperless',
                            journeyName: 'Other',
                            pageDef: 'paperlessLanding'
                        },
                        {
                            appRoute: 'paperless/confirmation',
                            journeyName: 'Other',
                            pageDef: 'paperlessConfirmation'
                        }
                    ]
                },
                {
                    parentRoute: 'mrc',
                    childRoutes: [
                        {
                            appRoute: 'mrc/dashboard',
                            journeyName: 'MRCDashboard',
                            pageDef: 'NGA_MRCDASHBOARD'
                        }
                    ]
                },
                {
                    parentRoute: 'servicing',
                    childRoutes: [
                        {
                            appRoute: 'servicing/index?pageName=StatementsAndDocumentServices',
                            journeyName: 'Other',
                            pageDef: 'StatementsAndDocumentServices'
                        },
                        {
                            appRoute: 'servicing/index?pageName=CreditCardServices',
                            journeyName: 'Other',
                            pageDef: 'CreditCardServices'
                        },
                        {
                            appRoute: 'servicing/index?pageName=Settings',
                            journeyName: 'Other',
                            pageDef: 'Settings'
                        },
                        {
                            appRoute: 'servicing/index?pageName=BankingServices',
                            journeyName: 'Other',
                            pageDef: 'BankingServices'
                        },
                        {
                            appRoute: 'servicing/index?pageName=travelServices',
                            journeyName: 'Other',
                            pageDef: 'travelServices'
                        },
                        {
                            appRoute: 'servicing/index?pageName=balanceTransfers',
                            journeyName: 'Balance Transfer',
                            pageDef: 'balanceTransfers'
                        }
                    ]
                },
                {
                    parentRoute: 'citibank-location-finder',
                    childRoutes: [
                        {
                            appRoute: 'citibank-location-finder',
                            journeyName: 'Location Finder',
                            pageDef: 'locationFinder'
                        }
                    ]
                },
                {
                    parentRoute: 'ContactInfo',
                    childRoutes: [
                        {
                            appRoute: 'ContactInfo/Profiles',
                            journeyName: 'Profile Contact Info',
                            pageDef: 'Profile'
                        },
                        {
                            appRoute: 'ContactInfo/index',
                            journeyName: 'Profile Contact Info',
                            pageDef: 'Profile'
                        }
                    ]
                },
                {
                    parentRoute: 'statements',
                    childRoutes: [
                        {
                            appRoute: 'statements',
                            journeyName: 'DocCenter Statements',
                            pageDef: 'statements'
                        }
                    ]
                },
                {
                    parentRoute: 'creditlineincrease',
                    childRoutes: [
                        {
                            appRoute: 'creditlineincrease/creditlineincreaseinput',
                            journeyName: 'Credit Line Increase',
                            pageDef: 'creditlineincreaseinput'
                        },
                        {
                            appRoute: 'creditlineincrease/index',
                            journeyName: 'Credit Line Increase',
                            pageDef: 'creditlineincreasehome'
                        }
                    ]
                },
                {
                    parentRoute: 'forgot-userid-pwd',
                    childRoutes: [
                        {
                            appRoute: 'forgot-userid-pwd/account-type',
                            journeyName: 'FUIP',
                            pageDef: 'FUIP Home'
                        },
                        {
                            appRoute: 'forgot-userid-pwd/bank-account-details',
                            journeyName: 'Other',
                            pageDef: 'FUP Bank account details'
                        },
                        {
                            appRoute: 'forgot-userid-pwd/credit-card-account-details',
                            journeyName: 'FUIP',
                            pageDef: 'FUIP Credit card account details'
                        },
                        {
                            appRoute: 'forgot-userid-pwd/security/multi-factor-auth',
                            journeyName: 'Other',
                            pageDef: 'FUP MFA'
                        },
                        {
                            appRoute: 'forgot-userid-pwd/reset-password',
                            journeyName: 'Other',
                            pageDef: 'FUP Password reset'
                        },
                        {
                            appRoute: 'forgot-userid-pwd/retrieve-user',
                            journeyName: 'Other',
                            pageDef: 'FUP retrieve user'
                        },
                        {
                            appRoute: 'forgot-userid-pwd/security/one-time-pwd',
                            journeyName: 'Other',
                            pageDef: 'FUP one-time-pwd'
                        },
                        {
                            appRoute: 'forgot-userid-pwd/error',
                            journeyName: 'Other',
                            pageDef: 'FUP error'
                        }
                    ]
                },
                {
                    parentRoute: 'user-registration',
                    childRoutes: [
                        {
                            appRoute: 'user-registration/account-details',
                            journeyName: 'Credit Card Registration',
                            pageDef: 'accountDetails'
                        },
                        {
                            appRoute: 'user-registration/user-id-password',
                            journeyName: 'Credit Card Registration',
                            pageDef: 'userId'
                        },
                        {
                            appRoute: 'user-registration/contact-info',
                            journeyName: 'Credit Card Registration',
                            pageDef: 'contactInfo'
                        },
                        {
                            appRoute: 'user-registration/security-questions',
                            journeyName: 'Credit Card Registration',
                            pageDef: 'securityQuestions'
                        },
                        {
                            appRoute: 'user-registration/paperless',
                            journeyName: 'Credit Card Registration',
                            pageDef: 'paperless'
                        },
                        {
                            appRoute: 'user-registration/confirmation',
                            journeyName: 'Credit Card Registration',
                            pageDef: 'confirmation'
                        },
                        {
                            appRoute: 'user-registration/temp-delay',
                            journeyName: 'Credit Card Registration',
                            pageDef: 'tempDelay'
                        },
                        {
                            appRoute: 'user-registration/set-up-online-access',
                            journeyName: 'Credit Card Registration',
                            pageDef: 'accountDetails'
                        }
                    ]
                },
                {
                    parentRoute: 'activate',
                    childRoutes: [
                        {
                            appRoute: 'activate/index',
                            journeyName: 'Activate Card',
                            pageDef: 'activate'
                        }
                    ]
                },
                {
                    parentRoute: 'bank/registration',
                    childRoutes: [
                        {
                            appRoute: 'bank/registration/set-up-online-access',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_Landing'
                        },
                        {
                            appRoute: 'bank/registration/link-userName',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_LinkUserName'
                        },
                        {
                            appRoute: 'bank/registration/user-login',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_UserLogin'
                        },
                        {
                            appRoute: 'bank/registration/verify-identity',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_VerifyIdentity'
                        },
                        {
                            appRoute: 'bank/registration/general-error',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_GeneralError'
                        },
                        {
                            appRoute: 'bank/registration/exceeds-error',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_ExceedsError'
                        },
                        {
                            appRoute: 'bank/registration/authenticate-user',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_AuthenticateUser'
                        },
                        {
                            appRoute: 'bank/registration/product-not-found',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_ProductNotFound'
                        },
                        {
                            appRoute: 'bank/registration/register-business-user',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_RegisterBusinessUser'
                        },
                        {
                            appRoute: 'bank/registration/sbob-tier-selection',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_SbobTierSelection'
                        },
                        {
                            appRoute: 'bank/registration/confirmation',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_Confirmation'
                        },
                        {
                            appRoute: 'bank/registration/security-questions',
                            journeyName: 'bankregistration',
                            pageDef: 'bankRegistration_SecurityQuestions'
                        }
                    ]
                },
                {
                    parentRoute: 'debcaract',
                    childRoutes: [
                        {
                            appRoute: 'debcaract/index',
                            journeyName: 'Debit Card Activation',
                            pageDef: 'Home page'
                        },
                        {
                            appRoute: 'debcaract/confirmation',
                            journeyName: 'Debit Card Activation',
                            pageDef: 'DCA confirmation'
                        },
                        {
                            appRoute: 'debcaract/verify',
                            journeyName: 'Debit Card Activation',
                            pageDef: 'DCA verify'
                        },
                        {
                            appRoute: 'debcaract/noCardsAct',
                            journeyName: 'Debit Card Activation',
                            pageDef: 'DCA noCardsAct'
                        },
                        {
                            appRoute: 'debcaract/error',
                            journeyName: 'Debit Card Activation',
                            pageDef: 'DCA error'
                        },
                        {
                            appRoute: 'debcaract/tempdelay',
                            journeyName: 'Debit Card Activation',
                            pageDef: 'DCA tempdelay'
                        },
                        {
                            appRoute: 'debcaract/hardtempdelay',
                            journeyName: 'Debit Card Activation',
                            pageDef: 'DCA hardtempdelay'
                        },
                        {
                            appRoute: 'debcaract/noCardsAct',
                            journeyName: 'Debit Card Activation',
                            pageDef: 'DCA noCardsAct'
                        }
                    ]
                },
                {
                    parentRoute: 'repcard/cia',
                    childRoutes: [
                        { appRoute: 'repcard/cia/index', journeyName: '', pageDef: '' }
                    ]
                },
                {
                    parentRoute: 'lending',
                    childRoutes: [
                        {
                            appRoute: 'lending/landing',
                            journeyName: 'lending',
                            pageDef: 'landing'
                        },
                        {
                            appRoute: 'lending/error/error',
                            journeyName: 'lending',
                            pageDef: 'error'
                        },
                        {
                            appRoute: 'lending/offers',
                            journeyName: 'lending',
                            pageDef: 'Offers_Page'
                        },
                        {
                            appRoute: 'lending/offers',
                            journeyName: 'lending',
                            pageDef: 'NoOffers_Page'
                        },
                        {
                            appRoute: 'lending/customerInfo',
                            journeyName: 'lending',
                            pageDef: 'Missing_Mandatory_Info_Page'
                        },
                        {
                            appRoute: 'lending/customerInfo',
                            journeyName: 'lending',
                            pageDef: 'Income_Update_Page'
                        },
                        {
                            appRoute: 'lending/apply/input',
                            journeyName: 'lending',
                            pageDef: 'Input_Page'
                        },
                        {
                            appRoute: 'lending/apply/recap',
                            journeyName: 'lending',
                            pageDef: 'Recap_Page'
                        },
                        {
                            appRoute: 'lending/decision',
                            journeyName: 'lending',
                            pageDef: 'Approved_Page'
                        },
                        {
                            appRoute: 'lending/decision',
                            journeyName: 'lending',
                            pageDef: 'Declined_Page'
                        },
                        {
                            appRoute: 'lending/decision',
                            journeyName: 'lending',
                            pageDef: 'Pended_Page'
                        },
                        {
                            appRoute: 'lending/decision',
                            journeyName: 'lending',
                            pageDef: 'Counter-Offer_Page'
                        },
                        {
                            appRoute: 'lending/decision/CO-Approved',
                            journeyName: 'lending',
                            pageDef: 'Counter-Offer_Accepted_Page'
                        },
                        {
                            appRoute: 'lending/decision/CO-Approved',
                            journeyName: 'lending',
                            pageDef: 'Counter_Approved_Page'
                        },
                        {
                            appRoute: 'lending/decision/route',
                            journeyName: 'lending',
                            pageDef: 'Pended_Missing_Info_Page'
                        },
                        {
                            appRoute: 'lending/decision/route',
                            journeyName: 'lending',
                            pageDef: 'Counter-Offer_MissingInfo_page'
                        },
                        {
                            appRoute: 'lending/apply/approval-confirmation',
                            journeyName: 'lending',
                            pageDef: 'Disbursement_Confirmation'
                        },
                        {
                            appRoute: 'lending/decision/upload/id',
                            journeyName: 'lending',
                            pageDef: 'Doc_Upload_Page'
                        },
                        {
                            appRoute: 'lending/decision/upload-confirmation',
                            journeyName: 'lending',
                            pageDef: 'Thank_you_Page'
                        }
                    ]
                },
                {
                    parentRoute: 'CDAccount',
                    childRoutes: [
                        {
                            appRoute: 'CDAccount/userInfo/idverification',
                            journeyName: 'CDAccount',
                            pageDef: 'idverification'
                        },
                        {
                            appRoute: 'CDAccount/userInfo/funding',
                            journeyName: 'CDAccount',
                            pageDef: 'funding'
                        },
                        {
                            appRoute: 'CDAccount/userInfo/confirmation',
                            journeyName: 'CDAccount',
                            pageDef: 'confirmation'
                        },
                        {
                            appRoute: 'CDAccount/userInfo/declined',
                            journeyName: 'CDAccount',
                            pageDef: 'declined'
                        },
                        {
                            appRoute: 'CDAccount/userInfo/pended',
                            journeyName: 'CDAccount',
                            pageDef: 'pended'
                        },
                        {
                            appRoute: 'CDAccount/userInfo/sourceofWealth',
                            journeyName: 'CDAccount',
                            pageDef: 'sourceofWealth'
                        },
                        {
                            appRoute: 'CDAccount/userInfo/bannerOverride',
                            journeyName: 'CDAccount',
                            pageDef: 'bannerOverride'
                        },
                        {
                            appRoute: 'CDAccount/userInfo/error',
                            journeyName: 'CDAccount',
                            pageDef: 'error'
                        },
                        {
                            appRoute: 'CDAccount/userInfo',
                            journeyName: 'CDAccount',
                            pageDef: 'userInfo'
                        }
                    ]
                },
                {
                    parentRoute: 'mortgage/home-lending-officer-finder',
                    childRoutes: [
                        {
                            appRoute: 'mortgage/home-lending-officer-finder/results',
                            journeyName: 'Mortgage Home Lending Offer Finder',
                            pageDef: 'results'
                        },
                        {
                            appRoute: 'mortgage/home-lending-officer-finder/options',
                            journeyName: 'Mortgage Home Lending Offer Finder',
                            pageDef: 'options'
                        }
                    ]
                },
                {
                    parentRoute: 'hlofinder',
                    childRoutes: [
                        {
                            appRoute: 'hlofinder/resultsList',
                            journeyName: 'Home Lending Offer Finder',
                            pageDef: 'resultsList'
                        },
                        {
                            appRoute: 'hlofinder/options',
                            journeyName: 'Home Lending Offer Finder',
                            pageDef: 'options'
                        }
                    ]
                },
                {
                    parentRoute: 'alerts',
                    childRoutes: [
                        {
                            appRoute: 'alerts',
                            journeyName: 'alerts and notifications',
                            pageDef: 'AlertsEnrollManage'
                        }
                    ]
                },
                {
                    parentRoute: 'sow',
                    childRoutes: [
                        {
                            appRoute: 'sow/applicant',
                            journeyName: 'Sow',
                            pageDef: 'applicant'
                        },
                        { appRoute: 'sow/co-app', journeyName: 'Sow', pageDef: 'co-app' },
                        { appRoute: 'sow/success', journeyName: 'Sow', pageDef: 'success' },
                        { appRoute: 'sow/error', journeyName: 'Sow', pageDef: 'error' }
                    ]
                },
                {
                    parentRoute: 'apptsched',
                    childRoutes: [
                        {
                            appRoute: 'apptsched/request/error',
                            journeyName: 'Schedule Appointment',
                            pageDef: 'error'
                        },
                        {
                            appRoute: 'apptsched/request/input',
                            journeyName: 'Schedule Appointment',
                            pageDef: 'input'
                        },
                        {
                            appRoute: 'apptsched/request/review',
                            journeyName: 'Schedule Appointment',
                            pageDef: 'review'
                        },
                        {
                            appRoute: 'apptsched/request/confirm',
                            journeyName: 'Schedule Appointment',
                            pageDef: 'confirm'
                        }
                    ]
                },
                {
                    parentRoute: 'mortgage/rate-notification/unsubscribe',
                    childRoutes: [
                        {
                            appRoute: 'mortgage/rate-notification/unsubscribe/success',
                            journeyName: 'mortgage rate-notification unsubscribe',
                            pageDef: 'success'
                        },
                        {
                            appRoute: 'mortgage/rate-notification/unsubscribe/subscribeError',
                            journeyName: 'mortgage rate-notification unsubscribe',
                            pageDef: 'subscribeError'
                        },
                        {
                            appRoute: 'mortgage/rate-notification/unsubscribe/error',
                            journeyName: 'mortgage rate-notification unsubscribe',
                            pageDef: 'error page'
                        },
                        {
                            appRoute: 'mortgage/rate-notification/unsubscribe/contentError',
                            journeyName: 'mortgage rate-notification unsubscribe',
                            pageDef: 'contentError'
                        }
                    ]
                },
                {
                    parentRoute: 'kyc',
                    childRoutes: [
                        { appRoute: 'kyc', journeyName: 'KYC', pageDef: 'KYC' },
                        { appRoute: 'kyc/index', journeyName: 'KYC', pageDef: 'KYC' }
                    ]
                },
                {
                    parentRoute: 'open-a-bank-account',
                    childRoutes: [
                        {
                            appRoute: 'open-a-bank-account/banking',
                            journeyName: 'Open A Bank Aaccount',
                            pageDef: 'banking'
                        },
                        {
                            appRoute: 'open-a-bank-account/creditcard',
                            journeyName: 'Open A Bank Aaccount',
                            pageDef: 'creditcard'
                        },
                        {
                            appRoute: 'open-a-bank-account/lending',
                            journeyName: 'Open A Bank Aaccount',
                            pageDef: 'lending'
                        }
                    ]
                },
                {
                    parentRoute: 'paypal',
                    childRoutes: [
                        {
                            appRoute: 'paypal/eligibleCards',
                            journeyName: 'Paypal',
                            pageDef: 'eligibleCards'
                        },
                        {
                            appRoute: 'paypal/selectedCards',
                            journeyName: 'Paypal',
                            pageDef: 'selectedCards'
                        },
                        {
                            appRoute: 'paypal/landing',
                            journeyName: 'Paypal',
                            pageDef: 'landing'
                        },
                        {
                            appRoute: 'paypal/paypalError',
                            journeyName: 'Paypal',
                            pageDef: 'paypalError'
                        }
                    ]
                },
                {
                    parentRoute: 'travelNotice',
                    childRoutes: [
                        {
                            appRoute: 'travelNotice/getTravelNotifications',
                            journeyName: 'Travel Notifications',
                            pageDef: 'getTravelNotifications'
                        }
                    ]
                },
                {
                    parentRoute: 'cardservices/acctprefcard',
                    childRoutes: [
                        {
                            appRoute: 'cardservices/acctprefcard',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13003'
                        }
                    ]
                },
                {
                    parentRoute: 'cardservices/securityword',
                    childRoutes: [
                        {
                            appRoute: 'cardservices/securityword',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13003'
                        }
                    ]
                },
                {
                    parentRoute: 'cardservices/pin',
                    childRoutes: [
                        {
                            appRoute: 'cardservices/pin',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13089'
                        }
                    ]
                },
                {
                    parentRoute: 'cardservices/cardrefund',
                    childRoutes: [
                        {
                            appRoute: 'cardservices/cardrefund',
                            journeyName: 'Other',
                            pageDef: 'Credit_Balance_Refund'
                        }
                    ]
                },
                {
                    parentRoute: 'disputes',
                    childRoutes: [
                        {
                            appRoute: 'disputes/disputecenter',
                            journeyName: 'Disputes',
                            pageDef: 'jcbol_disputes_DisputeTracker'
                        },
                        {
                            appRoute: 'disputes/disputecenter/detail',
                            journeyName: 'Disputes',
                            pageDef: 'jcbol_disputes_DisputeTracker'
                        }
                    ]
                },
                {
                    parentRoute: 'communicationPreference',
                    childRoutes: [
                        {
                            appRoute: 'getCommunicationPreference',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13272'
                        }
                    ]
                },
                {
                    parentRoute: 'accountdetails',
                    childRoutes: [
                        {
                            appRoute: 'accountdetails',
                            journeyName: 'Manage my spend',
                            pageDef: 'jcbol_ain_caraccdet_CardADA'
                        }
                    ]
                },
                {
                    parentRoute: 'activateacard',
                    childRoutes: [
                        {
                            appRoute: 'activateacard/activateacardlanding',
                            journeyName: 'Other',
                            pageDef: 'jcbol_cam_carposactdea_Input'
                        },
                        {
                            appRoute: 'activateacard/activateacardconfirm',
                            journeyName: 'Other',
                            pageDef: 'jcbol_cam_carposactdea_Confirm'
                        }
                    ]
                },
                {
                    parentRoute: 'citi-flex-loan',
                    childRoutes: [
                        {
                            appRoute: 'citi-flex-loan/offer-unavailability',
                            journeyName: 'FlexLoan',
                            pageDef: 'CFP_offerUnavailability'
                        },
                        {
                            appRoute: 'citi-flex-loan/customize-loan',
                            journeyName: 'FlexLoan',
                            pageDef: 'CFP_CustomizeLoan'
                        },
                        {
                            appRoute: 'citi-flex-loan/delivery-method',
                            journeyName: 'FlexLoan',
                            pageDef: 'CFP_deliveryMethod'
                        },
                        {
                            appRoute: 'citi-flex-loan/review-loan',
                            journeyName: 'FlexLoan',
                            pageDef: 'CFP_reviewLoan'
                        },
                        {
                            appRoute: 'citi-flex-loan/confirmation',
                            journeyName: 'FlexLoan',
                            pageDef: 'CFP_confirmation'
                        },
                        {
                            appRoute: 'citi-flex-loan/fatal-error',
                            journeyName: 'FlexLoan',
                            pageDef: 'CFP_fatalError'
                        },
                        {
                            appRoute: 'citi-flex-loan/get-loan',
                            journeyName: 'FlexLoanSPA',
                            pageDef: 'flex loan fast funds offer not available'
                        },
                        {
                            appRoute: 'citi-flex-loan/get-loan',
                            journeyName: 'FlexLoanSPA',
                            pageDef: 'flex loan fast funds landing page'
                        },
                        {
                            appRoute: 'citi-flex-loan/get-loan',
                            journeyName: 'FlexLoanSPA',
                            pageDef: 'flex loan fast funds bank confirmation'
                        },
                        {
                            appRoute: 'citi-flex-loan/get-loan',
                            journeyName: 'FlexLoanSPA',
                            pageDef: 'flex loan fast funds check by mail confirmation'
                        },
                        {
                            appRoute: 'citi-flex-loan/get-loan',
                            journeyName: 'FlexLoanSPA',
                            pageDef: 'flex loan fast funds error'
                        },
                        {
                            appRoute: 'citi-flex-loan/get-loan',
                            journeyName: 'FlexLoanSPA',
                            pageDef: 'CFP_addAccount'
                        }
                    ]
                },
                {
                    parentRoute: 'citi-flex-pay',
                    childRoutes: [
                        {
                            appRoute: 'citi-flex-pay/select-transaction',
                            journeyName: 'FlexPay',
                            pageDef: 'flex pay multiple transactions'
                        },
                        {
                            appRoute: 'citi-flex-pay/select-transaction',
                            journeyName: 'FlexPay',
                            pageDef: 'flex pay single transactions'
                        },
                        {
                            appRoute: 'citi-flex-pay/select-transaction',
                            journeyName: 'FlexPay',
                            pageDef: 'flex pay no eligible transactions'
                        },
                        {
                            appRoute: 'citi-flex-pay/choose-duration',
                            journeyName: 'FlexPay',
                            pageDef: 'flex pay choose payment plan'
                        },
                        {
                            appRoute: 'citi-flex-pay/review-selection',
                            journeyName: 'FlexPay',
                            pageDef: 'flex pay review plan'
                        },
                        {
                            appRoute: 'citi-flex-pay/confirmation',
                            journeyName: 'FlexPay',
                            pageDef: 'flex pay review plan confirm'
                        },
                        {
                            appRoute: 'citi-flex-pay/fatal-error',
                            journeyName: 'FlexPay',
                            pageDef: 'flex Pay error'
                        },
                        {
                            appRoute: 'citi-flex-pay/offer-unavailable',
                            journeyName: 'FlexPay',
                            pageDef: 'flex pay not available'
                        },
                        {
                            appRoute: 'citi-flex-pay/select-term',
                            journeyName: 'FlexPaySPA',
                            pageDef: 'flex pay single page landing page'
                        },
                        {
                            appRoute: 'citi-flex-pay/select-term',
                            journeyName: 'FlexPaySPA',
                            pageDef: 'flex pay single page bank confirmation'
                        },
                        {
                            appRoute: 'citi-flex-pay/select-term',
                            journeyName: 'FlexPaySPA',
                            pageDef: 'flex pay single page offer not available'
                        },
                        {
                            appRoute: 'citi-flex-pay/select-term',
                            journeyName: 'FlexPaySPA',
                            pageDef: 'flex pay single page error'
                        }
                    ]
                },
                {
                    parentRoute: 'citiflexsummary',
                    childRoutes: [
                        {
                            appRoute: 'citi-flex-summary/landing',
                            journeyName: 'FlexSummary',
                            pageDef: 'CFP_CitiFlexSummaryHome'
                        },
                        {
                            appRoute: 'citi-flex-summary/error',
                            journeyName: 'FlexSummary',
                            pageDef: 'CFP_CitiFlexSummaryError'
                        }
                    ]
                },
                {
                    parentRoute: 'creditlineincrease',
                    childRoutes: [
                        {
                            appRoute: 'creditlineincrease/creditlineincreaseinput',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13786'
                        },
                        {
                            appRoute: 'creditlineincrease/creditlineincreaseconfirm',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13787'
                        },
                        {
                            appRoute: 'creditlineincrease/creditlineincreaseresult',
                            journeyName: 'Other',
                            pageDef: 'jPublic_14050'
                        },
                        {
                            appRoute: 'creditlineincrease/creditlineincreaseincome',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13068'
                        },
                        {
                            appRoute: 'creditlineincrease/creditlineincreasereferral',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13068'
                        },
                        {
                            appRoute: 'creditlineincrease/creditlineincreasereferralconfirm',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13787'
                        },
                        {
                            appRoute: 'creditlineincrease/creditlineincreasereferralresult',
                            journeyName: 'Other',
                            pageDef: 'jPublic_14050'
                        },
                        {
                            appRoute: 'creditlineincrease/cicreditlineincreaseinput',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13068'
                        },
                        {
                            appRoute: 'creditlineincrease/cicreditlineincreaseconfirm',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13069'
                        },
                        {
                            appRoute: 'creditlineincrease/cicreditlineincreaseresult',
                            journeyName: 'Other',
                            pageDef: 'jPublic_14050'
                        },
                        {
                            appRoute: 'creditlineincrease/cicreditlineincreaseincome',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13068'
                        },
                        {
                            appRoute: 'creditlineincrease/creditlineincreaseerror',
                            journeyName: 'Other',
                            pageDef: 'jPublic_13068'
                        }
                    ]
                },
                {
                    parentRoute: 'secure-message-center',
                    childRoutes: [
                        {
                            appRoute: 'secure-message-center',
                            journeyName: 'Secure Message',
                            pageDef: 'jjba_mc_300'
                        },
                        {
                            appRoute: 'secure-message-center/read-message',
                            journeyName: 'Secure Message',
                            pageDef: 'jjba_mc_110'
                        }
                    ]
                },
                //added part of 2020-01 sprint
                {
                    parentRoute: 'docmanagement',
                    childRoutes: [
                        {
                            appRoute: 'docmangement/ecom',
                            journeyName: 'DocCenter',
                            pageDef: 'NoticeAndLetters'
                        }
                    ]
                },
                //added link-unlink and smartLink part of US DCC-2075
                {
                    parentRoute: 'link-unlink',
                    childRoutes: [
                        {
                            appRoute: 'link-unlink',
                            journeyName: 'Profile Contact Info',
                            pageDef: 'angular manual linking'
                        }
                    ]
                },
                {
                    parentRoute: 'SmartLink',
                    childRoutes: [
                        {
                            appRoute: 'SmartLink',
                            journeyName: 'Profile Contact Info',
                            pageDef: 'SmartLinking'
                        }
                    ]
                },
                //added below payments part of US DCC-2105
                {
                    parentRoute: 'payments',
                    childRoutes: [
                        {
                            appRoute: 'payments/error',
                            journeyName: 'payments',
                            pageDef: 'payments error'
                        },
                        {
                            appRoute: 'payments/crecarpay/input',
                            journeyName: 'payments',
                            pageDef: 'make a payment - start'
                        },
                        {
                            appRoute: 'payments/crecarpay/review',
                            journeyName: 'payments',
                            pageDef: 'make a payment - verify'
                        },
                        {
                            appRoute: 'payments/crecarpay/success',
                            journeyName: 'payments',
                            pageDef: 'make a payment - complete'
                        },
                        {
                            appRoute: 'payments/managepmtacct/input',
                            journeyName: 'payments',
                            pageDef: 'edit upcoming autopay confirmation'
                        },
                        {
                            appRoute: 'payments/edit-next-autopay/input',
                            journeyName: 'payments',
                            pageDef: 'edit upcoming autopay - cutoff time'
                        },
                        {
                            appRoute: 'payments/edit-next-autopay/confirm',
                            journeyName: 'payments',
                            pageDef: 'Recap_Page'
                        },
                        {
                            appRoute: 'payments/autopay/landing',
                            journeyName: 'payments',
                            pageDef: 'manage autopay'
                        },
                        {
                            appRoute: 'payments/autopay/edit',
                            journeyName: 'payments',
                            pageDef: 'edit_autopay_start'
                        },
                        {
                            appRoute: 'payments/autopay/success',
                            journeyName: 'payments',
                            pageDef: 'edit_autopay_complete'
                        },
                        {
                            appRoute: 'payments/autopay/delete',
                            journeyName: 'payments',
                            pageDef: 'remove_autopay_complete'
                        },
                        {
                            appRoute: 'payments/cpdd/input',
                            journeyName: 'payments',
                            pageDef: 'change payment due date - start'
                        },
                        {
                            appRoute: 'payments/cpdd/confirm',
                            journeyName: 'payments',
                            pageDef: 'change payment due date - complete'
                        },
                        {
                            appRoute: 'payments/forbearance/copa',
                            journeyName: 'payments',
                            pageDef: 'forbearance - copa'
                        },
                        {
                            appRoute: 'payments/forbearance/settlement',
                            journeyName: 'payments',
                            pageDef: 'forbearance - settlement'
                        },
                        {
                            appRoute: 'payments/forbearance/catch-up',
                            journeyName: 'payments',
                            pageDef: 'forbearance - catch-up'
                        },
                        {
                            appRoute: 'payments/forbearance/details',
                            journeyName: 'payments',
                            pageDef: 'forbearance - details'
                        },
                        {
                            appRoute: 'payments/forbearance/reage',
                            journeyName: 'payments',
                            pageDef: 'forbearance - reage'
                        },
                        {
                            appRoute: 'payments/forbearance/paydown',
                            journeyName: 'payments',
                            pageDef: 'forbearance - paydown'
                        },
                        {
                            appRoute: 'payments/forbearance/review',
                            journeyName: 'payments',
                            pageDef: 'forbearance - review'
                        },
                        {
                            appRoute: 'payments/forbearance/confirmation',
                            journeyName: 'payments',
                            pageDef: 'forbearance - confirmation'
                        },
                        {
                            appRoute: 'payments/schpayhis/landing',
                            journeyName: 'payments',
                            pageDef: 'payment activity'
                        }
                    ]
                }
            ]
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ChatConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ChatConfig }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ChatConfig, decorators: [{
            type: Injectable
        }] });

class CedricService {
    constructor(appConfigService, _document, _platformId, _window, _cookieService, _cs, _router, windowRefService, location) {
        this.appConfigService = appConfigService;
        this._document = _document;
        this._platformId = _platformId;
        this._window = _window;
        this._cookieService = _cookieService;
        this._cs = _cs;
        this._router = _router;
        this.windowRefService = windowRefService;
        this.location = location;
        this.windowRef = this.windowRefService.nativeWindow;
    }
    init(context) {
        console.log('cedric init', context);
        this.setupCedric(context);
    }
    setupCedric(context) {
        this.environment = this.appConfigService.getConfig('environment');
        const bcCookieName = 'bcsid';
        let bcsid = this.getBCCookie(bcCookieName);
        if (bcsid === '') {
            this.setBCCookie(bcCookieName);
            bcsid = this.getBCCookie(bcCookieName);
        }
        let cedricScriptUrl = '';
        let cedricPlugIn = '';
        let xmsdkScriptUrl = '';
        let staticAssetsUrl = this.appConfigService.getConfig('customConfig').staticAssetsUrl || '';
        let route = '';
        if (isPlatformBrowser(this._platformId)) {
            route = location.href.includes('/US/ag/') ? '/US/ag/' : route;
        }
        if (this.isProd()) {
            cedricScriptUrl = `cbol-core-assets/cedric/cedric.js`;
        }
        else {
            cedricScriptUrl = `cbol-core-assets/cedric/cedrictest.js`;
        }
        console.log('cedric js path', cedricScriptUrl);
        const cedricScript = this._document.createElement('script');
        cedricScript.setAttribute('src', cedricScriptUrl);
        cedricScript.setAttribute('id', 'cedric');
        const aoPages = ['/US/ag/account-opening', '/US/ag/open-cs-acct', '/US/ag/cards/application', '/US/nga/lendingv2/ntc'];
        var currentPageUrl = this._window.location.href;
        let cedricFallback = aoPages.some(aoPath => currentPageUrl.includes(aoPath));
        (!this._document.getElementById('cedric') && !cedricFallback) ? this._document.getElementsByTagName('head')[0].appendChild(cedricScript) : '';
        (!cedricFallback) ? this.changeContextAndSetCsid(context, bcsid) : '';
    }
    changeContextAndSetCsid(context, bcsid) {
        if (this._window) {
            let interval = setInterval(() => {
                if (typeof cdApi !== 'undefined' && typeof cdApi.changeContext === 'function') {
                    cdApi.changeContext(context);
                    console.log('cedric :: cdApi.changeContext', context);
                    cdApi.setCustomerSessionId(bcsid);
                    console.log('cedric :: cdApi.setCustomerSessionId', bcsid);
                    clearInterval(interval);
                }
            }, 100);
        }
    }
    setBCCookie(bcCookieName) {
        const csid = Math.random()
            .toString(16)
            .slice(3)
            .toUpperCase() +
            Math.random()
                .toString(16)
                .slice(3)
                .toUpperCase() +
            Math.random()
                .toString(16)
                .slice(3, 11)
                .toUpperCase();
        console.log('cedric setBCCookie', bcCookieName, csid);
        this._cookieService.setCookie({
            name: bcCookieName,
            value: csid,
            path: '/',
            domain: 'citi.com'
        });
    }
    getBCCookie(cookieName) {
        return this._cookieService.getCookie(cookieName);
    }
    isProd() {
        return this.environment === 'PROD';
    }
    getContext() {
        this.tokenMonitorSubscription = this._router.events
            .pipe(filter(event => {
            return event instanceof GuardsCheckEnd;
        }))
            .subscribe((event) => {
            console.log("detect!", event.urlAfterRedirects);
            let url = event.urlAfterRedirects;
            let contextName = '';
            if (this._window) {
                let href = this._window.location.href;
                if (href.includes("/US/ag")) {
                    console.log("This is for CSR Pages");
                    let capturedStr = event.urlAfterRedirects;
                    if (capturedStr.includes('servicing/index?pageName')) {
                        contextName = 'SERVICING_INDEX_' + capturedStr.substring(1).replace(/\//g, '_').split('=')[1].toUpperCase();
                    }
                    else {
                        let resArr;
                        let removedStr = capturedStr.substring(1).replace(/\//g, '_').split('?')[0];
                        resArr = removedStr.split('_');
                        for (var index in resArr) {
                            if (resArr[index].length > 30) {
                                resArr.splice(parseInt(index), 1);
                            }
                        }
                        contextName = resArr.join('_').toUpperCase();
                    }
                }
                else {
                    contextName = '';
                }
            }
            console.log("context name", contextName);
            this.init(contextName);
        });
    }
    getSSRContext() {
        let contextName = '';
        if (this._window) {
            let href = this._window.location.href;
            if (this._window.location.pathname == '/') {
                console.log('This is for HomePage');
                contextName = 'HOMEPAGE';
            }
            else if (!href.includes('/US/ag')) {
                console.log('This is for SSR Pages');
                let capturedStr = this.location.path();
                if (capturedStr.includes('loginscreenId')) {
                    contextName = capturedStr
                        .substring(1)
                        .replace(/\//g, '_')
                        .split('=')[1]
                        .toUpperCase();
                }
                else {
                    contextName = capturedStr
                        .substring(1)
                        .replace(/\//g, '_')
                        .split('?')[0]
                        .toUpperCase();
                }
            }
            else {
                console.log("context name cannot be passed");
            }
        }
        console.log('ssr context name', contextName);
        this.init(contextName);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CedricService, deps: [{ token: i1.AppConfigService }, { token: DOCUMENT }, { token: PLATFORM_ID }, { token: WINDOW }, { token: i1.CookieService }, { token: i2.ContentService }, { token: i4.Router }, { token: i1.WindowRef }, { token: i1$1.Location }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CedricService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CedricService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.AppConfigService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1.CookieService }, { type: i2.ContentService }, { type: i4.Router }, { type: i1.WindowRef }, { type: i1$1.Location }] });

class MrcdashboardRouteGuard {
    constructor(router) {
        this.router = router;
        this.sessionPostBrandingStorage = this.getSessionPostBrandingStorage();
    }
    /**
     * Decides if a user should be able to navigate to the mrc dashboard or cds dashboard.
     * Other possibility is to redirect to the accountdetails page for limited dashboard use.
     */
    canActivate(route, state) {
        console.log('Trying to hit Path: ', state.url);
        // Check if Guard is used for mrc dashboard, cds dashboard, accountdetails, or accountactivity
        if (state.url.startsWith('/mrc/dashboard')) {
            if (this.getRedirectionUrlMRC()) {
                console.log('Routing to: ', this.redirectionUrl);
                // Redirect to other page.
                this.router.navigate([this.redirectionUrl]);
                return false;
            }
            else {
                // Continue to mrc dashboard
                return true;
            }
        }
        else if (state.url.startsWith('/dashboard')) {
            if (this.isCdsDashboardEligible()) {
                // Continue to cds dashboard
                return true;
            }
            else {
                this.getRedirectionUrlCDS();
                console.log('Routing to: ', this.redirectionUrl);
                // Redirect to other page.
                this.router.navigate([this.redirectionUrl]);
                return false;
            }
        }
        else if (state.url.startsWith('/accountdetails')) {
            if (this.isCdsDashboardEligible()) {
                console.log('Routing to: /dashboard');
                // Redirect to cds dashboard
                this.router.navigate(['/dashboard']);
                return false;
            }
            else {
                // Continue to accountdetails
                return true;
            }
        }
        else if (state.url.startsWith('/accountactivity')) {
            if (this.isCdsDashboardEligible()) {
                console.log('Routing to: /dashboard');
                // Redirect to cds dashboard
                this.router.navigate(['/dashboard']);
                return false;
            }
            else {
                // Continue to accountactivity
                return true;
            }
        }
    }
    /**
     * Sets the redirectionUrl if the customer should be redirected away from the mrc dashboard.
     * Also sets paramerters if they are to be used for passing additional information.
     * Returns a boolean representing if a redirection shoud occur.
     */
    getRedirectionUrlMRC() {
        if (this.isCdsDashboardEligible()) {
            this.redirectionUrl = '/dashboard';
            this.params = undefined;
            return true;
        }
        else if (this.isAccountDetails()) {
            this.redirectionUrl = '/accountdetails';
            this.params = undefined;
            return true;
        }
        else if (this.isAccountActivity()) {
            this.redirectionUrl = '/accountactivity';
            this.params = undefined;
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Sets the redirectionUrl if the customer should be redirected away from the cds dashboard.
     * Also sets paramerters if they are to be used for passing additional information.
     * Returns a boolean representing if a redirection shoud occur.
     */
    getRedirectionUrlCDS() {
        if (this.isAccountDetails()) {
            this.redirectionUrl = '/accountdetails';
            this.params = undefined;
        }
        else if (this.isAccountActivity()) {
            this.redirectionUrl = '/accountactivity';
            this.params = undefined;
        }
        else {
            this.redirectionUrl = '/mrc/dashboard';
            this.params = undefined;
        }
    }
    /**
     * Decides if a customer should be redirected to accountdetails.
     */
    isAccountDetails() {
        if (this.sessionPostBrandingStorage) {
            const customerType = this.sessionPostBrandingStorage['customerType'];
            const hasMultipleCreditCard = this.sessionPostBrandingStorage['hasMultipleCreditCard'];
            if (customerType === 'SPF' &&
                (hasMultipleCreditCard === 'N' || hasMultipleCreditCard === null)) {
                return true;
            }
        }
        return false;
    }
    /**
     * Decides if a customer should be redirected to accountactivity.
     */
    isAccountActivity() {
        return false;
    }
    /**
     * Decides if a customer is eligible to be redirected to cds dashboard.
     *
     * If at least 1 flag under “cds_dashboard_auto” is “TRUE” AND cds_dashboard_enrollment.isDB2OptedOut is “FALSE”
     *
     * OR
     *
     * At least 1 flag under cds_dashboard is “TRUE”
     * AND
     * (cds_dashboard_enrollment.isDB2Whitelisted is “TRUE” OR cds_dashboard_enrollment.isDB2Enrolled is “TRUE”)
     * AND
     * cds_dashboard_enrollment.isDB2OptedOut is “FALSE”
     *
     * THEN redirect user to DB 2.0
     * ELSE redirect user to BAU DB
     */
    isCdsDashboardEligible() {
        let featureFlags = this.sessionPostBrandingStorage['featureFlags'];
        let isCdsDashboard = false;
        const cdsDashboardFlags = [
            "ff_checking",
            "ff_ibs",
            "ff_ibsx",
            "ff_investment",
            "ff_loan",
            "ff_loan_lc",
            "ff_saving",
            "ff_saving_cd",
            "ff_saving_mm"
        ];
        let isCdsDashboardAuto = false;
        const cdsDashboardAutoFlags = [
            "ff_DB2ibsx",
            "ff_db2EligibleNewToCiti",
            "ff_isDB2checking",
            "ff_isDB2ibs",
            "ff_isDB2investment",
            "ff_isDB2loan",
            "ff_isDB2saving",
            "ff_isThrottledCardsOnlyCustomer",
            "ff_pgl"
        ];
        let isCdsDashboardEnrolled = false;
        const cdsDashboardEnrolledFlags = [
            "isDB2Dismissed",
            "isDB2Enrolled",
            "isDB2OptedOut",
            "isDB2Viewed",
            "isDB2Whitelisted"
        ];
        let isCdsDashboardOptedOut = false;
        // Check if any cds_dashboard flags are true
        for (let j = 0; j < cdsDashboardFlags.length; j++) {
            if (featureFlags[cdsDashboardFlags[j]] === "Y") {
                isCdsDashboard = true;
                break;
            }
        }
        // Check if cds_dashboard_auto flag is true
        for (let j = 0; j < cdsDashboardAutoFlags.length; j++) {
            if (featureFlags[cdsDashboardFlags[j]] === "Y") {
                isCdsDashboardAuto = true;
                break;
            }
        }
        // Check if any cds_dashboard_enrolled 'isDB2Enrolled' OR 'isDB2Whitelisted' is true
        if (featureFlags.isDB2Enrolled === "Y" || featureFlags.isDB2Whitelisted === "Y") {
            isCdsDashboardEnrolled = true;
        }
        // Check if isDB2OptedOut
        if (featureFlags.isDB2OptedOut === "Y") {
            isCdsDashboardOptedOut = true;
        }
        // Check if eligible and enrolled
        if ((isCdsDashboardAuto && !isCdsDashboardOptedOut) || (isCdsDashboard && isCdsDashboardEnrolled && !isCdsDashboardOptedOut)) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Obtains the sessionPostBrandingStorage data from sessionStorage in object form.
     * If none exists or a parsing error happens, returns an empty object.
     */
    getSessionPostBrandingStorage() {
        if (sessionStorage.getItem('sessionPostBrandingStorage') !== undefined) {
            try {
                return JSON.parse(sessionStorage.getItem('sessionPostBrandingStorage'));
            }
            catch (error) {
                console.log(error);
            }
        }
        return undefined;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: MrcdashboardRouteGuard, deps: [{ token: i4.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: MrcdashboardRouteGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: MrcdashboardRouteGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i4.Router }] });

class NonFatalErrorRedirectService {
    constructor(route) {
        this.route = route;
    }
    navigateToErrorPage(errorType) {
        this.route.navigateByUrl('/error?errorCode=' + errorType);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NonFatalErrorRedirectService, deps: [{ token: i4.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NonFatalErrorRedirectService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NonFatalErrorRedirectService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i4.Router }] });

class CustomPreloaderService {
    preload(route, load) {
        if (route.data && route.data.preload) {
            return load();
        }
        else {
            return of(null);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CustomPreloaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CustomPreloaderService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CustomPreloaderService, decorators: [{
            type: Injectable
        }] });

class ModalOrchestratorService {
    constructor(_cbolCoreConfigService, _cookieService, _contentService, router, _sessionStorage) {
        this._cbolCoreConfigService = _cbolCoreConfigService;
        this._cookieService = _cookieService;
        this._contentService = _contentService;
        this.router = router;
        this._sessionStorage = _sessionStorage;
        this.icmsEmitter = new BehaviorSubject({});
        // ELIGIBLE_ROUTES = ['/accountdetails', '/mrc/dashboard', '/dashboard', '/home/second-home', '/US/ag/paymentHub/payDashboard', '/dashboard/summary'];
        // ELIGIBLE_WN_ROUTES = ['/dashboard', '/home/second-home', '/dashboard/summary'];
        // ELIGIBLE_MRC_ROUTES = ['/accountdetails', '/mrc/dashboard'];
        // route: string;
        this.WHATS_NEW_VERSION = "CBOL-ANG-2025-08-01";
    }
    // Checks tutorial related flags to prevent WN
    hasValidTutorial() {
        let validTour = false;
        const spbs = JSON.parse(this._sessionStorage.getItem("sessionPostBrandingStorage"));
        if (spbs) {
            let val = spbs.featureFlags;
            if (val.ff_NonPGLUser === "Y" ||
                val.ff_newCardLite === "Y" ||
                val.ff_AttNewCardLite === "Y" ||
                val.ff_ATTCardFull === "Y" ||
                val.ff_AttPointsPlusLite === "Y" ||
                val.ff_PGLMultiCardFull === "Y" ||
                val.ff_PGLMultiCardLite === "Y" ||
                val.ff_PGLCardLite === "Y" ||
                val.ff_PGLCardFull === "Y" ||
                val.ff_LeapFrog === "Y" ||
                val.ff_reImagine === "Y" ||
                val.ff_citiWealthBuilder === "Y" ||
                val.ff_AddExternalAccount === "Y" ||
                val.ff_singleCardEvolutionTutorial === "Y") {
                validTour = true;
            }
        }
        this.devLog('has validTour -->', validTour);
        return validTour;
    }
    isPGLOnlyCard() {
        const spbs = JSON.parse(this._sessionStorage.getItem("sessionPostBrandingStorage"));
        let isPGLonlyCard;
        if (!!spbs.pglAccountStatus) {
            const checkPGLonlyCard = spbs.pglAccountStatus;
            const checkPGLarray = [];
            checkPGLonlyCard.forEach((newStatus) => {
                checkPGLarray.push(newStatus.pglStatus);
            });
            this.devLog('PGL Status Array', checkPGLarray);
            if (checkPGLarray.length == 0) {
                isPGLonlyCard = !!isPGLonlyCard;
                // this.devLog(isPGLonlyCard, 'whats Non PGL Card User');
            }
            else if ((checkPGLarray.includes('INSTANT_AUTH') ||
                checkPGLarray.includes('INSTANT_APPROVED')) &&
                checkPGLarray.includes('READY')) {
                isPGLonlyCard = !!isPGLonlyCard;
                // this.devLog(isPGLonlyCard, 'whats Both PGL-BAU State Present!');
            }
            else if ((checkPGLarray.includes('INSTANT_AUTH') ||
                checkPGLarray.includes('INSTANT_APPROVED')) &&
                !checkPGLarray.includes('READY')) {
                isPGLonlyCard = !isPGLonlyCard;
                // this.devLog(isPGLonlyCard, 'whats Only PGL State Present!');
            }
            else if (!(checkPGLarray.includes('INSTANT_AUTH') ||
                checkPGLarray.includes('INSTANT_APPROVED')) &&
                checkPGLarray.includes('READY')) {
                isPGLonlyCard = !!isPGLonlyCard;
                // this.devLog(isPGLonlyCard, 'Only BAU State Present!');
            }
            else {
                isPGLonlyCard = !!isPGLonlyCard;
                // this.devLog(isPGLonlyCard, 'Invalid PGL Data!');
            }
        }
        else {
            isPGLonlyCard = !!isPGLonlyCard;
            this.devLog('No PGL Object in Session Storage!', isPGLonlyCard);
        }
        return isPGLonlyCard;
    }
    getCustomerType(spbs) {
        if (spbs.userBranding === 'Gold')
            return 'Gold_customerType';
        else if (spbs.userBranding === 'Priority')
            return 'Priority_customerType';
        else if (spbs.userBranding === 'Blue')
            return 'Default_customerType';
        else if (spbs.userBranding === 'CPC' || spbs.cinValuePropCode === '003')
            return 'CPC_customerType';
        else
            return null;
    }
    isTravelEligible(spbs) {
        const travelPids = ["90", "89", "83", "458", "439", "457", "408", "142", "416", "121", "125", "150", "297", "418"];
        return spbs.accounts.some((account) => travelPids.includes(account.pcodId));
    }
    hasNonLiteStatusAcct(spbs) {
        return spbs.pglAccountStatus.some((acct) => acct.pglStatus !== 'INSTANT_AUTH' && acct.pglStatus !== 'INSTANT_APPROVED');
    }
    /**
     * The shouldSeeOneStep method is the entry point for determining if a user is eligible to see the One Step tutorial.
     * First, it gets data from SPBS to determine eligibility.
     * The modal will not show if the user doesn't have the One Step feature flag,
     * or if the ICMS content did not load correctly.
     * @returns boolean
     */
    shouldSeeOneStep() {
        let validTour = this.hasValidTutorial();
        let oneStepFlag = false;
        this._cbolCoreConfigService.getSessionPostObservable().subscribe(spbs => {
            if (spbs) {
                let val = spbs.featureFlags;
                if (val.ff_reImagineBluePriority === 'Y') {
                    if (!validTour) {
                        this.devLog("TOUR: THIS IS ONE STEP FLAG TRUE");
                        return oneStepFlag = true;
                    }
                }
            }
        });
        return oneStepFlag;
    }
    /**
      * The shouldSeeWhatsNew method is the entry point for determining if a user is eligible to see the What's New modal.
      * First, it gets data from ICMS and session storage to determine eligibility.
      * The modal will not show if the user doesn't have the what's new feature flag,
      * if the user has come from a deepdrop or interstitial, tour, ivr, or pgl scenario,
      * or if the ICMS content did not load correctly.
      * @returns Obserbalve containging data if sucessful, or error message if not.
      */
    shouldSeeWhatsNew() {
        return this._contentService.getStaticBundle('cbol_ag_container').pipe(map$1((icms) => {
            const spbs = JSON.parse(this._sessionStorage.getItem("sessionPostBrandingStorage"));
            this.devLog('SPBS -->', spbs);
            this.devLog('ICMS -->', icms);
            // ---------------------------------------------
            //               VERIFY ICMS DATA
            // ---------------------------------------------
            if (!icms) {
                return { success: false, data: {}, error: 'ICMS Data could not be loaded' };
            }
            if (!icms.copy$$whats_new) {
                return { success: false, data: {}, error: 'ICMS does not contain Whats New copy' };
            }
            if (!icms.copy$$whats_new[this.WHATS_NEW_VERSION]) {
                let appVersionsWhatsNew = Object.keys(icms).filter(key => key.startsWith('CBOL-ANG'));
                return { success: false, data: {}, error: `ICMS does not contain Whats New version ${this.WHATS_NEW_VERSION}. Available versions: ${appVersionsWhatsNew}` };
            }
            if (icms.copy$$whats_new.showing !== "true") {
                return { success: false, data: {}, error: 'ICMS set to not show WN' };
            }
            // ---------------------------------------------
            //          Get Feature Flags from SPBS
            // ---------------------------------------------
            if (!spbs) {
                return { success: false, data: {}, error: 'SPBS Data could not be loaded' };
            }
            const flags = spbs.featureFlags;
            if (!flags) {
                return { success: false, data: {}, error: 'SPBS does not contain FF' };
            }
            const hasWhatsNewFlag = (flags.ff_whatsNew === 'Y');
            const isSafeMode = (flags.ff_ibsSafeMode === "Y");
            const reEntryTileVal = (flags.ff_reEntryTile === 'Y');
            const userFullPGL = (flags.ff_PGLCardFull === 'Y') || (flags.ff_PGLMultiCardFull === 'Y');
            const isPGLonlyCard = !!this.isPGLOnlyCard();
            const isPreventedDueToTutorial = !!this.hasValidTutorial();
            // ---------------------------------------------
            //               Get Cookie Data
            // ---------------------------------------------
            const forceWhatsNew = !!this._cookieService.getCookie('forceWhatsNew');
            const isDeepdrop = !!this._cookieService.getCookie('ngaDeepdrop');
            const hadInterstitial = this._cookieService.getCookie('interstitialSeen') == 'true';
            const hadCtaWNSeen = !!this._cookieService.getCookie('ctaWNSeen');
            const tutorialSeen = !!this._cookieService.getCookie('ts');
            // let wpbWelcomeSeen: boolean = !!this._cookieService.getCookie('wpbSeen');
            // let secretWhatsNew: boolean = !!this._cookieService.getCookie('secretWhatsNew');
            // ---------------------------------------------
            //            Identify Customer Type
            // ---------------------------------------------
            const customerType = this.getCustomerType(spbs);
            if (!customerType)
                return { success: false, data: {}, error: 'Customer type not accessible' };
            this.customerType = customerType;
            // Check travel eligibility
            if (this.isTravelEligible(spbs)) {
                this.customerType = 'Travel_customerType';
            }
            // ---------------------------------------------
            //           Standard Checks for WN
            // ---------------------------------------------
            if (forceWhatsNew) {
                return { success: true, data: this.getData(icms), error: `Whats New Deploying due to forceWhatsNew` };
            }
            if (!hasWhatsNewFlag) {
                return { success: false, data: {}, error: 'Whats New FF not set' };
            }
            if (isSafeMode) {
                return { success: false, data: {}, error: 'Whats New prevented due to safeMode' };
            }
            if (isPreventedDueToTutorial) {
                return { success: false, data: {}, error: 'Whats New prevented due to Tutorials' };
            }
            if (isDeepdrop || hadInterstitial || hadCtaWNSeen || tutorialSeen) {
                return { success: false, data: {}, error: `Whats New prevented by Cookie: isDeepdrop=${isDeepdrop}, hadInterstitial=${hadInterstitial}, hadCtaWNSeen=${hadCtaWNSeen} tutorialSeen=${tutorialSeen}` };
            }
            if (isPGLonlyCard || userFullPGL) {
                return { success: false, data: {}, error: 'Whats New prevented due to PGL' };
            }
            this.devLog('Passed Standard WN Checks');
            // ---------------------------------------------
            //         Case-Specific Buisness Logic
            // ---------------------------------------------
            const isCCUser = (spbs.customerType === "SPF");
            const isNonLiteDashboard = this.hasNonLiteStatusAcct(spbs);
            const hasIbsxWN = (flags.ff_ibsxWhatsNew === 'Y');
            if (hasIbsxWN && isNonLiteDashboard) {
                this.devLog('User is Eligible What-New Modal on dashboard 2.0!!');
                return { success: true, data: this.getData(icms), error: null };
            }
            else {
                return { success: false, data: {}, error: (!hasIbsxWN && 'Whats New prevented due specific buisness logic (failed ff_ibsxWhatsNew check)\n') + (!isNonLiteDashboard && 'Whats New prevented as user does not have a non-lite account') };
            }
        }), catchError$1((error) => {
            console.error('Error in shouldSeeWhatsNew:', error);
            return of({ success: false, data: {}, error: 'Whats New: An unexpected error occurred' });
        }));
    }
    /**
     *
     * @param cbol_ag_content
     * @returns object to bre returned with What's New Content
     */
    getData(cbol_ag_content) {
        this.devLog('mod-orc loadElement, icmsEmitter content:', cbol_ag_content);
        // Always 'whats_new' now. Removed all logic for old IVR modals and WPB whats new modals
        let modalData = {
            appVersion: this.WHATS_NEW_VERSION,
            modality: 'whats_new',
            customerType: this.customerType,
            content: cbol_ag_content
        };
        return modalData;
    }
    /**
     * Logs messages to the console only in development mode.
     */
    devLog(...args) {
        if (isDevMode()) {
            console.log('WN:', ...args);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ModalOrchestratorService, deps: [{ token: CbolCoreConfigService }, { token: i1.CookieService }, { token: i2.ContentService }, { token: i4.Router }, { token: SESSION_STORAGE }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ModalOrchestratorService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ModalOrchestratorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: CbolCoreConfigService }, { type: i1.CookieService }, { type: i2.ContentService }, { type: i4.Router }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }] });

class OneStepComponent {
    constructor(window, _document, _tour, _modal_orchestrator_, _cookieService, _contentService, _liveAnnouncer) {
        this.window = window;
        this._document = _document;
        this._tour = _tour;
        this._modal_orchestrator_ = _modal_orchestrator_;
        this._cookieService = _cookieService;
        this._contentService = _contentService;
        this._liveAnnouncer = _liveAnnouncer;
        this.tutorial_title = '';
        this.oneStepHeader = '';
        this.oneStepBody = '';
        this._showOneStep = false;
        this.showPopup = false;
        this.navHighlighted = false;
        this.exitEvent = new EventEmitter();
        this.isInverse = false;
        this.navigation = false;
        if (!!window) {
            this.hostname = window.location.origin;
        }
    }
    ngOnInit() {
        this._tour.activeOneStep.subscribe(activeFlag => {
            this.tutorial_title = activeFlag;
        });
    }
    ngAfterViewInit() {
        this.elExists()
            .then(() => {
            this.setPopup();
        })
            .catch(err => console.error(err));
    }
    ngOnDestroy() {
        this._tour.activeOneStep.unsubscribe();
        if (this.navHighlighted) {
            this.removeNavClass();
        }
    }
    startOneStep() {
        this.elExists()
            .then(() => {
            this.siteCatOnStartOneStep();
        })
            .catch(err => console.error(err));
        setTimeout(() => {
            this.setPopup();
            if (this.navigation) {
                this.addNavClass();
            }
            this.getLiveAnnouncer();
        }, 100);
    }
    welcomeOneStep() {
        if (this._cookieService.getCookie('ts'))
            return;
        setTimeout(() => {
            //console.log("shouldSeeOneStep: " + this._modal_orchestrator_.shouldSeeOneStep());
            if (this._modal_orchestrator_.shouldSeeOneStep()) {
                this._showOneStep = true;
                //this.getContents();
                this.startOneStep();
            }
        }, 1000);
    }
    elExists() {
        const startTime = new Date().getTime();
        return new Promise((resolve, reject) => {
            const timer = setInterval(() => {
                const now = new Date().getTime();
                if (document.getElementsByClassName('loaded').length > 0) {
                    clearInterval(timer);
                    resolve();
                }
                else if (now - startTime >= 30000) {
                    clearInterval(timer);
                    reject();
                }
            }, 50);
        });
    }
    onOneStepClose() {
        if (this.navHighlighted) {
            this.removeNavClass();
        }
        this.updateBackend("clearOneStepFlag");
        this._showOneStep = false;
        this.currentElement.focus();
        this.exitEvent.emit(true);
        this.siteCatOnOneStepClose();
    }
    updateBackend(label) {
        this._tour.updateOneStepBackend(label, this.tutorial_title);
    }
    setPopup() {
        this.currentElement = this._document.getElementById(this.elementId);
        this.oneStepHeader = this.header;
        this.oneStepBody = this.content;
    }
    removeNavClass() {
        const nav = this._document.querySelector('.primary-header');
        nav.classList.remove('tutorial-nav');
        this.navHighlighted = false;
    }
    addNavClass() {
        const nav = this._document.querySelector('.primary-header');
        nav.classList.add('tutorial-nav');
        this.navHighlighted = true;
    }
    getLiveAnnouncer() {
        this._liveAnnouncer.announce(`
      heading level 2 ${this.oneStepHeader} 
      ${this.oneStepBody}
    `);
    }
    //Tagging is commented out until tagging specs are established
    siteCatOnStartOneStep() {
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `secure|accounts|activity|dashboard:${this.tutorial_title}:tutorial:${this.oneStepHeader}`
            };
            window.taggingDataLayer.applicationData('38_3a1TutorialForDashboardIntro', taggingDetails);
        }
    }
    siteCatOnOneStepClose() {
        let link_name = "close";
        console.log("siteCatOnTourDoneAndBack is successful, link is :" + link_name);
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `secure|accounts|activity|dashboard:${this.tutorial_title}:tutorial:${this.oneStepHeader}`,
                link_name: link_name
            };
            window.taggingDataLayer.updateEventData('38_3b2TutorialForDashboardTourStepLinkClicked', taggingDetails);
        }
    }
    getContents() {
        this._contentService.getStaticBundle('cbol_ag_container').subscribe(val => {
            let contentName;
            contentName = 'copy$$' + this.tutorial_title;
            let tutorialSeen = !!this._cookieService.getCookie('ts');
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: OneStepComponent, deps: [{ token: WINDOW }, { token: DOCUMENT }, { token: TourService }, { token: ModalOrchestratorService }, { token: i1.CookieService }, { token: i2.ContentService }, { token: i4$3.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: OneStepComponent, isStandalone: false, selector: "one-step-modal-cbol-core", inputs: { header: "header", content: "content", elementId: "elementId", popupPosition: "popupPosition", popupWidth: "popupWidth", isInverse: "isInverse", navigation: "navigation" }, outputs: { exitEvent: "exitEvent" }, viewQueries: [{ propertyName: "popup", first: true, predicate: ["popup"], descendants: true }], ngImport: i0, template: "<div *ngIf=\"_showOneStep\">\n  <cds-popup2\n    class=\"cds-popup2-single-step\"\n    #popup\n    idStr=\"tourpopup\"\n    [popupHost]=\"currentElement\"\n    [(show)]=\"_showOneStep\"\n    (showChange)=\"onOneStepClose()\"\n    [isInverse]=\"isInverse\"\n    [position]=\"popupPosition\"\n    [maxWidth]=\"popupWidth\"\n    [titleText]=\"oneStepHeader\"\n    [isKeptOpenOnScrollResize]=\"true\"\n    [isKeptOpenOnOutsideClick]=\"true\"\n    [isKeptOpenOnFocusout]=\"true\"\n    [isKeptOpenOnEscape]=\"true\"\n  >\n    <div class=\"onestep-body\" [innerHTML]=\"oneStepBody\"></div>\n  </cds-popup2>\n</div>\n<div class=\"loaded\" aria-hidden=\"true\"></div>\n", styles: [".onestep-body{font-size:16px;font-weight:300;font-family:Interstate_Light;line-height:24px}:host ::ng-deep .tutorial-nav{position:static!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7.CdsPopup2Component, selector: "cds-popup2", inputs: ["closeAriaLabel", "idStr", "isInverse", "isKeptOpenOnEscape", "isKeptOpenOnFocusout", "isKeptOpenOnOutsideClick", "isKeptOpenOnScrollResize", "maxWidth", "popupHost", "position", "role", "show", "titleAriaLevel", "titleText"], outputs: ["showChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: OneStepComponent, decorators: [{
            type: Component,
            args: [{ selector: 'one-step-modal-cbol-core', standalone: false, template: "<div *ngIf=\"_showOneStep\">\n  <cds-popup2\n    class=\"cds-popup2-single-step\"\n    #popup\n    idStr=\"tourpopup\"\n    [popupHost]=\"currentElement\"\n    [(show)]=\"_showOneStep\"\n    (showChange)=\"onOneStepClose()\"\n    [isInverse]=\"isInverse\"\n    [position]=\"popupPosition\"\n    [maxWidth]=\"popupWidth\"\n    [titleText]=\"oneStepHeader\"\n    [isKeptOpenOnScrollResize]=\"true\"\n    [isKeptOpenOnOutsideClick]=\"true\"\n    [isKeptOpenOnFocusout]=\"true\"\n    [isKeptOpenOnEscape]=\"true\"\n  >\n    <div class=\"onestep-body\" [innerHTML]=\"oneStepBody\"></div>\n  </cds-popup2>\n</div>\n<div class=\"loaded\" aria-hidden=\"true\"></div>\n", styles: [".onestep-body{font-size:16px;font-weight:300;font-family:Interstate_Light;line-height:24px}:host ::ng-deep .tutorial-nav{position:static!important}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: TourService }, { type: ModalOrchestratorService }, { type: i1.CookieService }, { type: i2.ContentService }, { type: i4$3.LiveAnnouncer }], propDecorators: { exitEvent: [{
                type: Output
            }], header: [{
                type: Input
            }], content: [{
                type: Input
            }], elementId: [{
                type: Input
            }], popupPosition: [{
                type: Input
            }], popupWidth: [{
                type: Input
            }], isInverse: [{
                type: Input
            }], navigation: [{
                type: Input
            }], popup: [{
                type: ViewChild,
                args: ['popup']
            }] } });

const COMPONENTS$1 = [
    CdsCoreModule,
    CdsButtonModule,
    CdsPopup2Module
];
class OneStepModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: OneStepModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: OneStepModule, declarations: [OneStepComponent], imports: [CommonModule,
            A11yModule, CdsCoreModule,
            CdsButtonModule,
            CdsPopup2Module], exports: [OneStepComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: OneStepModule, providers: [TourService], imports: [CommonModule,
            A11yModule, COMPONENTS$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: OneStepModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneStepComponent],
                    imports: [
                        CommonModule,
                        A11yModule,
                        ...COMPONENTS$1
                    ],
                    exports: [OneStepComponent],
                    providers: [TourService]
                }]
        }] });

class Tour2Service {
    constructor(_httpService) {
        this._httpService = _httpService;
    }
    updateBackend(updateData) {
        return this._httpService.put('/digital/userActions/update', updateData);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Tour2Service, deps: [{ token: i2.HttpService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Tour2Service }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Tour2Service, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i2.HttpService }] });

class Tour2Component {
    constructor(_tour, _cookieService) {
        this._tour = _tour;
        this._cookieService = _cookieService;
        this.isInverse = true;
        this.hasWelcomeModal = true;
        this.hasDoneModal = true;
        this.updateFlag = true;
        this.disableTutorialOnInterstital = true;
        this.disableTutorialOnTutorialSeen = true;
        this.appHierarchyTagging = "secure|accounts|activity|dashboard";
        this.tourStart = new EventEmitter();
        this.tourEnd = new EventEmitter();
        this.onWelcomeModalClosed = new EventEmitter();
        this.onWelcomeModalConfirmClicked = new EventEmitter();
        this.onClosePopup = new EventEmitter();
        this.onNextPopup = new EventEmitter();
        this.onBackPopup = new EventEmitter();
        this.onDonePopup = new EventEmitter();
        this.onShowPopup = new EventEmitter();
        this.onDoneModalBack = new EventEmitter();
        this.onDoneModalFinish = new EventEmitter();
        this.onDoneModalClose = new EventEmitter();
        this.unlayerBackground = true;
        this.startMiddleSteps = false;
        this.hideMiddleStepPageDots = false;
        this.showPopup = false;
        this.previousSteps = [];
        this.showDoneModalButton = true;
        this.highlightedElements = [];
        this.maxWidth = "350px";
    }
    ngOnInit() {
        // this._tour.activeTutorial.subscribe(activeFlag => {
        //   this.tutorial_title = activeFlag;
        // });
    }
    /**
     * Starts the tutorial.
     *
     * @param steps
     */
    startTour(steps) {
        if (this.isTutorialDisabled()) {
            console.error("Tutorial execution exited.");
            return; // kick out if tutorial has already been seen this session
        }
        this.title = this.title ? this.title : this.featureFlag; // set the title to the feature flag, if none is given
        this.steps = steps;
        this.setMiddleStepCount();
        this.hideMiddleStepPageDots = this.middleStepCount == 1;
        this.startMiddleSteps = false;
        this.currentStepIndex = 0;
        this.currentStep = steps[this.currentStepIndex];
        this.toggleBackground(true);
        this.processStep(this.currentStep);
        this.tourStart.emit();
    }
    finishTour() {
        this.setTutorialSeenCookie();
        this.tryUpdateBackendFlag();
        this.toggleBackground(false);
        if (this.closeFocusElement)
            this.closeFocusElement.focus();
        this.cleanUp();
        this.tourEnd.emit();
    }
    // preparation before proceeding with the step
    async preProcessStep(step) {
        this.calculateMiddleStepIndex();
    }
    // displays current step
    async processStep(step) {
        this.preProcessStep(this.currentStep);
        if (this.stepStartCallback)
            await this.stepStartCallback();
        // unhighlight elements, if any
        this.unhighlightElements();
        // set header and content
        this.modalHeader = this.currentStep.header;
        this.modalContent = this.currentStep.content;
        this.modalAriaDescription = this.currentStep.ariaDescription;
        this.closeFocusElement = this.currentStep.closeFocusElement ? document.querySelector(this.currentStep.closeFocusElement) : null;
        // tagging
        this.modalHeaderToTag = this.currentStep.customStepHeaderTagging ? this.currentStep.customStepHeaderTagging : this.modalHeader;
        // welcome modal
        if (this.hasWelcomeModal && this.currentStepIndex == 0) {
            this.showWelcomeModal = true;
            this.buttonLabel = this.currentStep.buttonLabel ?? "Start the Tutorial";
            this.modalImage = this.currentStep.modalImage;
            this.modalImageAltText = this.currentStep.modalImageAltText ?? "";
            this.modalImageRole = this.currentStep.modalImageRole;
            this.startModalHeader = this.modalHeader;
            this.siteCatOnOverlay();
        }
        // done modal
        else if (this.hasDoneModal && this.currentStepIndex == this.steps.length - 1) {
            this.showDoneModal = true;
            this.buttonLabel = this.currentStep.buttonLabel ?? "Done";
            this.modalImage = this.currentStep.modalImage;
            this.modalImageAltText = this.currentStep.modalImageAltText ?? "";
            this.modalImageRole = this.currentStep.modalImageRole;
            this.startModalHeader = this.modalHeader;
        }
        // MIDDLE STEP
        else {
            // BACK BUTTON
            // if there is no previous step, don't show back button
            // also, first middle step also does not have a back button
            if (!this.previousStep || (this.currentStepIndex == 1 && this.hasWelcomeModal)) {
                this.showBackButton = false;
            }
            // otherwise, show the back button
            else {
                this.showBackButton = true;
            }
            // NEXT/DONE BUTTON
            // if last step property is true or it's the last step, show Done. Otherwise, show next
            if (this.currentStepIndex == this.steps.length - 1) {
                this.showDoneButton = true;
                this.showNextButton = false;
            }
            else {
                this.showDoneButton = false;
                this.showNextButton = true;
            }
            const targetElement = document.querySelector(this.currentStep.targetSelector);
            // SKIP STEP IF ID NOT FOUND
            if (!targetElement) {
                if (!this.nextStepDirection || this.nextStepDirection == "NEXT")
                    this.gotoNextStep();
                else if (this.nextStepDirection == "BACK")
                    this.gotoPreviousStep();
                return;
            }
            // highlight elements
            this.toggleHighlight(targetElement, true);
            if (this.currentStep.additionalTargetSelectors) {
                this.currentStep.additionalTargetSelectors.forEach(elementSelector => {
                    let currentElement = document.querySelector(elementSelector);
                    if (currentElement)
                        this.toggleHighlight(currentElement, true);
                });
            }
            if (!this.closeFocusElement)
                this.closeFocusElement = targetElement; // sets target element if we didn't set it earlier
            this.tourHost = targetElement;
            this.popupPosition = this.currentStep.position;
            setTimeout(() => {
                this.showPopup = true;
                this.siteCatOnStartTourStepOverlay();
            }, 0);
            this.scrollToElement(targetElement, this.popupPosition);
        }
    }
    closeWelcomeModal() {
        this.showWelcomeModal = false;
        this.onWelcomeModalClosed.emit();
        this.siteCatOnStartAndEndTour('close');
    }
    gotoFirstStep() {
        this.showWelcomeModal = false;
        this.tourStart.emit();
        this.gotoNextStep();
    }
    async gotoNextStep() {
        if (this.stepEndCallback)
            await this.stepEndCallback();
        this.previousStep = this.currentStep;
        this.previousSteps.push(this.previousStep);
        this.previousStepIndex = this.currentStepIndex; // may not need indecies
        this.nextStepDirection = "NEXT";
        this.currentStepIndex++;
        // if no more steps, finish the tutorial
        if (!this.steps[this.currentStepIndex]) {
            this.finishTour();
            return;
        }
        // otherwise, continue
        this.currentStep = this.steps[this.currentStepIndex];
        this.processStep(this.currentStep);
    }
    // goes to previous step
    async gotoPreviousStep() {
        if (this.stepEndCallback)
            await this.stepEndCallback();
        this.currentStep = this.previousSteps.pop();
        this.currentStepIndex = this.steps.indexOf(this.currentStep);
        this.previousStep = this.previousSteps.length >= 1 ? this.previousSteps[this.previousSteps.length - 1] : null;
        this.nextStepDirection = "BACK";
        this.processStep(this.currentStep);
    }
    setCurrentStep(index) {
        try {
            this.currentStep = this.steps[index];
            this.currentStepIndex = index;
        }
        catch (e) {
            this.logError(e);
        }
    }
    // logs and error to the console
    logError(error) {
        console.error("Tutorial error: ", error);
    }
    // highlights / unhighlights an element
    toggleHighlight(element, highlightFlag) {
        // highlight the element
        if (highlightFlag) {
            this.highlight(element);
            this.highlightedElements.push(element);
        }
        // unhighlight the element
        else {
            this.unhighlight(element);
            const index = this.highlightedElements.indexOf(element);
            this.highlightedElements.splice(index);
        }
    }
    // highlight an element
    highlight(element) {
        if (!element.style.position || element.style.position == 'static') {
            element.previousPosition = element.style.position;
            element.style.position = 'relative';
        }
        element.previousZIndex = element.style['z-index'] ? element.style['z-index'] : "";
        element.style['z-index'] = 10001;
    }
    // unhighlight an element
    unhighlight(element) {
        element.style['z-index'] = element.previousZIndex;
        element.style.position = element.previousPosition;
    }
    // unhighlights all highlighted elements
    unhighlightElements() {
        this.highlightedElements.forEach(element => {
            this.unhighlight(element);
        });
        this.highlightedElements = [];
    }
    /**
     * Scrolls to an element. Wrapped in a setTimeout because the tourpopup isn't initialized the same frame it's shown for the first time, which
     * throws errors.
     *
     * @param targetElement
     */
    scrollToElement(targetElement, position) {
        setTimeout(() => {
            let bottomYCoordinate = targetElement.getBoundingClientRect().y + window.scrollY - 10;
            let popupEl = document.getElementById('tourpopup');
            let topYCoordinate = bottomYCoordinate - popupEl.getBoundingClientRect().height;
            let minCoordinate = Math.min(topYCoordinate, bottomYCoordinate);
            //let midPointCoordinate = (bottomYCoordinate - topYCoordinate)/2;
            window.scrollTo({ top: minCoordinate, left: 0, behavior: 'smooth' });
        }, 100);
    }
    // darken background
    toggleBackground(darkenBackground) {
        this.darkBackground = darkenBackground;
        // wait to unlayer the background until the animation finishes
        if (!darkenBackground) {
            setTimeout(() => {
                this.unlayerBackground = true;
            }, 150);
        }
        else {
            this.unlayerBackground = false;
        }
    }
    // determines what middle step we're at for the tracker
    calculateMiddleStepIndex() {
        var stepIndex = this.currentStepIndex + 1; // middle step input starts at 1 instead of 0
        if (this.hasWelcomeModal && stepIndex != 0) {
            stepIndex--;
        }
        this.middleStepIndex = stepIndex;
    }
    // sets middle step count for the pagination
    setMiddleStepCount() {
        let middleStepCount = this.steps.length;
        if (this.hasWelcomeModal)
            middleStepCount--;
        if (this.hasDoneModal)
            middleStepCount--;
        this.middleStepCount = middleStepCount;
        if (middleStepCount < 3) {
            this.maxWidth = "305px";
        }
    }
    // checks for whether or not the tutorial should execute
    isTutorialDisabled() {
        if (this.disableTutorialOnInterstital && this._cookieService.getCookie('interstitialSeen') == "true") {
            return true;
        }
        if (this.disableTutorialOnTutorialSeen && this._cookieService.getCookie('ts')) {
            return true;
        }
        return false;
    }
    cleanUp() {
        this.unhighlightElements();
        this.steps = [];
        this.currentStep = null;
        this.middleStepCount = null;
        this.middleStepIndex = null;
        this.previousStep = null;
        this.previousStepIndex = null;
        this.previousSteps = [];
        this.startMiddleSteps = false;
    }
    //set cookie to supress a subsequent modal during the same session.
    setTutorialSeenCookie() {
        const now = new Date();
        const expDate = new Date(now.getTime() + 60 * 60 * 1000); //cookie will expire after 60 minutes, * 60 seconds per minute, * 1000 ms per second
        Cookie.set('ts', 'y', expDate, '/', '.citi.com', true);
    }
    // decides whether or not the tutorial should update the backend or not
    tryUpdateBackendFlag() {
        if (!this.updateFlag)
            return;
        if (!this.featureFlag) {
            console.error("Tutorial error: No tutorial flag given");
            return;
        }
        // if conditions are met, update the flag
        try {
            this.updateBackendFlag(this.featureFlag);
        }
        catch (e) {
            console.error(`Tutorial error: Failed to update backend flag ${this.featureFlag}.\n`, e);
        }
    }
    // fires the api call for the service to update the feature flag in the backend
    // anyone can access this simple version of the method. Other additions require journey team implementation
    updateBackendFlag(featureFlag = '') {
        if (!featureFlag)
            featureFlag = this.featureFlag;
        if (!featureFlag) {
            console.error("Tutorial error: Update failed");
        }
        // body to send
        let updateObj = {
            applicationId: 'CBOL',
            requestType: 'TUTORIALS',
            tutorial: {
                action: 'FINISHED',
                id: featureFlag
            }
        };
        this._tour.updateBackend(updateObj).subscribe(response => {
            // successful update call
        });
    }
    // WELCOME modal events
    /**
     * Event function for after welcome modal finishes closing.
     */
    onWelcomeModalClose() {
        if (this.startMiddleSteps)
            this.gotoNextStep();
        else
            this.finishTour();
    }
    // after confirm is clicked on the modal
    onWelcomeModalConfirmClick() {
        this.startMiddleSteps = true;
        this.showWelcomeModal = false;
        this.onWelcomeModalConfirmClicked.emit();
        this.siteCatOnStartAndEndTour("Start Tutorial");
    }
    // POPUP Events
    // event for detecting popup change
    onPopupExitClicked() {
        this.showPopup = false;
        this.onClosePopup.emit();
        this.siteCatOnTourSteps("Close");
        this.closeFocusElement.focus();
        this.finishTour();
    }
    onPopupBackClicked() {
        this.showPopup = false;
        this.onBackPopup.emit();
        this.siteCatOnTourSteps("Back");
        this.gotoPreviousStep();
    }
    onPopupNextClicked() {
        this.showPopup = false;
        this.onNextPopup.emit();
        this.siteCatOnTourSteps("Next");
        this.gotoNextStep();
    }
    onPopupDoneClicked() {
        this.showPopup = false;
        this.onDonePopup.emit();
        this.siteCatOnTourDoneAndBack("Done");
        this.finishTour();
    }
    // DONE MODAL Events
    onDoneModalCloseClicked() {
        this.showDoneModal = false;
        this.onDoneModalClose.emit();
        this.siteCatOnTourDoneAndBack('close');
        this.finishTour();
    }
    onDoneModalFinishClicked() {
        this.showDoneModal = false;
        this.onDoneModalFinish.emit();
        this.siteCatOnTourDoneAndBack(this.buttonLabel);
        this.finishTour();
    }
    onDoneModalBackClicked() {
        this.showDoneModal = false;
        this.onDoneModalBack.emit();
        this.siteCatOnTourDoneAndBack('Back');
        this.gotoPreviousStep();
    }
    //TAGGING METHODS
    siteCatOnOverlay() {
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `${this.appHierarchyTagging}:${this.title}:tutorial:intro`,
                action_type: 'page view',
                event: 'tutorial start',
                page_type: 'overlay',
                test_id: '647_a Tutorial Welcome Slide'
            };
            window.taggingDataLayer.applicationData('647_aTutorialWelcomeSlide', taggingDetails);
        }
    }
    siteCatOnStartAndEndTour(action) {
        let link_name = action;
        if (action == "close") {
            link_name = "Close";
        }
        else if (action == "Start Tutorial") {
            link_name = this.buttonLabel;
        }
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `${this.appHierarchyTagging}:${this.title}:tutorial:intro:link clicked`,
                action_type: 'event',
                event: 'custom_link_click',
                link_name: link_name,
                test_id: '647_a2 Tutorial Welcome Slide CTA Clicked'
            };
            window.taggingDataLayer.updateEventData('647_a2TutorialWelcomeSlideCTAClicked', taggingDetails);
        }
    }
    siteCatOnStartTourStepOverlay() {
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `${this.appHierarchyTagging}:${this.title}:tutorial:${this.modalHeaderToTag}:${this.middleStepIndex}`,
                action_type: 'page view',
                event: 'tutorial start',
                page_type: 'overlay',
                test_id: '647_b Tutorial Slide'
            };
            window.taggingDataLayer.applicationData('647_bTutorialSlide', taggingDetails);
        }
    }
    siteCatOnTourSteps(steps) {
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `${this.appHierarchyTagging}:${this.title}:tutorial:${this.modalHeaderToTag}:${this.middleStepIndex}:link clicked`,
                action_type: 'event',
                event: 'custom_link_click',
                link_name: steps,
                test_id: '647_b2 Tutorial Slide CTA Clicked',
            };
            window.taggingDataLayer.updateEventData('647_b2TutorialSlideCTAClicked', taggingDetails);
        }
    }
    siteCatOnTourDoneAndBack(action) {
        let link_name = action;
        if (action == "close") {
            link_name = "Close";
        }
        else if (action == "Back") {
            link_name = "Back";
        }
        else {
            link_name = "Done";
        }
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `${this.appHierarchyTagging}:${this.title}:tutorial:${this.modalHeaderToTag}:${this.middleStepCount + 1}:link clicked`,
                action_type: 'event',
                event: 'custom_link_click',
                page_type: 'overlay',
                link_name: link_name,
                test_id: '647_b2 Tutorial Slide CTA Clicked'
            };
            window.taggingDataLayer.updateEventData('647_b2TutorialSlideCTAClicked', taggingDetails);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Tour2Component, deps: [{ token: Tour2Service }, { token: i1.CookieService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: Tour2Component, isStandalone: false, selector: "tour2", inputs: { stepStartCallback: "stepStartCallback", stepEndCallback: "stepEndCallback", title: "title", isInverse: "isInverse", hasWelcomeModal: "hasWelcomeModal", hasDoneModal: "hasDoneModal", featureFlag: "featureFlag", updateFlag: "updateFlag", disableTutorialOnInterstital: "disableTutorialOnInterstital", disableTutorialOnTutorialSeen: "disableTutorialOnTutorialSeen", appHierarchyTagging: "appHierarchyTagging" }, outputs: { tourStart: "tourStart", tourEnd: "tourEnd", onWelcomeModalClosed: "onWelcomeModalClosed", onWelcomeModalConfirmClicked: "onWelcomeModalConfirmClicked", onClosePopup: "onClosePopup", onNextPopup: "onNextPopup", onBackPopup: "onBackPopup", onDonePopup: "onDonePopup", onShowPopup: "onShowPopup", onDoneModalBack: "onDoneModalBack", onDoneModalFinish: "onDoneModalFinish", onDoneModalClose: "onDoneModalClose" }, viewQueries: [{ propertyName: "popup", first: true, predicate: ["popup"], descendants: true }], ngImport: i0, template: "<!-- Modal Backdrop -->\n<div *ngIf=\"showWelcomeModal || showDoneModal || showPopup\" class=\"background\" [class.dark]=\"darkBackground\"></div>\n\n<div *ngIf=\"showWelcomeModal || showDoneModal || showPopup\" class=\"background-layer\" [class.unlayered]=\"unlayerBackground\"></div>\n\n<!-- Welcome Modal -->\n<cds-modal-dialog\n  [(isOpen)]=\"showWelcomeModal\"\n  (closeEnd)=\"onWelcomeModalClose()\"\n  [isClosedOnBackdropClick]=\"false\"\n  [isClosedOnEscape]=\"false\"\n  [isRestoreFocusDisabled]=\"true\"\n  [hasFade]=\"true\"\n  [ariaLabel]=\"'Tour Welcome Modal'\"\n>\n  <div\n    class=\"cds-modal-dialog-centered\"\n    [class.style1]=\"currentStep?.modalStyle == 1\"\n  >\n    <div\n      class=\"cds-modal2-content cds-modal2-lg tour-modal-content\"\n      role=\"dialog\"\n      cdsModalInitialFocus\n    >\n      <!-- Modal Close Button -->\n      <div class=\"close-button-wrap\">\n        <button\n          class=\"tour-modal-close close-btn\"\n          aria-label=\"Close Welcome Modal\"\n          cdsButton=\"secondary\"\n          buttonIcon=\"icon\"\n          size=\"small\"\n          (click)=\"closeWelcomeModal()\"\n        >\n          <cds-icon\n            class=\"close-icon\"\n            type=\"2021\"\n            name=\"044-close\"\n            [svgStyle]=\"{ 'width.px': 20, 'height.px': 20 }\"\n            aria-hidden=\"true\"\n          ></cds-icon>\n        </button>\n      </div>\n\n      <div class=\"right-image-modal\">\n        <div class=\"tour-text-content welcome-text-content\">\n          <!-- Modal Header -->\n          <div\n            class=\"cds-modal2-header tour-welcome-modal-header\"\n            cdsTextHeader\n            role=\"heading\"\n            textSize=\"header-1\"\n            aria-level=\"1\"\n            [innerHTML]=\"modalHeader\"\n          >\n          </div>\n          <!-- Modal Content -->\n          <div\n            class=\"cds-modal2-body tour-modal-body\"\n            cdsTextHeader\n            textSize=\"body\"\n            [innerHTML]=\"modalContent\"\n          >\n          </div>\n          <!-- Modal Footer -->\n          <div class=\"welcome-modal-footer\">\n            <button\n              class=\"ml-left tour-modal-button\"\n              cdsButton=\"primary\"\n              (click)=\"onWelcomeModalConfirmClick()\"\n              [innerHTML]=\"buttonLabel\"\n            ></button>\n          </div>\n        </div>\n        <!-- Modal Image -->\n        <div class=\"tour-image-content\" *ngIf=\"modalImage\">\n          <img class=\"tour-right-image\" [src]=\"modalImage\" [attr.role]=\"modalImageRole\" [alt]=\"modalImageAltText\"/>\n        </div>\n\n      </div>\n    </div>\n  </div>\n</cds-modal-dialog>\n\n<!-- Popups -->\n<div class=\"popup-wrapper\" *ngIf=\"showPopup\">\n  <cds-tour\n    #popup\n    idStr=\"tourpopup\"\n    [tourHost]=\"tourHost\"\n    [position]=\"popupPosition\"\n    [(show)]=\"showPopup\"\n    (onChangeCloseBtn)=\"onPopupExitClicked()\"\n    (onChangeBackBtn)=\"onPopupBackClicked()\"\n    (onChangeNextBtn)=\"onPopupNextClicked()\"\n    (onChangeDoneBtn)=\"onPopupDoneClicked()\"\n    (onChangeShow)=\"onShowPopup.emit()\"\n    [isInverse]=\"isInverse\"\n    [maxWidth]=\"maxWidth\"\n    [titleText]=\"modalHeader\"\n    [contentText]=\"modalContent\"\n    [ariaDescription]=\"modalAriaDescription\"\n    [currentStep]=\"middleStepIndex\"\n    [totalSteps]=\"middleStepCount\"\n    [isKeptOpenOnFocusout]=\"true\"\n    [showBackButton]=\"showBackButton\"\n    [showNextButton]=\"showNextButton\"\n    [showDoneButton]=\"showDoneButton\"\n    [hidePageDots]=\"hideMiddleStepPageDots\"\n    titleAriaLevel=\"1\"\n  >\n  </cds-tour>\n</div>\n\n<!-- Done modal -->\n<cds-modal-dialog\n  [(isOpen)]=\"showDoneModal\"\n  [isClosedOnBackdropClick]=\"false\"\n  [isClosedOnEscape]=\"false\"\n  [isRestoreFocusDisabled]=\"true\"\n  [hasFade]=\"true\"\n  [ariaLabel]=\"'Tour Done Modal'\"\n>\n  <div\n    class=\"cds-modal-dialog-centered\"\n    [class.style1]=\"currentStep?.modalStyle == 1\"\n  >\n    <div\n      class=\"cds-modal2-content cds-modal2-lg tour-modal-content\"\n      role=\"dialog\"\n    >\n      <!-- Modal Close Button -->\n      <div class=\"close-button-wrap\">\n        <button\n          cdsModalInitialFocus\n          class=\"tour-modal-close close-btn\"\n          aria-label=\"Close Thank You Modal\"\n          cdsButton=\"secondary\"\n          buttonIcon=\"icon\"\n          size=\"small\"\n          (click)=\"onDoneModalCloseClicked()\"\n        >\n          <cds-icon\n            class=\"close-icon\"\n            type=\"2021\"\n            name=\"044-close\"\n            [svgStyle]=\"{ 'width.px': 20, 'height.px': 20 }\"\n            aria-hidden=\"true\"\n          ></cds-icon>\n        </button>\n      </div>\n      <div class=\"right-image-modal\">\n        <div class=\"tour-text-content done-text-content\">\n          <!-- Modal Header -->\n          <div\n            class=\"cds-modal2-header tour-done-modal-header\"\n            cdsTextHeader\n            role=\"heading\"\n            textSize=\"header-1\"\n            aria-level=\"1\"\n            [innerHTML]=\"modalHeader\"\n          >\n          </div>\n          <!-- Modal Content -->\n          <div class=\"cds-modal2-body tour-modal-body\"\n          [innerHTML]=\"modalContent\">\n          </div>\n          <!-- Modal Footer -->\n          <div class=\"done-modal-footer\">\n            <button\n              class=\"ml-left tour-modal-button\"\n              cdsButton=\"primary\"\n              (click)=\"onDoneModalFinishClicked()\"\n              [innerHTML]=\"buttonLabel\"\n            ></button>\n            <button\n              *ngIf=\"showDoneModalButton\"\n              class=\"tour-modal-button\"\n              cdsButton=\"secondary\"\n              (click)=\"onDoneModalBackClicked()\"\n            >\n              Back\n            </button>\n          </div>\n        </div>\n        <!-- Modal Image -->\n        <div class=\"tour-image-content\" *ngIf=\"modalImage\">\n          <img class=\"tour-right-image\" [src]=\"modalImage\" [attr.role]=\"modalImageRole\" [alt]=\"modalImageAltText\"/>\n        </div>\n      </div>\n    </div>\n  </div>\n</cds-modal-dialog>\n", styles: [".background{position:fixed;top:0;left:0;background-color:#000;width:100vw;height:100vh;opacity:0;transition:opacity .15s linear;z-index:-10000}.background.dark{display:block;opacity:.6;z-index:10000}.background-layer{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:10002}.background-layer.unlayered{z-index:-10000}:host ::ng-deep cds-modal-dialog ::ng-deep .cds-modal-backdrop{opacity:0!important}:host ::ng-deep cds-modal-dialog ::ng-deep .cds-modal{z-index:10003}.tour-modal-content{padding:16px 0 40px}.tour-modal-button{padding:12px 16px;width:204px;height:48px}.tour-modal-close{display:flex;position:absolute;right:0;padding:12px!important;margin:0 12px 12px}.tour-text-content{width:67%}.tour-image-content{width:33%;align-content:center;padding-right:40px;margin-top:48px}.tour-modal-body{font-size:16px;padding-right:0}.tour-done-modal-body{margin-bottom:24px;font-size:16px;padding-right:0;min-height:29%}.right-image-modal{justify-content:space-between;column-gap:24px;display:flex}.tour-right-image{width:100%;height:auto}.tour-welcome-modal-header,.tour-done-modal-header{font-weight:700;font-size:36px;line-height:44px;margin-top:48px;padding-top:12px;padding-right:0;padding-bottom:0;display:block}.welcome-text-content{display:flex;flex-direction:column;justify-content:center;gap:24px;flex:1 0 0}.welcome-modal-footer{display:flex;padding:24px 0 12px 40px}.done-text-content{display:flex;flex-direction:column;justify-content:center;gap:24px;flex:1 0 0}.done-modal-footer{display:flex;padding:24px 0 12px 40px}.popup-wrapper{position:fixed;z-index:10003}.popup-wrapper.hidden{display:hidden}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7.CdsModalDialogComponent, selector: "cds-modal-dialog", inputs: ["isOpen", "isClosedOnBackdropClick", "isClosedOnEscape", "hasFade", "ariaRole", "isRestoreFocusDisabled", "ariaLabel", "ariaLabelledby", "fadeTime"], outputs: ["isOpenChange", "openStart", "openEnd", "closeStart", "closeEnd"] }, { kind: "directive", type: i7.CdsButton, selector: "button[cdsButton],button[cds-button],a[cdsButton],a[cds-button]", inputs: ["cdsButton", "size", "buttonIcon", "arrowRight", "arrowLeft", "JFPToken"], exportAs: ["cdsButton"] }, { kind: "component", type: i7.CdsIcon, selector: "cds-icon", inputs: ["role", "idStr", "ariaLabel", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "altText", "shade", "name", "pathColor", "circleColor"] }, { kind: "component", type: i7.CdsTourComponent, selector: "cds-tour", inputs: ["closeAriaLabel", "ariaRole", "idStr", "showModal", "isInverse", "isKeptOpenOnFocusout", "maxWidth", "tourHost", "position", "show", "titleAriaLevel", "titleText", "contentText", "ariaDescription", "totalSteps", "currentStep", "showBackButton", "showNextButton", "showDoneButton", "hidePageDots"], outputs: ["onChangeBackBtn", "onChangeNextBtn", "onChangeDoneBtn", "onChangeCloseBtn", "onChangeShow"] }, { kind: "directive", type: i7.CdsTextHeader, selector: "[cdsTextHeader]", inputs: ["textColor", "textAlignment", "textSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Tour2Component, decorators: [{
            type: Component,
            args: [{ selector: 'tour2', standalone: false, template: "<!-- Modal Backdrop -->\n<div *ngIf=\"showWelcomeModal || showDoneModal || showPopup\" class=\"background\" [class.dark]=\"darkBackground\"></div>\n\n<div *ngIf=\"showWelcomeModal || showDoneModal || showPopup\" class=\"background-layer\" [class.unlayered]=\"unlayerBackground\"></div>\n\n<!-- Welcome Modal -->\n<cds-modal-dialog\n  [(isOpen)]=\"showWelcomeModal\"\n  (closeEnd)=\"onWelcomeModalClose()\"\n  [isClosedOnBackdropClick]=\"false\"\n  [isClosedOnEscape]=\"false\"\n  [isRestoreFocusDisabled]=\"true\"\n  [hasFade]=\"true\"\n  [ariaLabel]=\"'Tour Welcome Modal'\"\n>\n  <div\n    class=\"cds-modal-dialog-centered\"\n    [class.style1]=\"currentStep?.modalStyle == 1\"\n  >\n    <div\n      class=\"cds-modal2-content cds-modal2-lg tour-modal-content\"\n      role=\"dialog\"\n      cdsModalInitialFocus\n    >\n      <!-- Modal Close Button -->\n      <div class=\"close-button-wrap\">\n        <button\n          class=\"tour-modal-close close-btn\"\n          aria-label=\"Close Welcome Modal\"\n          cdsButton=\"secondary\"\n          buttonIcon=\"icon\"\n          size=\"small\"\n          (click)=\"closeWelcomeModal()\"\n        >\n          <cds-icon\n            class=\"close-icon\"\n            type=\"2021\"\n            name=\"044-close\"\n            [svgStyle]=\"{ 'width.px': 20, 'height.px': 20 }\"\n            aria-hidden=\"true\"\n          ></cds-icon>\n        </button>\n      </div>\n\n      <div class=\"right-image-modal\">\n        <div class=\"tour-text-content welcome-text-content\">\n          <!-- Modal Header -->\n          <div\n            class=\"cds-modal2-header tour-welcome-modal-header\"\n            cdsTextHeader\n            role=\"heading\"\n            textSize=\"header-1\"\n            aria-level=\"1\"\n            [innerHTML]=\"modalHeader\"\n          >\n          </div>\n          <!-- Modal Content -->\n          <div\n            class=\"cds-modal2-body tour-modal-body\"\n            cdsTextHeader\n            textSize=\"body\"\n            [innerHTML]=\"modalContent\"\n          >\n          </div>\n          <!-- Modal Footer -->\n          <div class=\"welcome-modal-footer\">\n            <button\n              class=\"ml-left tour-modal-button\"\n              cdsButton=\"primary\"\n              (click)=\"onWelcomeModalConfirmClick()\"\n              [innerHTML]=\"buttonLabel\"\n            ></button>\n          </div>\n        </div>\n        <!-- Modal Image -->\n        <div class=\"tour-image-content\" *ngIf=\"modalImage\">\n          <img class=\"tour-right-image\" [src]=\"modalImage\" [attr.role]=\"modalImageRole\" [alt]=\"modalImageAltText\"/>\n        </div>\n\n      </div>\n    </div>\n  </div>\n</cds-modal-dialog>\n\n<!-- Popups -->\n<div class=\"popup-wrapper\" *ngIf=\"showPopup\">\n  <cds-tour\n    #popup\n    idStr=\"tourpopup\"\n    [tourHost]=\"tourHost\"\n    [position]=\"popupPosition\"\n    [(show)]=\"showPopup\"\n    (onChangeCloseBtn)=\"onPopupExitClicked()\"\n    (onChangeBackBtn)=\"onPopupBackClicked()\"\n    (onChangeNextBtn)=\"onPopupNextClicked()\"\n    (onChangeDoneBtn)=\"onPopupDoneClicked()\"\n    (onChangeShow)=\"onShowPopup.emit()\"\n    [isInverse]=\"isInverse\"\n    [maxWidth]=\"maxWidth\"\n    [titleText]=\"modalHeader\"\n    [contentText]=\"modalContent\"\n    [ariaDescription]=\"modalAriaDescription\"\n    [currentStep]=\"middleStepIndex\"\n    [totalSteps]=\"middleStepCount\"\n    [isKeptOpenOnFocusout]=\"true\"\n    [showBackButton]=\"showBackButton\"\n    [showNextButton]=\"showNextButton\"\n    [showDoneButton]=\"showDoneButton\"\n    [hidePageDots]=\"hideMiddleStepPageDots\"\n    titleAriaLevel=\"1\"\n  >\n  </cds-tour>\n</div>\n\n<!-- Done modal -->\n<cds-modal-dialog\n  [(isOpen)]=\"showDoneModal\"\n  [isClosedOnBackdropClick]=\"false\"\n  [isClosedOnEscape]=\"false\"\n  [isRestoreFocusDisabled]=\"true\"\n  [hasFade]=\"true\"\n  [ariaLabel]=\"'Tour Done Modal'\"\n>\n  <div\n    class=\"cds-modal-dialog-centered\"\n    [class.style1]=\"currentStep?.modalStyle == 1\"\n  >\n    <div\n      class=\"cds-modal2-content cds-modal2-lg tour-modal-content\"\n      role=\"dialog\"\n    >\n      <!-- Modal Close Button -->\n      <div class=\"close-button-wrap\">\n        <button\n          cdsModalInitialFocus\n          class=\"tour-modal-close close-btn\"\n          aria-label=\"Close Thank You Modal\"\n          cdsButton=\"secondary\"\n          buttonIcon=\"icon\"\n          size=\"small\"\n          (click)=\"onDoneModalCloseClicked()\"\n        >\n          <cds-icon\n            class=\"close-icon\"\n            type=\"2021\"\n            name=\"044-close\"\n            [svgStyle]=\"{ 'width.px': 20, 'height.px': 20 }\"\n            aria-hidden=\"true\"\n          ></cds-icon>\n        </button>\n      </div>\n      <div class=\"right-image-modal\">\n        <div class=\"tour-text-content done-text-content\">\n          <!-- Modal Header -->\n          <div\n            class=\"cds-modal2-header tour-done-modal-header\"\n            cdsTextHeader\n            role=\"heading\"\n            textSize=\"header-1\"\n            aria-level=\"1\"\n            [innerHTML]=\"modalHeader\"\n          >\n          </div>\n          <!-- Modal Content -->\n          <div class=\"cds-modal2-body tour-modal-body\"\n          [innerHTML]=\"modalContent\">\n          </div>\n          <!-- Modal Footer -->\n          <div class=\"done-modal-footer\">\n            <button\n              class=\"ml-left tour-modal-button\"\n              cdsButton=\"primary\"\n              (click)=\"onDoneModalFinishClicked()\"\n              [innerHTML]=\"buttonLabel\"\n            ></button>\n            <button\n              *ngIf=\"showDoneModalButton\"\n              class=\"tour-modal-button\"\n              cdsButton=\"secondary\"\n              (click)=\"onDoneModalBackClicked()\"\n            >\n              Back\n            </button>\n          </div>\n        </div>\n        <!-- Modal Image -->\n        <div class=\"tour-image-content\" *ngIf=\"modalImage\">\n          <img class=\"tour-right-image\" [src]=\"modalImage\" [attr.role]=\"modalImageRole\" [alt]=\"modalImageAltText\"/>\n        </div>\n      </div>\n    </div>\n  </div>\n</cds-modal-dialog>\n", styles: [".background{position:fixed;top:0;left:0;background-color:#000;width:100vw;height:100vh;opacity:0;transition:opacity .15s linear;z-index:-10000}.background.dark{display:block;opacity:.6;z-index:10000}.background-layer{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:10002}.background-layer.unlayered{z-index:-10000}:host ::ng-deep cds-modal-dialog ::ng-deep .cds-modal-backdrop{opacity:0!important}:host ::ng-deep cds-modal-dialog ::ng-deep .cds-modal{z-index:10003}.tour-modal-content{padding:16px 0 40px}.tour-modal-button{padding:12px 16px;width:204px;height:48px}.tour-modal-close{display:flex;position:absolute;right:0;padding:12px!important;margin:0 12px 12px}.tour-text-content{width:67%}.tour-image-content{width:33%;align-content:center;padding-right:40px;margin-top:48px}.tour-modal-body{font-size:16px;padding-right:0}.tour-done-modal-body{margin-bottom:24px;font-size:16px;padding-right:0;min-height:29%}.right-image-modal{justify-content:space-between;column-gap:24px;display:flex}.tour-right-image{width:100%;height:auto}.tour-welcome-modal-header,.tour-done-modal-header{font-weight:700;font-size:36px;line-height:44px;margin-top:48px;padding-top:12px;padding-right:0;padding-bottom:0;display:block}.welcome-text-content{display:flex;flex-direction:column;justify-content:center;gap:24px;flex:1 0 0}.welcome-modal-footer{display:flex;padding:24px 0 12px 40px}.done-text-content{display:flex;flex-direction:column;justify-content:center;gap:24px;flex:1 0 0}.done-modal-footer{display:flex;padding:24px 0 12px 40px}.popup-wrapper{position:fixed;z-index:10003}.popup-wrapper.hidden{display:hidden}\n"] }]
        }], ctorParameters: () => [{ type: Tour2Service }, { type: i1.CookieService }], propDecorators: { popup: [{
                type: ViewChild,
                args: ['popup']
            }], stepStartCallback: [{
                type: Input
            }], stepEndCallback: [{
                type: Input
            }], title: [{
                type: Input
            }], isInverse: [{
                type: Input
            }], hasWelcomeModal: [{
                type: Input
            }], hasDoneModal: [{
                type: Input
            }], featureFlag: [{
                type: Input
            }], updateFlag: [{
                type: Input
            }], disableTutorialOnInterstital: [{
                type: Input
            }], disableTutorialOnTutorialSeen: [{
                type: Input
            }], appHierarchyTagging: [{
                type: Input
            }], tourStart: [{
                type: Output
            }], tourEnd: [{
                type: Output
            }], onWelcomeModalClosed: [{
                type: Output
            }], onWelcomeModalConfirmClicked: [{
                type: Output
            }], onClosePopup: [{
                type: Output
            }], onNextPopup: [{
                type: Output
            }], onBackPopup: [{
                type: Output
            }], onDonePopup: [{
                type: Output
            }], onShowPopup: [{
                type: Output
            }], onDoneModalBack: [{
                type: Output
            }], onDoneModalFinish: [{
                type: Output
            }], onDoneModalClose: [{
                type: Output
            }] } });

const COMPONENTS = [
    CdsCoreModule,
    CdsJampModule,
    CdsPageDotsModule,
    CdsModalDialogModule,
    CdsButtonModule,
    CdsIconModule,
    CdsTourModule,
    CdsTextHeaderModule
];
class Tour2Module {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Tour2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: Tour2Module, declarations: [Tour2Component], imports: [CommonModule,
            A11yModule, CdsCoreModule,
            CdsJampModule,
            CdsPageDotsModule,
            CdsModalDialogModule,
            CdsButtonModule,
            CdsIconModule,
            CdsTourModule,
            CdsTextHeaderModule], exports: [Tour2Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Tour2Module, providers: [Tour2Service], imports: [CommonModule,
            A11yModule, COMPONENTS] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: Tour2Module, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [Tour2Component],
                    imports: [
                        CommonModule,
                        A11yModule,
                        ...COMPONENTS
                    ],
                    exports: [Tour2Component],
                    providers: [Tour2Service]
                }]
        }] });

const MODULES$1 = [
    CommonModule,
    Modal
];
class SessionTimeoutModalModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SessionTimeoutModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: SessionTimeoutModalModule, declarations: [SessionTimeoutModal], imports: [CommonModule,
            Modal], exports: [SessionTimeoutModal] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SessionTimeoutModalModule, imports: [MODULES$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SessionTimeoutModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$1],
                    declarations: [SessionTimeoutModal],
                    exports: [SessionTimeoutModal],
                }]
        }] });

const importz = [
    TourModule,
    OneStepModule,
    CdsTourModule,
    Tour2Module,
    SessionTimeoutModalModule,
    CoreServicesModule,
    CoreCommonModule,
    Layouts.forRoot(), // will also provide the LayoutsService
    CitiRouteDetector,
    CitiAppConfig,
    BrowserAnimationsModule,
    HttpClientModule,
    CitiBrandingModule,
    Dropdown2,
    ContentModule,
    CitiSecurityModule,
    RouterModule,
    CdsModalDialogModule,
    CdsDropdownModule,
    CdsCTAModule,
    CdsCoreModule,
    CdsJampModule,
    CdsPageDotsModule,
    CdsIconModule,
    FormsModule,
    ReactiveFormsModule,
    CdsFormsModule,
    // WhatsNewModule,
    NgaLoginServiceModule,
    DeepDropAssistedChannelModule
];
const declarations = [
    CbolCoreComponent,
    CbolSessionComponent,
    NonFatalErrorComponent,
    CitiSessionHandlerComponent,
    PageNotFoundComponent
];
const core_exports = [
    CbolCoreComponent,
    CbolSessionComponent,
    NonFatalErrorComponent,
    CitiSessionHandlerComponent,
    PageNotFoundComponent
];
const providers = [
    SessionService,
    AppConfigService,
    StorageService,
    CbolCoreContentService,
    CbolSessionService,
    NonFatalErrorRedirectService,
    CbolCoreConfigService,
    SiteCatalystService,
    CbolCoreRedirectService,
    //E2eActivationService,
    E2eService,
    PostSessionService,
    CookieService,
    EcmCookieService,
    ScriptLoadService,
    DeepdropService,
    TMXService,
    CedricService,
    PreloginInactivityService,
    provideNgxWebstorage(withNgxWebstorageConfig({
        prefix: '',
        separator: '',
        caseSensitive: true
    }), withLocalStorage(), withSessionStorage()),
    WINDOW_PROVIDER,
    NAVIGATOR_PROVIDER,
    SESSION_STORAGE_PROVIDER,
    CustomPreloaderService,
    MrcdashboardRouteGuard,
    NGALoginService,
    AssistedChannelDataShareService,
    // BasketjsService,
    { provide: 'ChatConfig', useClass: ChatConfig }
    // {
    //   // Provider for APP_INITIALIZER
    //   provide: APP_INITIALIZER,
    //   useFactory: configServiceFactory,
    //   deps: [CbolCoreConfigService],
    //   multi: true
    // },
];
class CbolCoreModule {
    static forRoot() {
        return {
            ngModule: CbolCoreModule,
            providers: [providers]
        };
    }
    constructor(cbolCoreConfigService) {
        this.cbolCoreConfigService = cbolCoreConfigService;
        this.cbolCoreConfigService.load();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreModule, deps: [{ token: CbolCoreConfigService }], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreModule, declarations: [CbolCoreComponent,
            CbolSessionComponent,
            NonFatalErrorComponent,
            CitiSessionHandlerComponent,
            PageNotFoundComponent], imports: [TourModule,
            OneStepModule,
            CdsTourModule,
            Tour2Module,
            SessionTimeoutModalModule,
            CoreServicesModule,
            CoreCommonModule, i3.Layouts, // will also provide the LayoutsService
            CitiRouteDetector,
            CitiAppConfig,
            BrowserAnimationsModule,
            HttpClientModule,
            CitiBrandingModule,
            Dropdown2,
            ContentModule,
            CitiSecurityModule,
            RouterModule,
            CdsModalDialogModule,
            CdsDropdownModule,
            CdsCTAModule,
            CdsCoreModule,
            CdsJampModule,
            CdsPageDotsModule,
            CdsIconModule,
            FormsModule,
            ReactiveFormsModule,
            CdsFormsModule,
            // WhatsNewModule,
            NgaLoginServiceModule,
            DeepDropAssistedChannelModule], exports: [CbolCoreComponent,
            CbolSessionComponent,
            NonFatalErrorComponent,
            CitiSessionHandlerComponent,
            PageNotFoundComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreModule, imports: [importz] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CbolCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [importz],
                    declarations: [declarations],
                    exports: [core_exports],
                    providers: []
                }]
        }], ctorParameters: () => [{ type: CbolCoreConfigService }] });
const ROOT_EFFECTS = new InjectionToken('ngrx/effects: Root Effects');
function createSourceInstances(instances) {
    return instances;
}

class WhatsNewBauModalComponent {
    constructor() {
        this.contents = [];
        this.close = new EventEmitter();
        this.cta = new EventEmitter();
    }
    set modality(modality) {
        this._modality = modality;
    }
    set customerType(customerType) {
        this._customerType = customerType;
    }
    isOneContent() {
        return this.contents?.length === 1 || window.innerWidth < 992;
    }
    doneModal(eve) {
        this.close.emit(eve);
    }
    onCTALinkClick(target, urlVal, header_text, cta_label) {
        this.cta.emit({ target, urlVal, header_text, cta_label });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: WhatsNewBauModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: WhatsNewBauModalComponent, isStandalone: true, selector: "citi-whats-new-bau-modal", inputs: { showModal: "showModal", contents: "contents", noneFeature: "noneFeature", modality: "modality", customerType: "customerType" }, outputs: { close: "close", cta: "cta" }, ngImport: i0, template: "<!-- CDS Modal -->\n<div class=\"cbolui-cds\">\n  <div\n    [ngClass]=\"{\n      'one-content': contents.length == 1 && _modality !== 'whats_new_wpb',\n      'two-content': contents.length == 2,\n      'three-content': contents.length == 3,\n      'wpb-modal': _modality === 'whats_new_wpb',\n      gold: _customerType === 'Gold_customerType' && _modality === 'whats_new_wpb',\n      priority: _customerType === 'Priority_customerType' && _modality === 'whats_new_wpb'\n    }\"\n    class=\"bau-wn\"\n  >\n    <cds-modal-dialog\n      [(isOpen)]=\"showModal\"\n      [isClosedOnEscape]=\"false\"\n      [isClosedOnBackdropClick]=\"false\"\n      [hasFade]=\"true\"\n    >\n      <div\n        cdsModalInitialFocus\n        [ngClass]=\"\n          isOneContent()\n            ? 'cds-modal-content cds-modal-lg'\n            : 'cds-modal-content cds-modal-xl'\n        \"\n        role=\"dialog\"\n      >\n        <!-- Modal Close Icon -->\n        <div class=\"close-icon-wrapper\">\n          <button\n          #close\n          class=\"cds-modal2-close close-btn\"\n          cdsButton=\"secondary\"\n          buttonIcon=\"icon\"\n          size=\"small\"\n          (click)=\"doneModal(close)\"\n          aria-label=\"Modal Close\"\n        >\n          <cds-icon\n            class=\"close-icon\"\n            type=\"2021\"\n            name=\"044-close\"\n            alt=\"close-icon\"\n            [svgStyle]=\"{ 'width.px': '20', 'height.px': '20' }\"\n            aria-hidden=\"true\"\n          ></cds-icon>\n        </button>\n        </div>\n\n        <!-- Modal Header -->\n        <div\n          [ngClass]=\"{ 'wn-modal-header-one-content': isOneContent() }\"\n        >\n          <h1\n            class=\"wn-modal-header\"\n            #elemRef\n            [innerHTML]=\"noneFeature?.title\"\n          ></h1>\n        </div>\n\n        <!-- Modal Body -->\n        <div class=\"body-container\">\n          <div class=\"flex-items\" *ngFor=\"let feature of contents; let idx = index\">\n            <div [ngClass]=\"{ 'secondary-contents': idx > 0 }\">\n              <div\n                [ngClass]=\"{ 'image-border-one-content': isOneContent() }\"\n              >\n                <!-- QR Image -->\n                <div\n                  *ngIf=\"feature.imageUrl && isOneContent()\"\n                  class=\"image-border\"\n                >\n                  <img\n                    class=\"qr-image\"\n                    [src]=\"feature.imageUrl\"\n                    [attr.alt]=\"feature.imageUrl\"\n                  />\n                </div>\n                <cds-icon\n                  *ngIf=\"feature.iconUrl.trim().length > 0\"\n                  [class]=\"feature.iconUrl\"\n                  [ngClass]=\"{ 'one-content-icon': isOneContent() }\"\n                  [ariaLabel]=\"feature.iconAltText || feature.iconUrl.split('-')[1]\"\n                  type=\"2021\"\n                  [svgStyle]=\"{ 'width.px': '44', 'height.px': '44' }\"\n                  [name]=\"feature.iconUrl\"\n                  [pathColor]=\"feature.iconColor\"\n                ></cds-icon>\n              </div>\n              <div\n                class=\"body-header\"\n                [ngClass]=\"{ 'text-align-one-content': isOneContent() }\"\n              >\n                <h2\n                  *ngIf=\"feature.header.trim().length > 0\"\n                  class=\"sub-header\"\n                >\n                  {{ feature.header }}\n                </h2>\n              </div>\n              <div\n                class=\"body-text\"\n                [ngClass]=\"{ 'text-align-one-content': isOneContent() }\"\n              >\n                <p\n                  class=\"checkout-content\"\n                  [attr.aria-label]=\"feature.content\"\n                  role=\"document\"\n                  [innerHTML]=\"feature.content\"\n                >\n                </p>\n              </div>\n              <!-- QR Image -->\n              <div\n                *ngIf=\"feature.imageUrl && contents?.length > 1\"\n                class=\"image-border\"\n              >\n                <img\n                  class=\"qr-image\"\n                  [src]=\"feature.imageUrl\"\n                  [attr.alt]=\"feature.imageUrl\"\n                />\n              </div>\n              <!-- Learn more CTA -->\n              <div\n                [ngClass]=\"{ 'text-align-one-content': isOneContent() }\"\n              >\n                <button\n                  #cta\n                  *ngIf=\"feature.CTALabel?.trim().length > 0\"\n                  cdsButton=\"alternate\"\n                  class=\"cta-button content-link\"\n                  role=\"link\"\n                  [attr.aria-label]=\"feature.CTALabel\"\n                  (click)=\"\n                    onCTALinkClick(\n                      cta,\n                      feature.CTALink,\n                      feature.header,\n                      feature.CTALabel\n                    )\n                  \"\n                  [JFPToken]=\"false\"\n                  size=\"default\"\n                >\n                  {{ feature.CTALabel }}\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <!-- Modal Footer -->\n        <div\n          [ngClass]=\"{ 'wn-modal-footer-one-content': isOneContent(), 'wn-modal-footer':  !isOneContent() }\"\n        >\n\n            <button *ngIf=\"noneFeature?.CTALabel\"\n              #done\n              class=\"done-btn\"\n              cdsButton=\"primary\"\n              (click)=\"doneModal(done)\"\n            >\n              {{ noneFeature?.CTALabel }}\n            </button>\n\n            <button\n              #remind\n              class=\"remind-me-later\"\n              cdsButton=\"tertiary\"\n              (click)=\"doneModal(remind)\"\n              aria-label=\"Remind me later\"\n            >\n              Remind me later\n            </button>\n\n        </div>\n      </div>\n    </cds-modal-dialog>\n  </div>\n</div>\n", styles: [".bau-wn .wn-modal-header{padding:3rem 60px 1.75rem;font-family:Interstate_Light;font-style:normal;font-weight:300;font-size:38px;line-height:42px;margin-bottom:0}.bau-wn .close-icon-wrapper{align-self:flex-end}.bau-wn .close-btn{border:none}.bau-wn .sub-header{font-size:1.5rem!important}.bau-wn .body-container{font-family:Interstate_Light;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-around;align-content:stretch;align-items:flex-start;column-gap:40px;padding:0 60px 1.75rem}.bau-wn .body-container .flex-items{order:0;flex:1 1 0px;align-self:auto}.bau-wn .body-container .body-header{margin:16px 0}.bau-wn .body-container .body-text{font-family:Interstate_Light;font-style:normal;font-weight:300;font-size:16px;line-height:24px}.bau-wn .wn-modal-footer{padding:0 0 49px 60px}.bau-wn .image-border{border:1px solid #333;width:132px;height:132px}.bau-wn .image-border .qr-image{margin:15px}.bau-wn .text-align-one-content{text-align:center}.bau-wn .wn-modal-header-one-content{text-align:center;padding:0}.bau-wn .image-border-one-content{display:flex}.bau-wn .image-border-one-content .one-content-icon{margin:0 auto}.bau-wn .wn-modal-footer-one-content{padding-bottom:49px;text-align:center;justify-content:center;display:flex;flex-direction:row;gap:1rem}.bau-wn div[class^=icon-]{background-size:cover;height:48px;width:48px}.bau-wn .qr-code-image{background-image:url(/JRS/banners/whats_new/QR.png);width:100px;height:100px;margin:7px}@media (max-width: 992px){.bau-wn .secondary-contents{display:none}.bau-wn .body-container{display:block;column-gap:0;text-align:center;padding:0 60px 1.4rem}.bau-wn .wn-modal-footer{padding-bottom:49px;text-align:center}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: CdsModalDialogModule }, { kind: "component", type: i7.CdsModalDialogComponent, selector: "cds-modal-dialog", inputs: ["isOpen", "isClosedOnBackdropClick", "isClosedOnEscape", "hasFade", "ariaRole", "isRestoreFocusDisabled", "ariaLabel", "ariaLabelledby", "fadeTime"], outputs: ["isOpenChange", "openStart", "openEnd", "closeStart", "closeEnd"] }, { kind: "ngmodule", type: CdsButtonModule }, { kind: "directive", type: i7.CdsButton, selector: "button[cdsButton],button[cds-button],a[cdsButton],a[cds-button]", inputs: ["cdsButton", "size", "buttonIcon", "arrowRight", "arrowLeft", "JFPToken"], exportAs: ["cdsButton"] }, { kind: "ngmodule", type: CdsIconModule }, { kind: "component", type: i7.CdsIcon, selector: "cds-icon", inputs: ["role", "idStr", "ariaLabel", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "altText", "shade", "name", "pathColor", "circleColor"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: WhatsNewBauModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-whats-new-bau-modal', standalone: true, imports: [CommonModule, CdsModalDialogModule, CdsButtonModule, CdsIconModule], template: "<!-- CDS Modal -->\n<div class=\"cbolui-cds\">\n  <div\n    [ngClass]=\"{\n      'one-content': contents.length == 1 && _modality !== 'whats_new_wpb',\n      'two-content': contents.length == 2,\n      'three-content': contents.length == 3,\n      'wpb-modal': _modality === 'whats_new_wpb',\n      gold: _customerType === 'Gold_customerType' && _modality === 'whats_new_wpb',\n      priority: _customerType === 'Priority_customerType' && _modality === 'whats_new_wpb'\n    }\"\n    class=\"bau-wn\"\n  >\n    <cds-modal-dialog\n      [(isOpen)]=\"showModal\"\n      [isClosedOnEscape]=\"false\"\n      [isClosedOnBackdropClick]=\"false\"\n      [hasFade]=\"true\"\n    >\n      <div\n        cdsModalInitialFocus\n        [ngClass]=\"\n          isOneContent()\n            ? 'cds-modal-content cds-modal-lg'\n            : 'cds-modal-content cds-modal-xl'\n        \"\n        role=\"dialog\"\n      >\n        <!-- Modal Close Icon -->\n        <div class=\"close-icon-wrapper\">\n          <button\n          #close\n          class=\"cds-modal2-close close-btn\"\n          cdsButton=\"secondary\"\n          buttonIcon=\"icon\"\n          size=\"small\"\n          (click)=\"doneModal(close)\"\n          aria-label=\"Modal Close\"\n        >\n          <cds-icon\n            class=\"close-icon\"\n            type=\"2021\"\n            name=\"044-close\"\n            alt=\"close-icon\"\n            [svgStyle]=\"{ 'width.px': '20', 'height.px': '20' }\"\n            aria-hidden=\"true\"\n          ></cds-icon>\n        </button>\n        </div>\n\n        <!-- Modal Header -->\n        <div\n          [ngClass]=\"{ 'wn-modal-header-one-content': isOneContent() }\"\n        >\n          <h1\n            class=\"wn-modal-header\"\n            #elemRef\n            [innerHTML]=\"noneFeature?.title\"\n          ></h1>\n        </div>\n\n        <!-- Modal Body -->\n        <div class=\"body-container\">\n          <div class=\"flex-items\" *ngFor=\"let feature of contents; let idx = index\">\n            <div [ngClass]=\"{ 'secondary-contents': idx > 0 }\">\n              <div\n                [ngClass]=\"{ 'image-border-one-content': isOneContent() }\"\n              >\n                <!-- QR Image -->\n                <div\n                  *ngIf=\"feature.imageUrl && isOneContent()\"\n                  class=\"image-border\"\n                >\n                  <img\n                    class=\"qr-image\"\n                    [src]=\"feature.imageUrl\"\n                    [attr.alt]=\"feature.imageUrl\"\n                  />\n                </div>\n                <cds-icon\n                  *ngIf=\"feature.iconUrl.trim().length > 0\"\n                  [class]=\"feature.iconUrl\"\n                  [ngClass]=\"{ 'one-content-icon': isOneContent() }\"\n                  [ariaLabel]=\"feature.iconAltText || feature.iconUrl.split('-')[1]\"\n                  type=\"2021\"\n                  [svgStyle]=\"{ 'width.px': '44', 'height.px': '44' }\"\n                  [name]=\"feature.iconUrl\"\n                  [pathColor]=\"feature.iconColor\"\n                ></cds-icon>\n              </div>\n              <div\n                class=\"body-header\"\n                [ngClass]=\"{ 'text-align-one-content': isOneContent() }\"\n              >\n                <h2\n                  *ngIf=\"feature.header.trim().length > 0\"\n                  class=\"sub-header\"\n                >\n                  {{ feature.header }}\n                </h2>\n              </div>\n              <div\n                class=\"body-text\"\n                [ngClass]=\"{ 'text-align-one-content': isOneContent() }\"\n              >\n                <p\n                  class=\"checkout-content\"\n                  [attr.aria-label]=\"feature.content\"\n                  role=\"document\"\n                  [innerHTML]=\"feature.content\"\n                >\n                </p>\n              </div>\n              <!-- QR Image -->\n              <div\n                *ngIf=\"feature.imageUrl && contents?.length > 1\"\n                class=\"image-border\"\n              >\n                <img\n                  class=\"qr-image\"\n                  [src]=\"feature.imageUrl\"\n                  [attr.alt]=\"feature.imageUrl\"\n                />\n              </div>\n              <!-- Learn more CTA -->\n              <div\n                [ngClass]=\"{ 'text-align-one-content': isOneContent() }\"\n              >\n                <button\n                  #cta\n                  *ngIf=\"feature.CTALabel?.trim().length > 0\"\n                  cdsButton=\"alternate\"\n                  class=\"cta-button content-link\"\n                  role=\"link\"\n                  [attr.aria-label]=\"feature.CTALabel\"\n                  (click)=\"\n                    onCTALinkClick(\n                      cta,\n                      feature.CTALink,\n                      feature.header,\n                      feature.CTALabel\n                    )\n                  \"\n                  [JFPToken]=\"false\"\n                  size=\"default\"\n                >\n                  {{ feature.CTALabel }}\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <!-- Modal Footer -->\n        <div\n          [ngClass]=\"{ 'wn-modal-footer-one-content': isOneContent(), 'wn-modal-footer':  !isOneContent() }\"\n        >\n\n            <button *ngIf=\"noneFeature?.CTALabel\"\n              #done\n              class=\"done-btn\"\n              cdsButton=\"primary\"\n              (click)=\"doneModal(done)\"\n            >\n              {{ noneFeature?.CTALabel }}\n            </button>\n\n            <button\n              #remind\n              class=\"remind-me-later\"\n              cdsButton=\"tertiary\"\n              (click)=\"doneModal(remind)\"\n              aria-label=\"Remind me later\"\n            >\n              Remind me later\n            </button>\n\n        </div>\n      </div>\n    </cds-modal-dialog>\n  </div>\n</div>\n", styles: [".bau-wn .wn-modal-header{padding:3rem 60px 1.75rem;font-family:Interstate_Light;font-style:normal;font-weight:300;font-size:38px;line-height:42px;margin-bottom:0}.bau-wn .close-icon-wrapper{align-self:flex-end}.bau-wn .close-btn{border:none}.bau-wn .sub-header{font-size:1.5rem!important}.bau-wn .body-container{font-family:Interstate_Light;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-around;align-content:stretch;align-items:flex-start;column-gap:40px;padding:0 60px 1.75rem}.bau-wn .body-container .flex-items{order:0;flex:1 1 0px;align-self:auto}.bau-wn .body-container .body-header{margin:16px 0}.bau-wn .body-container .body-text{font-family:Interstate_Light;font-style:normal;font-weight:300;font-size:16px;line-height:24px}.bau-wn .wn-modal-footer{padding:0 0 49px 60px}.bau-wn .image-border{border:1px solid #333;width:132px;height:132px}.bau-wn .image-border .qr-image{margin:15px}.bau-wn .text-align-one-content{text-align:center}.bau-wn .wn-modal-header-one-content{text-align:center;padding:0}.bau-wn .image-border-one-content{display:flex}.bau-wn .image-border-one-content .one-content-icon{margin:0 auto}.bau-wn .wn-modal-footer-one-content{padding-bottom:49px;text-align:center;justify-content:center;display:flex;flex-direction:row;gap:1rem}.bau-wn div[class^=icon-]{background-size:cover;height:48px;width:48px}.bau-wn .qr-code-image{background-image:url(/JRS/banners/whats_new/QR.png);width:100px;height:100px;margin:7px}@media (max-width: 992px){.bau-wn .secondary-contents{display:none}.bau-wn .body-container{display:block;column-gap:0;text-align:center;padding:0 60px 1.4rem}.bau-wn .wn-modal-footer{padding-bottom:49px;text-align:center}}\n"] }]
        }], propDecorators: { showModal: [{
                type: Input
            }], contents: [{
                type: Input
            }], noneFeature: [{
                type: Input
            }], close: [{
                type: Output
            }], cta: [{
                type: Output
            }], modality: [{
                type: Input
            }], customerType: [{
                type: Input
            }] } });

class WhatsNewMobileEvoModalComponent {
    constructor() {
        this.contents = [];
        this.close = new EventEmitter();
        this.cta = new EventEmitter();
    }
    doneModal(target) {
        this.close.emit(target);
    }
    onCTALinkClick(target, urlVal, header_text, cta_label) {
        this.cta.emit({ target, urlVal, header_text, cta_label });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: WhatsNewMobileEvoModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: WhatsNewMobileEvoModalComponent, isStandalone: true, selector: "citi-whats-new-mobile-evo-modal", inputs: { showModal: "showModal", contents: "contents", noneFeature: "noneFeature" }, outputs: { close: "close", cta: "cta" }, ngImport: i0, template: "<!-- CDS Modal -->\n<div class=\"cbolui-cds\">\n  <div\n    class=\"mobile-evolution-wn\"\n  >\n    <cds-modal-dialog\n      [(isOpen)]=\"showModal\"\n      [isClosedOnEscape]=\"false\"\n      [isClosedOnBackdropClick]=\"false\"\n      [hasFade]=\"true\"\n    >\n      <div\n        cdsModalInitialFocus\n        ngClass='cds-modal-content cds-modal-xl'\n        class = \"wn-modal\"\n        role=\"dialog\"\n      >\n        <!-- Modal Close Icon -->\n        <div class=\"close-icon-wrapper\">\n          <button\n            #close\n            class=\"cds-modal2-close close-btn\"\n            cdsButton=\"secondary\"\n            buttonIcon=\"icon\"\n            size=\"small\"\n            (click)=\"doneModal(close)\"\n            aria-label=\"Modal Close\"\n          >\n            <cds-icon\n              class=\"close-icon\"\n              type=\"2021\"\n              name=\"044-close\"\n              alt=\"close-icon\"\n              [svgStyle]=\"{ 'width.px': '20', 'height.px': '20' }\"\n              aria-hidden=\"true\"\n            ></cds-icon>\n          </button>\n        </div>\n\n        <!-- Modal Body -->\n        <div class=\"body-container\">\n          <div\n            class=\"flex-items\"\n            *ngFor=\"let feature of contents; let idx = index\"\n          >\n            <!-- Modal Header -->\n            <div\n              [ngClass]=\"{\n                'wn-modal-header-one-content': contents?.length === 1\n              }\"\n            >\n              <h1\n                class=\"wn-modal-header\"\n                #elemRef\n                [innerHTML]=\"noneFeature?.title\"\n              ></h1>\n            </div>\n\n            <hr class=\"line-break\"/>\n\n            <!-- QR Image -->\n            <div\n              *ngIf=\"feature.iconUrl && contents?.length === 1\"\n              class=\"image-border\"\n            >\n              <img\n                class=\"qr-image\"\n                [src]=\"feature.iconUrl\"\n                [attr.alt]=\"feature?.iconAltText || ''\"\n              />\n            </div>\n\n            <div>\n              <!-- Sub Header -->\n              <div\n                class=\"body-header\"\n                [ngClass]=\"{\n                  'text-align-one-content': contents?.length === 1\n                }\"\n              >\n                <h2 *ngIf=\"feature.header.trim().length > 0\" class=\"sub-header\">\n                  {{ feature.header }}\n                </h2>\n              </div>\n\n              <!-- Body Paragraph -->\n              <div\n                class=\"body-text\"\n                [ngClass]=\"{\n                  'text-align-one-content': contents?.length === 1\n                }\"\n              >\n                <p\n                  class=\"checkout-content\"\n                  [attr.aria-label]=\"feature.content\"\n                  role=\"document\"\n                  [innerHTML]=\"feature.content\"\n                ></p>\n              </div>\n            </div>\n\n            <!-- Learn more CTA -->\n            <div\n              [ngClass]=\"{\n                'text-align-one-content': contents?.length === 1\n              }\"\n            >\n              <button\n                #cta\n                *ngIf=\"feature.CTALabel?.trim().length > 0\"\n                cdsButton=\"tertiary\"\n                class=\"cta-button content-link cds-button-tertiary-with-icon\"\n                role=\"link\"\n                [attr.aria-label]=\"feature.CTALabel\"\n                (click)=\"\n                  onCTALinkClick(\n                    cta,\n                    feature.CTALink,\n                    feature.header,\n                    feature.CTALabel\n                  )\n                \"\n                [JFPToken]=\"false\"\n                size=\"default\"\n              >\n                <div\n                  style=\"display: flex; flex-direction: row; align-items: center;\"\n                >\n                  {{ feature.CTALabel }}\n                  <cds-icon\n                      type=\"2021\"\n                      name=\"257-chevron-right\"\n                      altText=\"chevron-right\"\n                      ariaLabel=\"chevron-right icon\"\n                      [svgStyle]=\"{\n                        'width.px': 18,\n                        'height.px': 18,\n                      }\"\n                    ></cds-icon>\n                  <!-- <cds-icon\n                    class = \"button-icon\"\n                    idStr=\"icon-id\"\n                    ariaLabel=\"Arial Label Text\"\n                    altText=\"Alt text\"\n                    type=\"sfi\"\n                    name=\"04-right\"\n                    size=\"medium\"\n                    shade=\"dark\"\n                    [pathColor]=\"ctaIconColor\"\n                    style=\"margin-left: 4px;\"\n                  ></cds-icon> -->\n                </div>\n              </button>\n            </div>\n          </div>\n        </div>\n\n        <!-- Modal Footer -->\n        <div\n          [ngClass]=\"{\n            'wn-modal-footer-one-content': contents?.length === 1,\n            'wn-modal-footer': contents?.length > 1\n          }\"\n        >\n          <img\n            class=\"side-image\"\n            [src]=\"noneFeature.imgUrl\"\n            [attr.alt]=\"noneFeature?.imgAltText || ''\"\n          />\n        </div>\n      </div>\n    </cds-modal-dialog>\n  </div>\n</div>\n", styles: [".mobile-evolution-wn .close-btn{background:none;border:none;cursor:pointer}.mobile-evolution-wn .close-icon-wrapper{position:absolute;top:0;right:0}.mobile-evolution-wn .body-container{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-around;margin:1rem}.mobile-evolution-wn .flex-items{display:flex;flex-direction:column;gap:1rem;align-self:auto;justify-content:space-evenly}.mobile-evolution-wn .wn-modal-header{font-family:Interstate_Regular;font-size:21px;line-height:27px;text-align:left;margin-right:3rem}.mobile-evolution-wn .line-break{width:95%;margin:0 auto;padding-top:1rem}.mobile-evolution-wn .sub-header{font-family:Interstate_Bold;font-size:21px!important;line-height:27px;letter-spacing:0px;text-align:left}.mobile-evolution-wn .image-border{display:none;width:64px;height:64px}.mobile-evolution-wn .body-text{font-family:Interstate_Regular;font-style:normal;font-weight:300;font-size:16px;line-height:24px}.mobile-evolution-wn .cta-button{padding:0!important}.mobile-evolution-wn .wn-modal-footer{padding:0}.mobile-evolution-wn .side-image{max-width:100%}.mobile-evolution-wn .text-align-one-content{text-align:left}.mobile-evolution-wn .checkout-content{margin-bottom:0!important}@media (min-width: 645px){.mobile-evolution-wn .wn-modal{max-height:500px!important;max-width:1000px!important}.mobile-evolution-wn .cds-modal-content{flex-direction:row-reverse}.mobile-evolution-wn .wn-modal-footer{width:45%}.mobile-evolution-wn .line-break{display:none}.mobile-evolution-wn .image-border{display:block}.mobile-evolution-wn .flex{flex-direction:column-reverse}.mobile-evolution-wn .content-container{width:55%}.mobile-evolution-wn .body-container{margin:3rem 3rem 3rem 0rem}.mobile-evolution-wn .wn-modal-container{max-width:902px}.mobile-evolution-wn .wn-modal-header{font-family:Interstate_Light;font-size:32px;line-height:42px;font-weight:300;letter-spacing:0px;text-align:left}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: CdsModalDialogModule }, { kind: "component", type: i7.CdsModalDialogComponent, selector: "cds-modal-dialog", inputs: ["isOpen", "isClosedOnBackdropClick", "isClosedOnEscape", "hasFade", "ariaRole", "isRestoreFocusDisabled", "ariaLabel", "ariaLabelledby", "fadeTime"], outputs: ["isOpenChange", "openStart", "openEnd", "closeStart", "closeEnd"] }, { kind: "ngmodule", type: CdsButtonModule }, { kind: "directive", type: i7.CdsButton, selector: "button[cdsButton],button[cds-button],a[cdsButton],a[cds-button]", inputs: ["cdsButton", "size", "buttonIcon", "arrowRight", "arrowLeft", "JFPToken"], exportAs: ["cdsButton"] }, { kind: "ngmodule", type: CdsIconModule }, { kind: "component", type: i7.CdsIcon, selector: "cds-icon", inputs: ["role", "idStr", "ariaLabel", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "altText", "shade", "name", "pathColor", "circleColor"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: WhatsNewMobileEvoModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-whats-new-mobile-evo-modal', standalone: true, imports: [CommonModule, CdsModalDialogModule, CdsButtonModule, CdsIconModule], template: "<!-- CDS Modal -->\n<div class=\"cbolui-cds\">\n  <div\n    class=\"mobile-evolution-wn\"\n  >\n    <cds-modal-dialog\n      [(isOpen)]=\"showModal\"\n      [isClosedOnEscape]=\"false\"\n      [isClosedOnBackdropClick]=\"false\"\n      [hasFade]=\"true\"\n    >\n      <div\n        cdsModalInitialFocus\n        ngClass='cds-modal-content cds-modal-xl'\n        class = \"wn-modal\"\n        role=\"dialog\"\n      >\n        <!-- Modal Close Icon -->\n        <div class=\"close-icon-wrapper\">\n          <button\n            #close\n            class=\"cds-modal2-close close-btn\"\n            cdsButton=\"secondary\"\n            buttonIcon=\"icon\"\n            size=\"small\"\n            (click)=\"doneModal(close)\"\n            aria-label=\"Modal Close\"\n          >\n            <cds-icon\n              class=\"close-icon\"\n              type=\"2021\"\n              name=\"044-close\"\n              alt=\"close-icon\"\n              [svgStyle]=\"{ 'width.px': '20', 'height.px': '20' }\"\n              aria-hidden=\"true\"\n            ></cds-icon>\n          </button>\n        </div>\n\n        <!-- Modal Body -->\n        <div class=\"body-container\">\n          <div\n            class=\"flex-items\"\n            *ngFor=\"let feature of contents; let idx = index\"\n          >\n            <!-- Modal Header -->\n            <div\n              [ngClass]=\"{\n                'wn-modal-header-one-content': contents?.length === 1\n              }\"\n            >\n              <h1\n                class=\"wn-modal-header\"\n                #elemRef\n                [innerHTML]=\"noneFeature?.title\"\n              ></h1>\n            </div>\n\n            <hr class=\"line-break\"/>\n\n            <!-- QR Image -->\n            <div\n              *ngIf=\"feature.iconUrl && contents?.length === 1\"\n              class=\"image-border\"\n            >\n              <img\n                class=\"qr-image\"\n                [src]=\"feature.iconUrl\"\n                [attr.alt]=\"feature?.iconAltText || ''\"\n              />\n            </div>\n\n            <div>\n              <!-- Sub Header -->\n              <div\n                class=\"body-header\"\n                [ngClass]=\"{\n                  'text-align-one-content': contents?.length === 1\n                }\"\n              >\n                <h2 *ngIf=\"feature.header.trim().length > 0\" class=\"sub-header\">\n                  {{ feature.header }}\n                </h2>\n              </div>\n\n              <!-- Body Paragraph -->\n              <div\n                class=\"body-text\"\n                [ngClass]=\"{\n                  'text-align-one-content': contents?.length === 1\n                }\"\n              >\n                <p\n                  class=\"checkout-content\"\n                  [attr.aria-label]=\"feature.content\"\n                  role=\"document\"\n                  [innerHTML]=\"feature.content\"\n                ></p>\n              </div>\n            </div>\n\n            <!-- Learn more CTA -->\n            <div\n              [ngClass]=\"{\n                'text-align-one-content': contents?.length === 1\n              }\"\n            >\n              <button\n                #cta\n                *ngIf=\"feature.CTALabel?.trim().length > 0\"\n                cdsButton=\"tertiary\"\n                class=\"cta-button content-link cds-button-tertiary-with-icon\"\n                role=\"link\"\n                [attr.aria-label]=\"feature.CTALabel\"\n                (click)=\"\n                  onCTALinkClick(\n                    cta,\n                    feature.CTALink,\n                    feature.header,\n                    feature.CTALabel\n                  )\n                \"\n                [JFPToken]=\"false\"\n                size=\"default\"\n              >\n                <div\n                  style=\"display: flex; flex-direction: row; align-items: center;\"\n                >\n                  {{ feature.CTALabel }}\n                  <cds-icon\n                      type=\"2021\"\n                      name=\"257-chevron-right\"\n                      altText=\"chevron-right\"\n                      ariaLabel=\"chevron-right icon\"\n                      [svgStyle]=\"{\n                        'width.px': 18,\n                        'height.px': 18,\n                      }\"\n                    ></cds-icon>\n                  <!-- <cds-icon\n                    class = \"button-icon\"\n                    idStr=\"icon-id\"\n                    ariaLabel=\"Arial Label Text\"\n                    altText=\"Alt text\"\n                    type=\"sfi\"\n                    name=\"04-right\"\n                    size=\"medium\"\n                    shade=\"dark\"\n                    [pathColor]=\"ctaIconColor\"\n                    style=\"margin-left: 4px;\"\n                  ></cds-icon> -->\n                </div>\n              </button>\n            </div>\n          </div>\n        </div>\n\n        <!-- Modal Footer -->\n        <div\n          [ngClass]=\"{\n            'wn-modal-footer-one-content': contents?.length === 1,\n            'wn-modal-footer': contents?.length > 1\n          }\"\n        >\n          <img\n            class=\"side-image\"\n            [src]=\"noneFeature.imgUrl\"\n            [attr.alt]=\"noneFeature?.imgAltText || ''\"\n          />\n        </div>\n      </div>\n    </cds-modal-dialog>\n  </div>\n</div>\n", styles: [".mobile-evolution-wn .close-btn{background:none;border:none;cursor:pointer}.mobile-evolution-wn .close-icon-wrapper{position:absolute;top:0;right:0}.mobile-evolution-wn .body-container{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-around;margin:1rem}.mobile-evolution-wn .flex-items{display:flex;flex-direction:column;gap:1rem;align-self:auto;justify-content:space-evenly}.mobile-evolution-wn .wn-modal-header{font-family:Interstate_Regular;font-size:21px;line-height:27px;text-align:left;margin-right:3rem}.mobile-evolution-wn .line-break{width:95%;margin:0 auto;padding-top:1rem}.mobile-evolution-wn .sub-header{font-family:Interstate_Bold;font-size:21px!important;line-height:27px;letter-spacing:0px;text-align:left}.mobile-evolution-wn .image-border{display:none;width:64px;height:64px}.mobile-evolution-wn .body-text{font-family:Interstate_Regular;font-style:normal;font-weight:300;font-size:16px;line-height:24px}.mobile-evolution-wn .cta-button{padding:0!important}.mobile-evolution-wn .wn-modal-footer{padding:0}.mobile-evolution-wn .side-image{max-width:100%}.mobile-evolution-wn .text-align-one-content{text-align:left}.mobile-evolution-wn .checkout-content{margin-bottom:0!important}@media (min-width: 645px){.mobile-evolution-wn .wn-modal{max-height:500px!important;max-width:1000px!important}.mobile-evolution-wn .cds-modal-content{flex-direction:row-reverse}.mobile-evolution-wn .wn-modal-footer{width:45%}.mobile-evolution-wn .line-break{display:none}.mobile-evolution-wn .image-border{display:block}.mobile-evolution-wn .flex{flex-direction:column-reverse}.mobile-evolution-wn .content-container{width:55%}.mobile-evolution-wn .body-container{margin:3rem 3rem 3rem 0rem}.mobile-evolution-wn .wn-modal-container{max-width:902px}.mobile-evolution-wn .wn-modal-header{font-family:Interstate_Light;font-size:32px;line-height:42px;font-weight:300;letter-spacing:0px;text-align:left}}\n"] }]
        }], propDecorators: { showModal: [{
                type: Input
            }], contents: [{
                type: Input
            }], noneFeature: [{
                type: Input
            }], close: [{
                type: Output
            }], cta: [{
                type: Output
            }] } });

class WhatsNewModalComponent {
    /*
     * CAUSING ERRORS with injections
     */
    constructor(_httpService, _cookieService, 
    // private focusMonitor: FocusMonitor,
    _document) {
        this._httpService = _httpService;
        this._cookieService = _cookieService;
        this._document = _document;
        this.contents = [];
        this.showModal = true;
        this._featureTypeArray = [];
        this.action = 'cta clicked';
        this.parent_app_hierarchy = `secure|accounts|activity|dashboard: citi summary`;
        this.putUserActionRequest = {
            applicationId: 'CBOL',
            applicationVersion: '',
            label: 'description of which button was clicked. "Got it" or "dismiss" or "Remind Me Later"'
        };
        this.close = new EventEmitter();
        this.updateFlag = true;
        this._window = this._document.defaultView;
        if (!!window) {
            this.hostname = window.location.origin;
            if (this.hostname.includes('4200')) {
                this.hostname += '/US/ag';
            }
        }
    }
    ngOnInit() {
        this.setContent();
    }
    YOUR_OPTIONAL_METHOD(e) {
        this.devLog('Tagging', e);
    }
    set appVersion(appVersion) {
        this._appVersion = appVersion;
    }
    set modality(modality) {
        this._modality = modality;
    }
    set customerType(customerType) {
        this._customerType = customerType;
    }
    set content(val) {
        this.getContents(val);
    }
    ngAfterViewInit() {
        // console.log("modality inside ngAfterViewInit ", this._modality);
        // this.focusMonitor.focusVia(this.elemRef, 'program');
        this.siteCatOnOverlay(this._modality);
    }
    setContent() {
        this.header1 = this.contents[0]?.header;
        this.header2 = (this.contents[1]?.header) || "";
        this.header3 = (this.contents[2]?.header) || "";
        this.ctaLabel1 = this.contents[0]?.CTALabel;
        this.ctaLabel2 = (this.contents[1]?.CTALabel) || "";
        this.ctaLabel3 = (this.contents[2]?.CTALabel) || "";
    }
    getContents(icmsVal) {
        this.contents = [];
        // console.log('WhatsNew Customer Type For modal -->', this._customerType);
        this.noneFeature = icmsVal[`copy$$${this._modality}`][this._appVersion];
        this.putUserActionRequest.applicationVersion = this._appVersion;
        this.devLog('noneFeature -->', this.noneFeature);
        // console.log('wpbData', this.noneFeature?.wpbData)
        for (let features in this.noneFeature) {
            // console.log("this._modality === 'whats_new_wpb': ", this._modality === 'whats_new_wpb')
            // if (this._modality === 'whats_new_wpb' && features.includes('Feature')) {
            //   this.contents.push(this.noneFeature[features]);
            //   if (Object.keys(this.noneFeature).includes('wpbData')) {//TO DO:replace wpbData with the OrgID when available
            //     this.wpbOrgLogo = this.noneFeature?.wpbData?.wpbImgURL;
            //   }
            //   this.wpbOrgLogo = '/JRS/banners/whats_new/combinedPlaceholder.png';
            // }
            // else
            if (this._customerType === 'Travel_customerType' && features.includes('Travel')) {
                this.contents.push(this.noneFeature[features]);
            }
            else if (this._customerType === 'Gold_customerType' && features.includes('Gold')) {
                this.contents.push(this.noneFeature[features]);
            }
            else if (this._customerType === 'Priority_customerType' && features.includes('Priority')) {
                this.contents.push(this.noneFeature[features]);
            }
            else if (this._customerType === 'CPC_customerType' && features.includes('CPC')) {
                this.contents.push(this.noneFeature[features]);
            }
            else if (this._customerType === 'Default_customerType' && features.includes('Default')) {
                this.contents.push(this.noneFeature[features]);
            }
        }
        if (this.contents && this.contents.length > 0 && this.contents.length < 4) {
            this.contents.sort((content1, content2) => content1.order > content2.order ? 1 : -1);
        }
        else {
            this.showModal = false;
        }
    }
    onCTALinkClick(data) {
        this.siteCatOnClick(data.header_text, data.cta_label);
        if (data.urlVal.includes('citi.com') || data.urlVal.includes('/US/ag/') || data.urlVal.includes('dashboard') || data.urlVal.includes('https://')) {
            window.open(data.urlVal, '_self');
        }
        else {
            if (!!confirm('Important Information: \nYou are leaving a Citibank Website and going to a third party site. That site may have a privacy policy different from Citibank and may provide less security than this Citibank site. Citibank and its affiliates are not responsible for the products, services, and content on the third party website. Do you want to go to the third party site?')) {
                window.open(data.urlVal, '_blank');
            }
            else {
                return;
            }
        }
        // set cookie to prevent modal pop-up again in same route.
        if (!this._cookieService.getCookie('ctaWNSeen')) {
            const now = new Date();
            const expDate = new Date(now.getTime() + 2 * 60 * 60 * 1000); //cookie will expire after 120 minutes, * 60 seconds per minute, * 1000 ms per second
            Cookie.set('ctaWNSeen', 'true', expDate);
            this.devLog('ctaWNSeen Cookie has been set, Cookie will be expired on -->', expDate);
        }
        this.doneModal(data.target);
    }
    doneModal(target) {
        this.showModal = false;
        // WPB code
        // if (this._modality === 'whats_new_wpb') {
        //   delete this.putUserActionRequest.applicationVersion;
        //   this.putUserActionRequest["requestType"] = 'TUTORIALS';
        //   this.putUserActionRequest["tutorial"] = {
        //     action: 'FINISHED',
        //     id: 'ff_citiatworkWelcome'
        //   };
        //   const expDate = new Date();
        //   expDate.setDate(expDate.getDate() + 30);
        //   console.log('wpbSeen cookie set! exp date: ', expDate.toString());
        //   Cookie.set('wpbSeen', 'y', expDate, '/', '.citi.com', true);
        // };
        let targetClass = target.getAttribute("class");
        //set label value in object before sending put request
        if (targetClass.includes('remind-me-later')) {
            this.siteCatOnRemindMeLater();
            this.putUserActionRequest.label = 'Remind Me Later';
        }
        else if (targetClass.includes('content-link')) {
            this.putUserActionRequest.label = 'ctaClicked';
        }
        else {
            this.putUserActionRequest.label = 'dismissed';
        }
        this.devLog("Done Modal, putUserActionRequest:", this.putUserActionRequest);
        if (this.updateFlag) {
            this._httpService
                .put('/digital/userActions/update', this.putUserActionRequest)
                .subscribe(val => this.devLog('API Call Response Value -->', val, '-->' + this.putUserActionRequest.label, '-->', this.putUserActionRequest));
        }
        this.close.emit('close');
    }
    siteCatOnOverlay(modality) {
        // console.log("modality inside siteCatOnOverlay", modality);
        // if (modality === "whats_new") {
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `${this.parent_app_hierarchy}:what's new`,
                form_type: `title_1=${this.header1}|cta_1=${this.ctaLabel1}|image_1=no|title_2=${this.header2}|cta_2=${this.ctaLabel2}|image_2=no|title_3=${this.header3}|cta_3=${this.ctaLabel3}|image_3=no}`
            };
            window.taggingDataLayer.applicationData('562aWhatsNewExperience', taggingDetails);
        }
        // }
        // else if (modality === "whats_new_wpb") {
        //   if ((window as any).taggingDataLayer) {
        //     const taggingDetails = { app_hierarchy: `public|marketing|workplace banking|welcome` };
        //     (<any>window).taggingDataLayer.applicationData(
        //       '555_1a0WorkplaceBanking-Welcome',
        //       taggingDetails
        //     );
        //   }
        // }
    }
    siteCatOnClick(header_text, cta_label) {
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `${this.parent_app_hierarchy}:what's new:${this.action}`,
                form_type: `title_1=${this.header1}|cta_1=${this.ctaLabel1}|image_1=no|title_2=${this.header2}|cta_2=${this.ctaLabel2}|image_2=no|title_3=${this.header3}|cta_3=${this.ctaLabel3}|image_3=no}`,
                link_name: `${header_text} | ${cta_label}`
            };
            window.taggingDataLayer.applicationData('562bWhatsNewExperience', taggingDetails);
        }
    }
    siteCatOnRemindMeLater() {
        if (window.taggingDataLayer) {
            const taggingDetails = {
                app_hierarchy: `${this.parent_app_hierarchy}:what's new:${this.action}`,
                form_type: `title_1=${this.header1}|cta_1=${this.ctaLabel1}|image_1=no|title_2=${this.header2}|cta_2=${this.ctaLabel2}|image_2=no|title_3=${this.header3}|cta_3=${this.ctaLabel3}|image_3=no}`,
                link_name: `Remind me Later`
            };
            window.taggingDataLayer.applicationData('562cWhatsNewExperience', taggingDetails);
        }
    }
    devLog(...args) {
        if (isDevMode()) {
            console.log('WN:', ...args);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: WhatsNewModalComponent, deps: [{ token: i2.HttpService }, { token: i1.CookieService }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: WhatsNewModalComponent, isStandalone: false, selector: "citi-whats-new-modal", inputs: { appVersion: "appVersion", modality: "modality", customerType: "customerType", content: "content", updateFlag: "updateFlag" }, outputs: { close: "close" }, viewQueries: [{ propertyName: "elemRef", first: true, predicate: ["elemRef"], descendants: true }], ngImport: i0, template: "<citi-whats-new-bau-modal\n  *ngIf=\"noneFeature?.modalType != 'Mobile Evolution'\"\n  [(showModal)]=\"showModal\"\n  [contents]=\"contents\"\n  [noneFeature]=\"noneFeature\"\n  [modality]=\"_modality\"\n  [customerType]=\"_customerType\"\n  (close)=\"doneModal($event)\"\n  (cta)=\"onCTALinkClick($event)\"\n></citi-whats-new-bau-modal>\n\n<citi-whats-new-mobile-evo-modal\n  *ngIf=\"noneFeature?.modalType == 'Mobile Evolution'\"\n  [(showModal)]=\"showModal\"\n  [contents]=\"contents\"\n  [noneFeature]=\"noneFeature\"\n  (close)=\"doneModal($event)\"\n  (cta)=\"onCTALinkClick($event)\"\n></citi-whats-new-mobile-evo-modal>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: WhatsNewBauModalComponent, selector: "citi-whats-new-bau-modal", inputs: ["showModal", "contents", "noneFeature", "modality", "customerType"], outputs: ["close", "cta"] }, { kind: "component", type: WhatsNewMobileEvoModalComponent, selector: "citi-whats-new-mobile-evo-modal", inputs: ["showModal", "contents", "noneFeature"], outputs: ["close", "cta"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: WhatsNewModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-whats-new-modal', standalone: false, template: "<citi-whats-new-bau-modal\n  *ngIf=\"noneFeature?.modalType != 'Mobile Evolution'\"\n  [(showModal)]=\"showModal\"\n  [contents]=\"contents\"\n  [noneFeature]=\"noneFeature\"\n  [modality]=\"_modality\"\n  [customerType]=\"_customerType\"\n  (close)=\"doneModal($event)\"\n  (cta)=\"onCTALinkClick($event)\"\n></citi-whats-new-bau-modal>\n\n<citi-whats-new-mobile-evo-modal\n  *ngIf=\"noneFeature?.modalType == 'Mobile Evolution'\"\n  [(showModal)]=\"showModal\"\n  [contents]=\"contents\"\n  [noneFeature]=\"noneFeature\"\n  (close)=\"doneModal($event)\"\n  (cta)=\"onCTALinkClick($event)\"\n></citi-whats-new-mobile-evo-modal>\n" }]
        }], ctorParameters: () => [{ type: i2.HttpService }, { type: i1.CookieService }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { elemRef: [{
                type: ViewChild,
                args: ['elemRef', { static: false }]
            }], close: [{
                type: Output
            }], appVersion: [{
                type: Input
            }], modality: [{
                type: Input
            }], customerType: [{
                type: Input
            }], content: [{
                type: Input
            }], updateFlag: [{
                type: Input
            }] } });

const MODULES = [
    CommonModule,
    CdsIconModule,
    CdsModalDialogModule,
    CdsButtonModule,
    WhatsNewBauModalComponent,
    WhatsNewMobileEvoModalComponent
];
class WhatsNewModalModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: WhatsNewModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: WhatsNewModalModule, declarations: [WhatsNewModalComponent], imports: [CommonModule,
            CdsIconModule,
            CdsModalDialogModule,
            CdsButtonModule,
            WhatsNewBauModalComponent,
            WhatsNewMobileEvoModalComponent], exports: [WhatsNewModalComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: WhatsNewModalModule, providers: [
            CookieService, StorageService, WINDOW_PROVIDER
        ], imports: [MODULES] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: WhatsNewModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [WhatsNewModalComponent],
                    imports: [...MODULES],
                    exports: [WhatsNewModalComponent],
                    providers: [
                        CookieService, StorageService, WINDOW_PROVIDER
                    ],
                }]
        }] });

class BasketjsService {
    constructor(_document, appConfigService) {
        this._document = _document;
        this.appConfigService = appConfigService;
        this.environment = this.appConfigService.getConfig('environment');
    }
    injectBasketScript() {
        const basketScriptUrl = 'cbol-core-assets/basket/basket.js';
        const basketScript = this._document.createElement('script');
        basketScript.setAttribute('src', basketScriptUrl);
        basketScript.setAttribute('id', 'basket');
        basketScript.setAttribute('async', 'true');
        this._document.getElementsByTagName('head')[0].appendChild(basketScript);
    }
    initRequire() {
        let cedricScriptUrl = '';
        if (this.isProd()) {
            cedricScriptUrl = `cbol-core-assets/cedric/cedric.js`;
        }
        else {
            cedricScriptUrl = `cbol-core-assets/cedric/cedrictest.js`;
        }
        basket.require({
            url: cedricScriptUrl
        }).then(() => {
            console.log("basket require script complete");
        });
    }
    isProd() {
        return this.environment === 'PROD';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BasketjsService, deps: [{ token: DOCUMENT }, { token: i1.AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BasketjsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BasketjsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1.AppConfigService }] });

/**
 * Represents the ErrorPageComponent.
 */
class ErrorPageComponent {
    constructor(_cdsService, layoutsService, _window, _storageService, _appConfigService, _metaService, _taggingService, _activatedRoute, _router, httpService) {
        this._cdsService = _cdsService;
        this.layoutsService = layoutsService;
        this._window = _window;
        this._storageService = _storageService;
        this._appConfigService = _appConfigService;
        this._metaService = _metaService;
        this._taggingService = _taggingService;
        this._activatedRoute = _activatedRoute;
        this._router = _router;
        this.httpService = httpService;
        this.relativePath = '';
        this.locale = '';
        this.citiUrl = '';
        this.iconSizeMobile = { 'width.px': '80', 'height.px': '80' };
        this.iconSizeDesktop = { 'width.px': '200', 'height.px': '200' };
        this.innerWidth = 991;
        this.pageLevelJamp = true;
        this.isBAOsunsetErrorPage = false;
    }
    ngOnInit() {
        this._cdsService.enableCds();
        this.setMetaTags();
        this.layoutsService.changeFullbleed(true);
        this.innerWidth = this._window?.innerWidth;
        this.logApi();
        this.handleQueryparam();
    }
    ngOnDestroy() {
        this._cdsService.disableCds();
        this.layoutsService.changeFullbleed(false);
        this._metaService.removeTag("name='robots'");
    }
    setMetaTags() {
        this._metaService.addTag({ name: 'robots', content: 'noindex,nofollow' });
    }
    handleQueryparam() {
        this._activatedRoute.queryParams.subscribe(param => {
            if (param['openSearchPanel']) {
                this.toggleSearchPanel();
                this._router.navigate([], {
                    relativeTo: this._activatedRoute,
                    queryParams: {},
                    replaceUrl: true
                });
            }
            this.isBAOsunsetErrorPage = (param['errorPage'] === 'BAOsunset');
        });
    }
    taggingPagename() {
        const pageType = this.isUserLoggedIn() ? '656aGerenralErrorPageSecure' : '656cGerenralErrorPagePublic';
        const custError = '404: Page not Found. Please check the URL and try again';
        this._taggingService.triggerPageTagging("nonicms_content", this.isUserLoggedIn(), pageType, {
            dynamicContent: { cust_error: this.errorCopy.custError }
        });
    }
    isUserLoggedIn() {
        return sessionStorage.getItem('sessionPostBrandingStorage') !== null;
    }
    // To get the data from the ICMS
    logApi() {
        const locale = this._storageService.get('locale');
        this.locale = locale === 'es_US' ? 'es_US' : 'en_US';
        this.relativePath = '/CBOL/IA/Angular/Servicing/';
        const errorContent = `${window.location.origin}${this.relativePath}${this.locale}/errorServicingContent.json`;
        this.httpService.get(errorContent).subscribe((res) => {
            const errorPage = this.isBAOsunsetErrorPage ? res.data.find((page) => page.pageName === 'BAOErrorPageNew') : res.data.find((page) => page.pageName === 'ErrorPageNew');
            this.errorCopy = errorPage;
            this.pageLevelJamp = false;
            setTimeout(() => {
                this.taggingPagename();
            }, 3000);
        }, (error) => {
            //Serving as the fallback content in case of error
            this.errorCopy = this.isBAOsunsetErrorPage ? {
                "pageName": "BAOErrorPageNew",
                "header": {
                    "title": "Important information regarding this credit card account",
                    "description": [
                        "Effective <b>November 8, 2025</b>, Citi has discontinued access to Citi Account Online for the account you have tried to access. You may instead call customer service at <a href='tel:1-800-950-5114'>1-800-950-5114</a> for your account servicing needs, including making payments. TTY: We accept <a href='tel:711'>711</a> or other relay service.",
                        "The responsible party or parties defined as ‘you, your, and yours’ in the Card Agreement will remain liable for paying the account balance as stated in the existing terms. Payments can be made over the phone, by mail to the address provided on the monthly billing statement, or with a third party bill payment option, subject to availability.",
                        "If this account is enrolled in Autopay, payments will continue to be processed as normal, and you do not need to take any action. In addition, all Online payments scheduled before <b>November 8, 2025</b> will still be processed as normal on the date specified.",
                        "As of <b>November 2025</b>, we will no longer provide any statements or legal notices regarding this account electronically. Instead, we will mail paper statements and legal notices for this account to the billing address we have on file."
                    ]
                },
                "custError": "404: Important information regarding this credit card account"
            } : {
                "pageName": "ErrorPageNew",
                "header": {
                    "title": "Hmm... looks like that information isn't here",
                    "description": "The page you're looking for has either moved or does not exist, but we can still help. Try finding your information in one of these places:",
                },
                "buttonCopy": {
                    "returnToYourDashboard": "Return to your account",
                    "citi": "Citi.com",
                    "findABranch": "Find a branch",
                    "howCanWeHelp": "How can we help?"
                },
                "custError": "404: Page not Found. Please check the URL and try again"
            };
            this.pageLevelJamp = false;
        });
    }
    // This function toggles the search panel when "Help & FAQs" link is clicked
    toggleSearchPanel() {
        const currentSearchState = this.layoutsService.toggleSearchPanel.getValue();
        this.layoutsService.toggleSearchPanel.next(!currentSearchState);
        // When opening search panel from the footer, scroll to top of page
        if (!currentSearchState) {
            this._window.scrollTo(0, 0);
        }
        const eventTagging = this.isUserLoggedIn() ? '656bGerenralErrorPageSecureCTAClicks' : '656dGerenralErrorPagePublicCTAClicks';
        const linkName = `error page - ${this.errorCopy?.buttonCopy.howCanWeHelp} clicked`;
        const app_hierarchy = this.isUserLoggedIn() ? 'secure|' : 'public|';
        this._taggingService.triggerEventTagging('nonicms_content', eventTagging, {
            dynamicContent: {
                link_name: linkName,
                app_hierarchy: app_hierarchy + "account|general error|landing:cta clicked"
            }
        });
    }
    // This method navigates to location-finder
    navigateToMaps() {
        const mapUrl = `${this._appConfigService.getcsrHostName()}/US/ag/citibank-location-finder`;
        this._window.location.replace(mapUrl);
        const eventTagging = this.isUserLoggedIn() ? '656bGerenralErrorPageSecureCTAClicks' : '656dGerenralErrorPagePublicCTAClicks';
        const linkName = `${this.errorCopy?.buttonCopy.findABranch} clicked`;
        const app_hierarchy = this.isUserLoggedIn() ? 'secure|' : 'public|';
        this._taggingService.triggerEventTagging('nonicms_content', eventTagging, {
            dynamicContent: {
                link_name: linkName,
                app_hierarchy: app_hierarchy + "account|general error|landing:cta clicked"
            }
        });
    }
    // This method navigates to citi.com
    navigateTociti() {
        const citiUrl = this._appConfigService.getnewCitiHostName();
        this._window.location.replace(citiUrl);
        const eventTagging = this.isUserLoggedIn() ? '656bGerenralErrorPageSecureCTAClicks' : '656dGerenralErrorPagePublicCTAClicks';
        const linkName = `${this.errorCopy?.buttonCopy.citi} clicked`;
        const app_hierarchy = this.isUserLoggedIn() ? 'secure|' : 'public|';
        this._taggingService.triggerEventTagging('nonicms_content', eventTagging, {
            dynamicContent: {
                link_name: linkName,
                app_hierarchy: app_hierarchy + "account|general error|landing:cta clicked"
            }
        });
    }
    // This will navigate to dashboard
    navigateToDashboard() {
        const dashboardUrl = `${this._appConfigService.getcsrHostName()}/US/ag/dashboard`;
        this._window.location.replace(dashboardUrl);
        const eventTagging = this.isUserLoggedIn() ? '656bGerenralErrorPageSecureCTAClicks' : '656dGerenralErrorPagePublicCTAClicks';
        const linkName = `${this.errorCopy?.buttonCopy.returnToYourDashboard} clicked`;
        const app_hierarchy = this.isUserLoggedIn() ? 'secure|' : 'public|';
        this._taggingService.triggerEventTagging('nonicms_content', eventTagging, {
            dynamicContent: {
                link_name: linkName,
                app_hierarchy: app_hierarchy + "account|general error|landing:cta clicked"
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ErrorPageComponent, deps: [{ token: i3.CDSService }, { token: i3.LayoutsService }, { token: WINDOW }, { token: i1.StorageService }, { token: i1.AppConfigService }, { token: i4$2.Meta }, { token: i1.TaggingService }, { token: i4.ActivatedRoute }, { token: i4.Router }, { token: i2.HttpService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: ErrorPageComponent, isStandalone: true, selector: "error-page", ngImport: i0, template: "<citi-simple-layout role=\"main\">\n  <div class=\"container container-BAO\">\n    <div *ngIf=\"isBAOsunsetErrorPage\">\n      <cds-icon class=\"icon-center\"\n        idStr=\"173-alert-warning\"\n        ariaLabel=\"Alert Icon\"\n        type=\"2021\"\n        name=\"173-alert-warning\"\n        [svgStyle]=\"{'width.px': '60' , 'height.px': '60' }\"\n      ></cds-icon>\n      <h1 role=\"heading\" aria-level=\"1\" class=\"centered-text bao-header\">{{errorCopy?.header?.title}}</h1>\n      <p *ngFor=\"let para of errorCopy?.header?.description\" [innerHTML]=\"para\"></p>\n    </div>\n  </div>\n\n  <div class=\"container\" *ngIf=\"!isBAOsunsetErrorPage\">\n    <cds-column\n      [sm]=\"12\"\n      [lg]=\"8\"\n      class=\"first-column\"\n    >\n      <h2\n        role=\"heading\"\n        aria-level=\"1\"\n        class=\"heading\"\n      >{{errorCopy?.header?.title}}</h2>\n      <p class=\"text-para\">{{errorCopy?.header?.description}}\n      </p>\n      <div role=\"grid\">\n        <cds-row\n          role=\"row\"\n          aria-labelledby=\"grid-heading\"\n        >\n          <cds-column\n            role=\"gridcell\"\n            sm=\"12\"\n            lg=\"4\"\n            class=\"btn\"\n            aria-labelledby=\"grid-heading\"\n          >\n            <div class=\"text-center bold\">\n              <button\n                type=\"button\"\n                cdsButton=\"secondary\"\n                class=\"btn-width\"\n                (click)=\"isUserLoggedIn() ? navigateToDashboard() : navigateTociti()\"\n              >\n                {{isUserLoggedIn() ? errorCopy?.buttonCopy?.returnToYourDashboard : errorCopy?.buttonCopy?.citi}}\n              </button>\n            </div>\n          </cds-column>\n          <cds-column\n            role=\"gridcell\"\n            sm=\"12\"\n            lg=\"4\"\n            class=\"btn\"\n            aria-labelledby=\"grid-heading\"\n          >\n            <div class=\"text-center bold\">\n              <button\n                type=\"button\"\n                cdsButton=\"secondary\"\n                class=\"btn-width\"\n                (click)=\"navigateToMaps()\"\n              >\n                {{errorCopy?.buttonCopy?.findABranch}}\n              </button>\n            </div>\n          </cds-column>\n          <cds-column\n            role=\"gridcell\"\n            sm=\"12\"\n            lg=\"4\"\n            class=\"btn\"\n            aria-labelledby=\"grid-heading\"\n          >\n            <div class=\"text-center bold\">\n              <button\n                type=\"button\"\n                cdsButton=\"secondary\"\n                class=\"btn-width\"\n                (click)=\"toggleSearchPanel()\"\n              >\n                {{errorCopy?.buttonCopy?.howCanWeHelp}}\n              </button>\n            </div>\n          </cds-column>\n        </cds-row>\n      </div>\n    </cds-column>\n    <cds-column\n      [sm]=\"12\"\n      [lg]=\"4\"\n      class=\"second-column\"\n    >\n      <cds-icon\n        idStr=\"error-comp-icon\"\n        ariaLabel=\"error_icon\"\n        altText=\"error_icon\"\n        type=\"2021\"\n        name=\"254-search-risk-control\"\n        [svgStyle]=\"innerWidth > 991 ? iconSizeDesktop : iconSizeMobile\"\n      ></cds-icon>\n    </cds-column>\n  </div>\n  <!-- Loading State -->\n  <cds-jamp\n    [visible]=\"pageLevelJamp\"\n    waitMessage=\"Hang On\"\n    [useGif]=\"pageLevelJamp\"\n    [pagelevel]=\"pageLevelJamp\"\n  ></cds-jamp>\n</citi-simple-layout>", styles: [".container{display:flex;flex-direction:row;margin-top:120px;width:fit-content}.container .heading{font-family:Interstate_Regular,sans-serif;font-size:36px}.container .cbolui-cds .cds-column{padding:0}.container .second-column{display:flex;align-items:center;justify-content:space-around;padding-left:5%}.container .btn-width{width:100%;overflow:hidden;white-space:nowrap}.container .cds-column.col-sm-12{padding-left:0}.container #error-comp-icon{width:210px;margin:3rem;height:170px}.container .text-para{font-size:18px;margin-bottom:40px;margin-top:16px;font-family:Interstate_Light,sans-serif}.container .btn{padding-right:40px;padding-left:0}@media screen and (max-width: 991px){.container{padding:0rem;flex-direction:column-reverse;margin:0%}.container .cds-column.col-sm-12{padding-left:12px}.container .heading{font-size:26px;font-weight:400}.container .btn{padding:0!important}.container .btn-width{margin-bottom:24px}.second-column{display:flex;justify-content:center;align-items:center;padding:40px 0}#error-comp-icon{height:100px;width:75px}.text-para{font-size:16px}}@media screen and (max-width: 436px){.heading{word-break:keep-all;text-align:center}}@media (min-width: 992px) and (max-width: 1485px){.btn{display:flex;flex-direction:column;max-width:100%;flex:100%;margin-bottom:2%}}@media (min-width: 1486px){.btn{max-width:33.33333333%}}.icon-center{display:flex;justify-content:center;align-items:center;--cds-icon-path-fill: #000;margin-top:20px;margin-bottom:40px}.centered-text{text-align:center}.bao-header{margin-bottom:2%}.container-BAO{display:flex;flex-direction:row;margin-top:50px!important;margin-left:10%;margin-right:10%;width:fit-content}.container-BAO ::ng-deep a{text-decoration:underline}\n"], dependencies: [{ kind: "ngmodule", type: CdsModalDialogModule }, { kind: "ngmodule", type: CdsIconModule }, { kind: "component", type: i7.CdsIcon, selector: "cds-icon", inputs: ["role", "idStr", "ariaLabel", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "altText", "shade", "name", "pathColor", "circleColor"] }, { kind: "ngmodule", type: Layouts }, { kind: "component", type: i3.SimpleLayoutComponent, selector: "citi-simple-layout", inputs: ["theme", "endpoint", "responsive", "width", "singleBreakpoint", "cdsThemeEnabled", "pageId", "servicingType", "brandingType", "loading", "prelogin", "locale", "fullbleed", "waitMessage", "readyMessage"] }, { kind: "ngmodule", type: CdsButtonModule }, { kind: "directive", type: i7.CdsButton, selector: "button[cdsButton],button[cds-button],a[cdsButton],a[cds-button]", inputs: ["cdsButton", "size", "buttonIcon", "arrowRight", "arrowLeft", "JFPToken"], exportAs: ["cdsButton"] }, { kind: "ngmodule", type: CdsJampModule }, { kind: "component", type: i7.JampComponent, selector: "cds-jamp", inputs: ["useGif", "visible", "withCard", "pagelevel", "htmlContent", "additionalCssClasses", "waitMessage", "readyMessage", "isCenterAligned"] }, { kind: "ngmodule", type: CdsGridModule }, { kind: "component", type: i7.CdsRowComponent, selector: "cds-row", inputs: ["classes"] }, { kind: "component", type: i7.CdsColumnComponent, selector: "cds-column", inputs: ["xs", "sm", "md", "lg", "xl", "xxl", "offXs", "offSm", "offMd", "offLg", "offXl", "offXxl", "classes"] }, { kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ErrorPageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'error-page', standalone: true, imports: [CdsModalDialogModule, CdsIconModule, Layouts, CdsButtonModule, CdsJampModule, CdsGridModule, CommonModule], template: "<citi-simple-layout role=\"main\">\n  <div class=\"container container-BAO\">\n    <div *ngIf=\"isBAOsunsetErrorPage\">\n      <cds-icon class=\"icon-center\"\n        idStr=\"173-alert-warning\"\n        ariaLabel=\"Alert Icon\"\n        type=\"2021\"\n        name=\"173-alert-warning\"\n        [svgStyle]=\"{'width.px': '60' , 'height.px': '60' }\"\n      ></cds-icon>\n      <h1 role=\"heading\" aria-level=\"1\" class=\"centered-text bao-header\">{{errorCopy?.header?.title}}</h1>\n      <p *ngFor=\"let para of errorCopy?.header?.description\" [innerHTML]=\"para\"></p>\n    </div>\n  </div>\n\n  <div class=\"container\" *ngIf=\"!isBAOsunsetErrorPage\">\n    <cds-column\n      [sm]=\"12\"\n      [lg]=\"8\"\n      class=\"first-column\"\n    >\n      <h2\n        role=\"heading\"\n        aria-level=\"1\"\n        class=\"heading\"\n      >{{errorCopy?.header?.title}}</h2>\n      <p class=\"text-para\">{{errorCopy?.header?.description}}\n      </p>\n      <div role=\"grid\">\n        <cds-row\n          role=\"row\"\n          aria-labelledby=\"grid-heading\"\n        >\n          <cds-column\n            role=\"gridcell\"\n            sm=\"12\"\n            lg=\"4\"\n            class=\"btn\"\n            aria-labelledby=\"grid-heading\"\n          >\n            <div class=\"text-center bold\">\n              <button\n                type=\"button\"\n                cdsButton=\"secondary\"\n                class=\"btn-width\"\n                (click)=\"isUserLoggedIn() ? navigateToDashboard() : navigateTociti()\"\n              >\n                {{isUserLoggedIn() ? errorCopy?.buttonCopy?.returnToYourDashboard : errorCopy?.buttonCopy?.citi}}\n              </button>\n            </div>\n          </cds-column>\n          <cds-column\n            role=\"gridcell\"\n            sm=\"12\"\n            lg=\"4\"\n            class=\"btn\"\n            aria-labelledby=\"grid-heading\"\n          >\n            <div class=\"text-center bold\">\n              <button\n                type=\"button\"\n                cdsButton=\"secondary\"\n                class=\"btn-width\"\n                (click)=\"navigateToMaps()\"\n              >\n                {{errorCopy?.buttonCopy?.findABranch}}\n              </button>\n            </div>\n          </cds-column>\n          <cds-column\n            role=\"gridcell\"\n            sm=\"12\"\n            lg=\"4\"\n            class=\"btn\"\n            aria-labelledby=\"grid-heading\"\n          >\n            <div class=\"text-center bold\">\n              <button\n                type=\"button\"\n                cdsButton=\"secondary\"\n                class=\"btn-width\"\n                (click)=\"toggleSearchPanel()\"\n              >\n                {{errorCopy?.buttonCopy?.howCanWeHelp}}\n              </button>\n            </div>\n          </cds-column>\n        </cds-row>\n      </div>\n    </cds-column>\n    <cds-column\n      [sm]=\"12\"\n      [lg]=\"4\"\n      class=\"second-column\"\n    >\n      <cds-icon\n        idStr=\"error-comp-icon\"\n        ariaLabel=\"error_icon\"\n        altText=\"error_icon\"\n        type=\"2021\"\n        name=\"254-search-risk-control\"\n        [svgStyle]=\"innerWidth > 991 ? iconSizeDesktop : iconSizeMobile\"\n      ></cds-icon>\n    </cds-column>\n  </div>\n  <!-- Loading State -->\n  <cds-jamp\n    [visible]=\"pageLevelJamp\"\n    waitMessage=\"Hang On\"\n    [useGif]=\"pageLevelJamp\"\n    [pagelevel]=\"pageLevelJamp\"\n  ></cds-jamp>\n</citi-simple-layout>", styles: [".container{display:flex;flex-direction:row;margin-top:120px;width:fit-content}.container .heading{font-family:Interstate_Regular,sans-serif;font-size:36px}.container .cbolui-cds .cds-column{padding:0}.container .second-column{display:flex;align-items:center;justify-content:space-around;padding-left:5%}.container .btn-width{width:100%;overflow:hidden;white-space:nowrap}.container .cds-column.col-sm-12{padding-left:0}.container #error-comp-icon{width:210px;margin:3rem;height:170px}.container .text-para{font-size:18px;margin-bottom:40px;margin-top:16px;font-family:Interstate_Light,sans-serif}.container .btn{padding-right:40px;padding-left:0}@media screen and (max-width: 991px){.container{padding:0rem;flex-direction:column-reverse;margin:0%}.container .cds-column.col-sm-12{padding-left:12px}.container .heading{font-size:26px;font-weight:400}.container .btn{padding:0!important}.container .btn-width{margin-bottom:24px}.second-column{display:flex;justify-content:center;align-items:center;padding:40px 0}#error-comp-icon{height:100px;width:75px}.text-para{font-size:16px}}@media screen and (max-width: 436px){.heading{word-break:keep-all;text-align:center}}@media (min-width: 992px) and (max-width: 1485px){.btn{display:flex;flex-direction:column;max-width:100%;flex:100%;margin-bottom:2%}}@media (min-width: 1486px){.btn{max-width:33.33333333%}}.icon-center{display:flex;justify-content:center;align-items:center;--cds-icon-path-fill: #000;margin-top:20px;margin-bottom:40px}.centered-text{text-align:center}.bao-header{margin-bottom:2%}.container-BAO{display:flex;flex-direction:row;margin-top:50px!important;margin-left:10%;margin-right:10%;width:fit-content}.container-BAO ::ng-deep a{text-decoration:underline}\n"] }]
        }], ctorParameters: () => [{ type: i3.CDSService }, { type: i3.LayoutsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1.StorageService }, { type: i1.AppConfigService }, { type: i4$2.Meta }, { type: i1.TaggingService }, { type: i4.ActivatedRoute }, { type: i4.Router }, { type: i2.HttpService }] });

/*
 * Public API Surface of cbol-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BasketjsService, CbolCoreComponent, CbolCoreConfig, CbolCoreConfigService, CbolCoreContent, CbolCoreContentService, CbolCoreModule, CbolSessionComponent, CbolSessionService, CedricService, ChatConfig, CitiSessionHandlerComponent, ContentComponent, ContentModule, CustomPreloaderService, ErrorPageComponent, ModalOrchestratorService, MrcdashboardRouteGuard, NonFatalErrorComponent, NonFatalErrorRedirectService, NonFatalErrorService, OneStepComponent, OneStepModule, PageNotFoundComponent, PreloginInactivityService, ROOT_EFFECTS, RoutingDetectorConfig, SessionTimeoutModal, SessionTimeoutModalModule, Tour2Component, Tour2Module, TourComponent, TourModule, TourService, WhatsNewModalComponent, WhatsNewModalModule, createSourceInstances };
